/**
 * A function to create a log object for the 'dummyEvent' event (evid: 1604)
 *
 * Event description: log a BI event, every time we detect a TPE instance
 *
 * @param {dummyEventParams} params - The parameters for this event
 * @property {string} instanceId - instance id of the TPE
 * @property {number} response_code - response_code
 * @property {string} originUrl - origin URL of the request
 * @property {string} httpMethod - http_method
 * @property {string} user_agent - user_agent
 * @property {string} appDefId - app def id of the TPE
 * @property {string} authType - oauth or api_key
 * @property {string} http_method - http_method
 * @property {number} httpResponseCode - response_code
 * @return {LogObject<dummyEventParams>} LogObject<dummyEventParams>
 */
export function dummyEvent(params) {
    return { evid: 1604, src: 11, endpoint: '', params };
}
/**
 * A function to create a log object for the 'isPermittedUser' event (evid: 1)
 *
 * Event description: isPermitted [USER].
 *
 * @param {isPermittedUserParams} params - The parameters for this event
 * @property {boolean} svSession - sv_session_cookie
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} metasiteId - msid
 * @property {string} permission - permission_request
 * @property {boolean} published - published
 * @property {string} apiName - api_name
 * @property {GUID} accountId - account_id
 * @property {boolean} smSession - sm_session_cookie
 * @property {string} appDefId - app_def_id
 * @property {boolean} isPermitted - is_permitted
 * @property {boolean} wixSession2 - wix_session_2_cookie
 * @property {boolean} isLogInAccountOwner - is_login_account_owner
 * @property {string} callingArtifact - calling_artifact
 * @property {boolean} authorization_header - authorization_header
 * @property {boolean} hasUserRole - has_user_role
 * @property {boolean} isWixStaff - is_wix_staff
 * @property {string} signedByArtifact - Artifact
 * @property {string} signed_by_transaction - signed_by_transaction
 * @property {string} calling_transaction - calling_transaction
 * @property {string} reason - reason
 * @property {string} signed_by_flow - signed_by_flow
 * @property {string} calling_flow - calling_flow
 * @return {LogObject<isPermittedUserParams>} LogObject<isPermittedUserParams>
 */
export function isPermittedUser(params) {
    return { evid: 1, src: 167, endpoint: '', params };
}
/**
 * A function to create a log object for the 'isPermittedSitemember' event (evid: 2)
 *
 * Event description: isPermitted [SITEMEMBER].
 *
 * @param {isPermittedSitememberParams} params - The parameters for this event
 * @property {boolean} svSession - sv_session_cookie
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} metasiteId - msid
 * @property {string} permission - permission_request
 * @property {boolean} published - published
 * @property {string} apiName - api_name
 * @property {GUID} accountId - account_id
 * @property {boolean} smSession - sm_session_cookie
 * @property {string} appDefId - app_def_id
 * @property {boolean} isPermitted - is_permitted
 * @property {boolean} wixSession2 - wix_session_2_cookie
 * @property {boolean} isLogInAccountOwner - is_login_account_owner
 * @property {string} callingArtifact - calling_artifact
 * @property {boolean} authorization_header - authorization_header
 * @property {boolean} hasUserRole - has_user_role
 * @property {boolean} isWixStaff - is_wix_staff
 * @property {string} signedByArtifact - Artifact
 * @property {string} signed_by_transaction - signed_by_transaction
 * @property {string} calling_transaction - calling_transaction
 * @property {string} reason - reason
 * @property {string} signed_by_flow - signed_by_flow
 * @property {string} calling_flow - calling_flow
 * @return {LogObject<isPermittedSitememberParams>} LogObject<isPermittedSitememberParams>
 */
export function isPermittedSitemember(params) {
    return { evid: 2, src: 167, endpoint: '', params };
}
/**
 * A function to create a log object for the 'isPermittedService' event (evid: 3)
 *
 * Event description: isPermitted [SERVICE].
 *
 * @param {isPermittedServiceParams} params - The parameters for this event
 * @property {boolean} svSession - sv_session_cookie
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} metasiteId - msid
 * @property {string} permission - permission_request
 * @property {boolean} published - published
 * @property {string} apiName - api_name
 * @property {GUID} accountId - account_id
 * @property {boolean} smSession - sm_session_cookie
 * @property {string} appDefId - app_def_id
 * @property {boolean} isPermitted - is_permitted
 * @property {boolean} wixSession2 - wix_session_2_cookie
 * @property {boolean} isLogInAccountOwner - is_login_account_owner
 * @property {string} callingArtifact - calling_artifact
 * @property {boolean} authorization_header - authorization_header
 * @property {boolean} hasUserRole - has_user_role
 * @property {boolean} isWixStaff - is_wix_staff
 * @property {string} signedByArtifact - artifact
 * @property {string} signed_by_transaction - signed_by_transaction
 * @property {string} calling_transaction - calling_transaction
 * @property {string} reason - reason
 * @property {string} signed_by_flow - signed_by_flow
 * @property {string} calling_flow - calling_flow
 * @return {LogObject<isPermittedServiceParams>} LogObject<isPermittedServiceParams>
 */
export function isPermittedService(params) {
    return { evid: 3, src: 167, endpoint: '', params };
}
/**
 * A function to create a log object for the 'isPermittedVisitor' event (evid: 4)
 *
 * Event description: isPermitted [VISITOR].
 *
 * @param {isPermittedVisitorParams} params - The parameters for this event
 * @property {boolean} svSession - sv_session_cookie
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} metasiteId - msid
 * @property {string} permission - permission_request
 * @property {boolean} published - published
 * @property {string} apiName - api_name
 * @property {GUID} accountId - account_id
 * @property {boolean} smSession - sm_session_cookie
 * @property {string} appDefId - app_def_id
 * @property {boolean} isPermitted - is_permitted
 * @property {boolean} wixSession2 - wix_session_2_cookie
 * @property {boolean} isLogInAccountOwner - is_login_account_owner
 * @property {string} callingArtifact - calling_artifact
 * @property {boolean} authorization_header - authorization_header
 * @property {boolean} hasUserRole - has_user_role
 * @property {boolean} isWixStaff - is_wix_staff
 * @property {string} signedByArtifact - artifact
 * @property {string} calling_transaction - calling_transaction
 * @property {string} signed_by_transaction - signed_by_transaction
 * @property {string} reason - reason
 * @property {string} signed_by_flow - signed_by_flow
 * @property {string} calling_flow - calling_flow
 * @return {LogObject<isPermittedVisitorParams>} LogObject<isPermittedVisitorParams>
 */
export function isPermittedVisitor(params) {
    return { evid: 4, src: 167, endpoint: '', params };
}
/**
 * A function to create a log object for the 'isPermittedExternalapp' event (evid: 5)
 *
 * Event description: Authorization response for isPremitted for external apps
 *
 * @param {isPermittedExternalappParams} params - The parameters for this event
 * @property {boolean} svSession - sv_session_cookie
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} metasiteId - msid
 * @property {string} permission - permission_request
 * @property {boolean} published - published
 * @property {string} apiName - api_name
 * @property {GUID} accountId - account_id
 * @property {boolean} smSession - sm_session_cookie
 * @property {string} appDefId - app_def_id
 * @property {boolean} isPermitted - is_permitted
 * @property {boolean} wixSession2 - wix_session_2_cookie
 * @property {boolean} isLogInAccountOwner - is_login_account_owner
 * @property {string} callingArtifact - calling_artifact
 * @property {boolean} authorization_header - authorization_header
 * @property {boolean} hasUserRole - has_user_role
 * @property {boolean} isWixStaff - is_wix_staff
 * @property {string} signedByArtifact - artifact
 * @property {string} signed_by_transaction - signed_by_transaction
 * @property {string} calling_transaction - calling_transaction
 * @property {string} reason - reason
 * @property {string} signed_by_flow - signed_by_flow
 * @property {string} calling_flow - calling_flow
 * @return {LogObject<isPermittedExternalappParams>} LogObject<isPermittedExternalappParams>
 */
export function isPermittedExternalapp(params) {
    return { evid: 5, src: 167, endpoint: '', params };
}
/**
 * A function to create a log object for the 'socialLoginPersonalInfo' event (evid: 1004)
 *
 * Event description: User personal info based on his login/signup data through social media
 *
 * @param {socialLoginPersonalInfoParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} providerId - name of social media channel
 * @property {number} ageRangeMin - user min age at the time of the event
 * @property {DateTime} updatedTime - time of data update based on the social media channel
 * @property {number} ageRangemax - user max age at the time of the event
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @property {string} gender - user gender
 * @return {LogObject<socialLoginPersonalInfoParams>} LogObject<socialLoginPersonalInfoParams>
 */
export function socialLoginPersonalInfo(params) {
    return { evid: 1004, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'createAppUser' event (evid: 1006)
 *
 * Event description: Creating User based on 3rd party App userId for internal use
 *
 * @param {createAppUserParams} params - The parameters for this event
 * @property {GUID} uuid - User Guid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} externalAppUserId - externalAppUserId that associate with the user
 * @property {string} recaptcha - recaptcha
 * @property {string} appId - AppId that associate with the user
 * @property {Url} app_url - app_url
 * @property {string} userType - UserType for each business flow. Ex. Billing
 * @return {LogObject<createAppUserParams>} LogObject<createAppUserParams>
 */
export function createAppUser(params) {
    return { evid: 1006, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oldLoginEvent' event (evid: 1007)
 *
 * Event description: old login event.
 *
 * @param {oldLoginEventParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<oldLoginEventParams>} LogObject<oldLoginEventParams>
 */
export function oldLoginEvent(params) {
    return { evid: 1007, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'recaptchaRequiredPerApiContext' event (evid: 1008)
 *
 * Event description: require captcha events for auth status end-point
 *
 * @param {recaptchaRequiredPerApiContextParams} params - The parameters for this event
 * @property {string} context - API context
 * @property {GUID} uuid - optional existing user id cookie
 * @property {string} reason - the reason why the captcha is required
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<recaptchaRequiredPerApiContextParams>} LogObject<recaptchaRequiredPerApiContextParams>
 */
export function recaptchaRequiredPerApiContext(params) {
    return { evid: 1008, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'transferSiteForLoginAnonUser' event (evid: 1009)
 *
 * Event description: Change site ownership after anon user is logged in to  existing account
 *
 * @param {transferSiteForLoginAnonUserParams} params - The parameters for this event
 * @property {GUID} target_user_uuid - target user guid
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {GUID} anon_uuid - anon user guid
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @property {GUID} msid - metaSiteID ownership changed
 * @return {LogObject<transferSiteForLoginAnonUserParams>} LogObject<transferSiteForLoginAnonUserParams>
 */
export function transferSiteForLoginAnonUser(params) {
    return { evid: 1009, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'recaptchaFailedPerApi' event (evid: 1010)
 *
 * Event description: failed captcha events for auth status end-point
 *
 * @param {recaptchaFailedPerApiParams} params - The parameters for this event
 * @property {string} context - API context
 * @property {GUID} uuid - optional existing user id cookie
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<recaptchaFailedPerApiParams>} LogObject<recaptchaFailedPerApiParams>
 */
export function recaptchaFailedPerApi(params) {
    return { evid: 1010, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'anonUserRegistered' event (evid: 1011)
 *
 * Event description: Anonymous user registration
 *
 * @param {anonUserRegisteredParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<anonUserRegisteredParams>} LogObject<anonUserRegisteredParams>
 */
export function anonUserRegistered(params) {
    return { evid: 1011, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'recaptchaValidatedPerApiContext' event (evid: 1012)
 *
 * Event description: validated captcha events for auth status end-point
 *
 * @param {recaptchaValidatedPerApiContextParams} params - The parameters for this event
 * @property {string} context - API context
 * @property {GUID} uuid - optional existing user id cookie
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<recaptchaValidatedPerApiContextParams>} LogObject<recaptchaValidatedPerApiContextParams>
 */
export function recaptchaValidatedPerApiContext(params) {
    return { evid: 1012, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'usersDebugEvent' event (evid: 1013)
 *
 * Event description: Email Verification Notification - Status
 *
 * @param {usersDebugEventParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} message - "Produce to kafka" / "Consume from kafka" / "Ping"
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<usersDebugEventParams>} LogObject<usersDebugEventParams>
 */
export function usersDebugEvent(params) {
    return { evid: 1013, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickContinueOnNewLoginPage' event (evid: 1014)
 *
 * Event description: indication on 'continue' click in login redesign
 *
 * @param {clickContinueOnNewLoginPageParams} params - The parameters for this event
 * @property {string} context - login/sign up (in the future might be used for verticals)
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {boolean} status - Returns true if the user was found else false.
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<clickContinueOnNewLoginPageParams>} LogObject<clickContinueOnNewLoginPageParams>
 */
export function clickContinueOnNewLoginPage(params) {
    return { evid: 1014, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'twoFactorAuthenticationSetupEnableSuccess' event (evid: 1015)
 *
 * Event description: When a user successfully enables 2-factor authentication
 *
 * @param {twoFactorAuthenticationSetupEnableSuccessParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} origin - From which flow the enabling happend ("Account settings"\"Post login"))
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<twoFactorAuthenticationSetupEnableSuccessParams>} LogObject<twoFactorAuthenticationSetupEnableSuccessParams>
 */
export function twoFactorAuthenticationSetupEnableSuccess(params) {
    return { evid: 1015, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'twoFactorAuthenticationSetupDisableSuccess' event (evid: 1016)
 *
 * Event description: When a user successfully disables 2-factor authentication
 *
 * @param {twoFactorAuthenticationSetupDisableSuccessParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} initiator_type - user/support (in case support reset 2FA for a user)
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<twoFactorAuthenticationSetupDisableSuccessParams>} LogObject<twoFactorAuthenticationSetupDisableSuccessParams>
 */
export function twoFactorAuthenticationSetupDisableSuccess(params) {
    return { evid: 1016, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'twoFactorAuthenticationSetupEditNumberSuccess' event (evid: 1017)
 *
 * Event description: When a user successfully updates the phone number he's using for 2-factor authentication
 *
 * @param {twoFactorAuthenticationSetupEditNumberSuccessParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<twoFactorAuthenticationSetupEditNumberSuccessParams>} LogObject<twoFactorAuthenticationSetupEditNumberSuccessParams>
 */
export function twoFactorAuthenticationSetupEditNumberSuccess(params) {
    return { evid: 1017, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationVerifyCodeSuccess' event (evid: 1018)
 *
 * Event description: When a user login succeeds, after he enters a correct code sent to his phone in 2-factor authentication login
 *
 * @param {loginTwoFactorAuthenticationVerifyCodeSuccessParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {string} flow_type - email/phone
 * @property {Url} app_url - app_url
 * @property {GUID} correlationId - correlation_id
 * @property {GUID} notificationId - notification_id
 * @property {string} verificationId - verification_id
 * @return {LogObject<loginTwoFactorAuthenticationVerifyCodeSuccessParams>} LogObject<loginTwoFactorAuthenticationVerifyCodeSuccessParams>
 */
export function loginTwoFactorAuthenticationVerifyCodeSuccess(params) {
    return { evid: 1018, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'twoFactorAuthenticationVerifyCodeFail' event (evid: 1019)
 *
 * Event description: When a user login fails after entering a wrong code in 2-factor authentication login
 *
 * @param {twoFactorAuthenticationVerifyCodeFailParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {string} flow_type - email/phone
 * @property {Url} app_url - app_url
 * @return {LogObject<twoFactorAuthenticationVerifyCodeFailParams>} LogObject<twoFactorAuthenticationVerifyCodeFailParams>
 */
export function twoFactorAuthenticationVerifyCodeFail(params) {
    return { evid: 1019, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'captchaTriggeredDueToDifferentGeo' event (evid: 1020)
 *
 * Event description: When we trigger captcha because the user logged in from a different GEO than he used to
 *
 * @param {captchaTriggeredDueToDifferentGeoParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} lastCountryCode - Previous country_code
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @property {string} lastRegion - Last region
 * @return {LogObject<captchaTriggeredDueToDifferentGeoParams>} LogObject<captchaTriggeredDueToDifferentGeoParams>
 */
export function captchaTriggeredDueToDifferentGeo(params) {
    return { evid: 1020, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountRecoveryWithPhoneNumberVerifyCodeSuccess' event (evid: 1021)
 *
 * Event description: The user chose the option to recover the account by phone number, and the code sent to his phone was successfully verified
 *
 * @param {accountRecoveryWithPhoneNumberVerifyCodeSuccessParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<accountRecoveryWithPhoneNumberVerifyCodeSuccessParams>} LogObject<accountRecoveryWithPhoneNumberVerifyCodeSuccessParams>
 */
export function accountRecoveryWithPhoneNumberVerifyCodeSuccess(params) {
    return { evid: 1021, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountRecoveryWithPhoneNumberVerifyCodeFailed' event (evid: 1022)
 *
 * Event description: The user chose the option to recover the account by phone number, and the verification of the code sent to his phone failed
 *
 * @param {accountRecoveryWithPhoneNumberVerifyCodeFailedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<accountRecoveryWithPhoneNumberVerifyCodeFailedParams>} LogObject<accountRecoveryWithPhoneNumberVerifyCodeFailedParams>
 */
export function accountRecoveryWithPhoneNumberVerifyCodeFailed(params) {
    return { evid: 1022, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLogoutFromAllBrowsersDevices' event (evid: 1023)
 *
 * Event description: a special log out from all devices, valid for WIX academy users only
 *
 * @param {userLogoutFromAllBrowsersDevicesParams} params - The parameters for this event
 * @property {GUID} uuid - user id
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<userLogoutFromAllBrowsersDevicesParams>} LogObject<userLogoutFromAllBrowsersDevicesParams>
 */
export function userLogoutFromAllBrowsersDevices(params) {
    return { evid: 1023, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLoginCallPxEnforcer' event (evid: 1024)
 *
 * Event description: User login - call PX Enforcer
 *
 * @param {userLoginCallPxEnforcerParams} params - The parameters for this event
 * @property {GUID} uuid - user id
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<userLoginCallPxEnforcerParams>} LogObject<userLoginCallPxEnforcerParams>
 */
export function userLoginCallPxEnforcer(params) {
    return { evid: 1024, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'signUpPasswordStrengthIndicatorSrc18Evid1025' event (evid: 1025)
 *
 * Event description: this event contains the indicators of each password saved during a sign up
 *
 * @param {signUpPasswordStrengthIndicatorSrc18Evid1025Params} params - The parameters for this event
 * @property {GUID} uuid - user id
 * @property {string} page - a string that indicates on what page the user types the password ("Signup"\"Account settings")
 * @property {boolean} containsUpper - indicates if the password contains uppercase bool
 * @property {string} strength - Numeric score
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} origin - From which flow the event happened ("Account settings"\"Post login"))
 * @property {number} length - password length
 * @property {string} recaptcha - recaptcha
 * @property {boolean} containsNumber - indicates if the password contains numbers
 * @property {Url} app_url - app_url
 * @property {boolean} containsSpecial - indicates if the password contains special key bool
 * @property {boolean} containsLower - indicates if the password contains lowercase bool
 * @return {LogObject<signUpPasswordStrengthIndicatorSrc18Evid1025Params>} LogObject<signUpPasswordStrengthIndicatorSrc18Evid1025Params>
 */
export function signUpPasswordStrengthIndicatorSrc18Evid1025(params) {
    return { evid: 1025, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'email2FaSetupEnableSuccess' event (evid: 1026)
 *
 * Event description: When a user successfully enables email 2-factor authentication
 *
 * @param {email2FaSetupEnableSuccessParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<email2FaSetupEnableSuccessParams>} LogObject<email2FaSetupEnableSuccessParams>
 */
export function email2FaSetupEnableSuccess(params) {
    return { evid: 1026, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'email2FaSetupDisableSuccess' event (evid: 1027)
 *
 * Event description: When a user successfully disables email 2-factor authentication
 *
 * @param {email2FaSetupDisableSuccessParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} initiator_type - user/support (in case support reset 2FA for a user)
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<email2FaSetupDisableSuccessParams>} LogObject<email2FaSetupDisableSuccessParams>
 */
export function email2FaSetupDisableSuccess(params) {
    return { evid: 1027, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ssoSetupEnableSuccess' event (evid: 1028)
 *
 * Event description: When a user successfully enables SSO from SSO settings
 *
 * @param {ssoSetupEnableSuccessParams} params - The parameters for this event
 * @property {GUID} sso_id - sso_id
 * @property {boolean} is_mandatory - is SSO mandatory for team member login/client, true/false
 * @property {string} sso_user_type - DIFM/DIY
 * @return {LogObject<ssoSetupEnableSuccessParams>} LogObject<ssoSetupEnableSuccessParams>
 */
export function ssoSetupEnableSuccess(params) {
    return { evid: 1028, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ssoSetupDisableSuccess' event (evid: 1029)
 *
 * Event description: When a user disabled SSO from SSO settings
 *
 * @param {ssoSetupDisableSuccessParams} params - The parameters for this event
 * @property {GUID} sso_id - sso_id
 * @property {string} sso_user_type - sso_user_type
 * @return {LogObject<ssoSetupDisableSuccessParams>} LogObject<ssoSetupDisableSuccessParams>
 */
export function ssoSetupDisableSuccess(params) {
    return { evid: 1029, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'app2FaSetupEnableSuccess' event (evid: 1030)
 *
 * Event description: When a user successfully enables app 2-factor authentication
 *
 * @param {app2FaSetupEnableSuccessParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<app2FaSetupEnableSuccessParams>} LogObject<app2FaSetupEnableSuccessParams>
 */
export function app2FaSetupEnableSuccess(params) {
    return { evid: 1030, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'app2FaSetupDisableSuccess' event (evid: 1031)
 *
 * Event description: When a user successfully disables app 2-factor authentication. Action: change/disable (what was the action that caused the app to be disabled - changing to another one, or simply disabling)
 *
 * @param {app2FaSetupDisableSuccessParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @property {string} action - change/disable
 * @return {LogObject<app2FaSetupDisableSuccessParams>} LogObject<app2FaSetupDisableSuccessParams>
 */
export function app2FaSetupDisableSuccess(params) {
    return { evid: 1031, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSignupFromUkraineRegions9And14' event (evid: 1032)
 *
 * Event description: The user signed up/logged in from regions 9/14 in Ukraine (Donetsk/Luhansk) and was either blocked (logged in from a city in the blacklist) or not
 *
 * @param {loginSignupFromUkraineRegions9And14Params} params - The parameters for this event
 * @property {string} user_region - The explicit region we retrieve from the user's IP
 * @property {GUID} uuid - uuid
 * @property {boolean} was_blocked - was the user blocked or not
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} user_city - The explicit city we retrieve from the user's IP
 * @property {string} type - Login/Signup
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<loginSignupFromUkraineRegions9And14Params>} LogObject<loginSignupFromUkraineRegions9And14Params>
 */
export function loginSignupFromUkraineRegions9And14(params) {
    return { evid: 1032, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountSettingsEmailAddressChanged' event (evid: 1033)
 *
 * Event description: The user's email address was successfully changed (by user action)
 *
 * @param {accountSettingsEmailAddressChangedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<accountSettingsEmailAddressChangedParams>} LogObject<accountSettingsEmailAddressChangedParams>
 */
export function accountSettingsEmailAddressChanged(params) {
    return { evid: 1033, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountSettingsEmailAddressChangeFailed' event (evid: 1034)
 *
 * Event description: The user's email address was not successfully changed (by user action)
 *
 * @param {accountSettingsEmailAddressChangeFailedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} origin - From which flow the event happened ("Account settings"\"Post login"))
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @property {string} error_code - error code
 * @return {LogObject<accountSettingsEmailAddressChangeFailedParams>} LogObject<accountSettingsEmailAddressChangeFailedParams>
 */
export function accountSettingsEmailAddressChangeFailed(params) {
    return { evid: 1034, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationModalViewSrc18Evid1035' event (evid: 1035)
 *
 * Event description: Modal view of  2-factor authentication login owa
 *
 * @param {loginTwoFactorAuthenticationModalViewSrc18Evid1035Params} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {string} flow_type - email/phone
 * @property {Url} app_url - app_url
 * @property {GUID} correlation_id - correlation id (for each notify)
 * @return {LogObject<loginTwoFactorAuthenticationModalViewSrc18Evid1035Params>} LogObject<loginTwoFactorAuthenticationModalViewSrc18Evid1035Params>
 */
export function loginTwoFactorAuthenticationModalViewSrc18Evid1035(params) {
    return { evid: 1035, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addRemoveBetaExperts' event (evid: 117)
 *
 * Event description: add/remove beta experts.
 *
 * @param {addRemoveBetaExpertsParams} params - The parameters for this event
 * @property {GUID} userGuid - uuid
 * @property {string} group - group_name
 * @property {string} action - on / off
 * @return {LogObject<addRemoveBetaExpertsParams>} LogObject<addRemoveBetaExpertsParams>
 */
export function addRemoveBetaExperts(params) {
    return { evid: 117, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gdprStartHarvesting' event (evid: 118)
 *
 * Event description: Agent clicks on start Harvesting in the Get User Archive
 *
 * @param {gdprStartHarvestingParams} params - The parameters for this event
 * @property {string} user - the uuid of the user that requested the data
 * @return {LogObject<gdprStartHarvestingParams>} LogObject<gdprStartHarvestingParams>
 */
export function gdprStartHarvesting(params) {
    return { evid: 118, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gdprBlockUser' event (evid: 119)
 *
 * Event description: Agent clicks on block user in the GDPR block tab
 *
 * @param {gdprBlockUserParams} params - The parameters for this event
 * @property {string} user - the uuid of the user that requested the data
 * @return {LogObject<gdprBlockUserParams>} LogObject<gdprBlockUserParams>
 */
export function gdprBlockUser(params) {
    return { evid: 119, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'emailDoesNotExist' event (evid: 1199)
 *
 * Event description: Indicates that this email does not exist in Wix. This error should be thrown from the server side (so no one can see it in the client)
 *
 * @param {emailDoesNotExistParams} params - The parameters for this event
 * @property {string} email - Rejected email
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} origin - Where did the user come from
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<emailDoesNotExistParams>} LogObject<emailDoesNotExistParams>
 */
export function emailDoesNotExist(params) {
    return { evid: 1199, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gdprUnblockUser' event (evid: 120)
 *
 * Event description: Agent clicks on unblock user in the GDPR block tab
 *
 * @param {gdprUnblockUserParams} params - The parameters for this event
 * @property {string} user - the uuid of the user that requested the data
 * @return {LogObject<gdprUnblockUserParams>} LogObject<gdprUnblockUserParams>
 */
export function gdprUnblockUser(params) {
    return { evid: 120, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLogin' event (evid: 1200)
 *
 * Event description: user login success.
 *
 * @param {userLoginParams} params - The parameters for this event
 * @property {DateTime} date - date_created
 * @property {string} is_magiclink - is the user logged in using magic link
 * @property {string} ip - ip
 * @property {GUID} uuid - uuid
 * @property {string} color - color
 * @property {string} inviteToken - team management invite token guid, else null
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} user_agent - user_agent
 * @property {boolean} is_accesslink - is the user logged in using access link
 * @property {string} originView - origin_view
 * @property {string} providerId - provider_id
 * @property {Url} origin - origin
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @property {string} userType - ["SiteBuilding","OneApp"]
 * @property {string} wixLanguage - the resolved Wix language
 * @return {LogObject<userLoginParams>} LogObject<userLoginParams>
 */
export function userLogin(params) {
    return { evid: 1200, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLoginFailed' event (evid: 1201)
 *
 * Event description: user login failed.
 *
 * @param {userLoginFailedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} color - color
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} originView - the view mode (mobile/pc..)
 * @property {string} providerId - provider_id
 * @property {number} errorCode - reason for error
 * @property {Url} origin - urlThatUserRedirectedFrom
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @property {string} userType - ["SiteBuilding","OneApp"]
 * @return {LogObject<userLoginFailedParams>} LogObject<userLoginFailedParams>
 */
export function userLoginFailed(params) {
    return { evid: 1201, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'forgotPassword' event (evid: 1202)
 *
 * Event description: reset password email sent
 *
 * @param {forgotPasswordParams} params - The parameters for this event
 * @property {string} orgDocID - org doc id
 * @property {string} email - email
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {number} errorCode - error code
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @property {string} mailprovider - provider_id
 * @return {LogObject<forgotPasswordParams>} LogObject<forgotPasswordParams>
 */
export function forgotPassword(params) {
    return { evid: 1202, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'forgotPasswordFailed' event (evid: 1203)
 *
 * Event description: forgot password failed.
 *
 * @param {forgotPasswordFailedParams} params - The parameters for this event
 * @property {string} email - email
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<forgotPasswordFailedParams>} LogObject<forgotPasswordFailedParams>
 */
export function forgotPasswordFailed(params) {
    return { evid: 1203, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userSignupSuccess' event (evid: 1204)
 *
 * Event description: user registration signup sign-up
 *
 * @param {userSignupSuccessParams} params - The parameters for this event
 * @property {DateTime} date - date_created
 * @property {string} latest_campaign_id - campaign_id_latest
 * @property {string} first_campaign_id - campaign_id
 * @property {string} ad_position - ad_position
 * @property {string} referralInfo - indicates where the user was referred from
 * @property {string} ip - ip
 * @property {string} profile_local - profile_local
 * @property {string} ad_domain_latest - ad_domain_latest
 * @property {string} ad_keywords_latest - ad_keywords_latest
 * @property {string} googlead_domain - googlead_domain
 * @property {GUID} uuid - uuid
 * @property {string} ad_group_latest - ad_group_latest
 * @property {string} ad_group - ad_group
 * @property {string} segment_latest - segment_latest
 * @property {string} existing_account_ids - existing account ids for the same email
 * @property {string} ad_match_type - ad_match_type
 * @property {DateTime} latest_time_cookie_set - time_cookie_set_latest
 * @property {string} subsub - subsub
 * @property {string} subsegment_latest - subsegment_latest
 * @property {string} googlead_domain_latest - googlead_domain_latest
 * @property {string} color - color
 * @property {string} segment - segment
 * @property {string} inviteToken - team management invite token guid, else null
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} user_agent - user_agent
 * @property {string} first_experiment_id - experiment_id
 * @property {number} latest_landing_page - landing_page_latest
 * @property {string} ad_domain - ad_domain
 * @property {string} subsegment - subsegment
 * @property {string} originView - origin_view
 * @property {string} emailProvider - email domain (for example - 'google.com'
 * @property {string} providerId - provider_id
 * @property {string} profile - profile
 * @property {string} googlead_referral_latest - googlead_referral_latest
 * @property {Url} origin - origin
 * @property {number} first_landing_page - landing_page
 * @property {string} first_referrer - referrer
 * @property {string} ad_keywords - ad_keywords
 * @property {string} latest_referrer - referrer_latest
 * @property {string} ad_id - ad_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} ad_match_type_latest - ad_match_type_latest
 * @property {string} ad_id_latest - ad_id_latest
 * @property {string} subsub_latest - subsub_latest
 * @property {string} latest_experiment_id - experiment_id_latest
 * @property {string} recaptcha - recaptcha
 * @property {string} googlead_referral - googlead_referral
 * @property {Url} app_url - app_url
 * @property {string} userType - ["SiteBuilding","OneApp"]
 * @property {string} wixLanguage - the resolved Wix language
 * @property {DateTime} first_time_cookie_set - time_cookie_set
 * @property {string} ad_position_latest - ad_position_latest
 * @property {string} existing_user_ids - existing user ids for the same email
 * @return {LogObject<userSignupSuccessParams>} LogObject<userSignupSuccessParams>
 */
export function userSignupSuccess(params) {
    return { evid: 1204, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userSignupFailed' event (evid: 1205)
 *
 * Event description: user signup failed.
 *
 * @param {userSignupFailedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} color - color
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} originView - the view mode (mobile/pc..)
 * @property {string} providerId - provider_id
 * @property {Url} origin - urlThatUserRedirectedFrom
 * @property {GUID} ldSessionID - a unique guid for signup flow
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @property {string} userType - ["SiteBuilding","OneApp"]
 * @property {number} errorCode - reason of error
 * @property {string} error_reason - reason of error
 * @return {LogObject<userSignupFailedParams>} LogObject<userSignupFailedParams>
 */
export function userSignupFailed(params) {
    return { evid: 1205, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'openForm' event (evid: 1206)
 *
 * Event description: open form.
 *
 * @param {openFormParams} params - The parameters for this event
 * @property {string} referralInfo - name of the button in the referral page
 * @property {string} context - form context - "Wix"/"EditorX"
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} displayVersion - old/ new
 * @property {Url} origin - origin, calculated by server, not counting on query param
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @property {string} userType - Adding user type to login view (each type that use web get its own entry-point)
 * @property {Url} redirectedFrom - redirectedfrom
 * @return {LogObject<openFormParams>} LogObject<openFormParams>
 */
export function openForm(params) {
    return { evid: 1206, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'updateUserSuccess' event (evid: 1207)
 *
 * Event description: update user success.
 *
 * @param {updateUserSuccessParams} params - The parameters for this event
 * @property {string} orgDocID - org doc id
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {number} errorCode - error code
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<updateUserSuccessParams>} LogObject<updateUserSuccessParams>
 */
export function updateUserSuccess(params) {
    return { evid: 1207, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'updateUserFailed' event (evid: 1208)
 *
 * Event description: update user failed.
 *
 * @param {updateUserFailedParams} params - The parameters for this event
 * @property {string} orgDocID - org doc id
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {number} errorCode - error code
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<updateUserFailedParams>} LogObject<updateUserFailedParams>
 */
export function updateUserFailed(params) {
    return { evid: 1208, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blockUser' event (evid: 1209)
 *
 * Event description: block user.
 *
 * @param {blockUserParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<blockUserParams>} LogObject<blockUserParams>
 */
export function blockUser(params) {
    return { evid: 1209, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gdprDeleteUser' event (evid: 121)
 *
 * Event description: Agent clicks on Delete Immediately in the Delete User tab
 *
 * @param {gdprDeleteUserParams} params - The parameters for this event
 * @property {string} user - the uuid of the user that requested the data
 * @return {LogObject<gdprDeleteUserParams>} LogObject<gdprDeleteUserParams>
 */
export function gdprDeleteUser(params) {
    return { evid: 121, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blockUserFailed' event (evid: 1210)
 *
 * Event description: block user failed.
 *
 * @param {blockUserFailedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<blockUserFailedParams>} LogObject<blockUserFailedParams>
 */
export function blockUserFailed(params) {
    return { evid: 1210, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteUser' event (evid: 1211)
 *
 * Event description: delete user.
 *
 * @param {deleteUserParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<deleteUserParams>} LogObject<deleteUserParams>
 */
export function deleteUser(params) {
    return { evid: 1211, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteUserFailed' event (evid: 1212)
 *
 * Event description: delete user failed.
 *
 * @param {deleteUserFailedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<deleteUserFailedParams>} LogObject<deleteUserFailedParams>
 */
export function deleteUserFailed(params) {
    return { evid: 1212, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getUserDetails' event (evid: 1213)
 *
 * Event description: get user details.
 *
 * @param {getUserDetailsParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<getUserDetailsParams>} LogObject<getUserDetailsParams>
 */
export function getUserDetails(params) {
    return { evid: 1213, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getUserDetailsFailed' event (evid: 1214)
 *
 * Event description: get user details failed.
 *
 * @param {getUserDetailsFailedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<getUserDetailsFailedParams>} LogObject<getUserDetailsFailedParams>
 */
export function getUserDetailsFailed(params) {
    return { evid: 1214, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'setUserVersion' event (evid: 1215)
 *
 * Event description: set user version.
 *
 * @param {setUserVersionParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<setUserVersionParams>} LogObject<setUserVersionParams>
 */
export function setUserVersion(params) {
    return { evid: 1215, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'setUserVersionFailed' event (evid: 1216)
 *
 * Event description: set user version failed.
 *
 * @param {setUserVersionFailedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<setUserVersionFailedParams>} LogObject<setUserVersionFailedParams>
 */
export function setUserVersionFailed(params) {
    return { evid: 1216, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'setUserPermissions' event (evid: 1217)
 *
 * Event description: set user permissions.
 *
 * @param {setUserPermissionsParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<setUserPermissionsParams>} LogObject<setUserPermissionsParams>
 */
export function setUserPermissions(params) {
    return { evid: 1217, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'setUserPermissionsFailed' event (evid: 1218)
 *
 * Event description: set user permissions failed.
 *
 * @param {setUserPermissionsFailedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<setUserPermissionsFailedParams>} LogObject<setUserPermissionsFailedParams>
 */
export function setUserPermissionsFailed(params) {
    return { evid: 1218, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'setUserProperty' event (evid: 1219)
 *
 * Event description: set user property.
 *
 * @param {setUserPropertyParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<setUserPropertyParams>} LogObject<setUserPropertyParams>
 */
export function setUserProperty(params) {
    return { evid: 1219, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'attemptToUseUserManagerFeature' event (evid: 122)
 *
 * Event description: this would be used to track which features in user manager employees are using the most by tracking what they click on.
 *
 * might be better assigned to source 11, but we already have a project integrated in src 18.
 *
 * similar to https://bo.wix.com/bi-catalog-webapp/#/sources/11/events/1352?artifactId=com.wixpress.people-client
 *
 * @param {attemptToUseUserManagerFeatureParams} params - The parameters for this event
 * @property {string} featureName - which feature the employee tried to use
 * @property {Url} pageURL - the full url of the page the user was on
 * @property {GUID} userId - employee wix uuid (implicit field? ideally user email as well)
 * @return {LogObject<attemptToUseUserManagerFeatureParams>} LogObject<attemptToUseUserManagerFeatureParams>
 */
export function attemptToUseUserManagerFeature(params) {
    return { evid: 122, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'setUserPropertyFailed' event (evid: 1220)
 *
 * Event description: set user property failed.
 *
 * @param {setUserPropertyFailedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<setUserPropertyFailedParams>} LogObject<setUserPropertyFailedParams>
 */
export function setUserPropertyFailed(params) {
    return { evid: 1220, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getUserData' event (evid: 1221)
 *
 * Event description: get user data.
 *
 * @param {getUserDataParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<getUserDataParams>} LogObject<getUserDataParams>
 */
export function getUserData(params) {
    return { evid: 1221, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getUserDataFailed' event (evid: 1222)
 *
 * Event description: get user data failed.
 *
 * @param {getUserDataFailedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<getUserDataFailedParams>} LogObject<getUserDataFailedParams>
 */
export function getUserDataFailed(params) {
    return { evid: 1222, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'authenticate' event (evid: 1223)
 *
 * Event description: authenticate.
 *
 * @param {authenticateParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<authenticateParams>} LogObject<authenticateParams>
 */
export function authenticate(params) {
    return { evid: 1223, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'authenticateFailed' event (evid: 1224)
 *
 * Event description: authenticate failed.
 *
 * @param {authenticateFailedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<authenticateFailedParams>} LogObject<authenticateFailedParams>
 */
export function authenticateFailed(params) {
    return { evid: 1224, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changePasswordPage' event (evid: 1225)
 *
 * Event description: change password page.
 *
 * @param {changePasswordPageParams} params - The parameters for this event
 * @property {string} orgDocID - org doc id
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {number} errorCode - error code
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<changePasswordPageParams>} LogObject<changePasswordPageParams>
 */
export function changePasswordPage(params) {
    return { evid: 1225, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changePasswordSuccess' event (evid: 1226)
 *
 * Event description: change password success.
 *
 * @param {changePasswordSuccessParams} params - The parameters for this event
 * @property {string} orgDocID - org doc id
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {number} errorCode - error code
 * @property {string} origin - From which flow the change happend ("Account settings"\"Post login"))
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<changePasswordSuccessParams>} LogObject<changePasswordSuccessParams>
 */
export function changePasswordSuccess(params) {
    return { evid: 1226, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'verifyEmail' event (evid: 1227)
 *
 * Event description: verify email.
 *
 * @param {verifyEmailParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {number} errorCode - code of error. error = 0 means valid message
 * @property {string} origin - The source from which the email was verified ("Email Link"\"Account settings"\"Post Login"
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<verifyEmailParams>} LogObject<verifyEmailParams>
 */
export function verifyEmail(params) {
    return { evid: 1227, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'unsubscribed' event (evid: 1228)
 *
 * Event description: unsubscribed.
 *
 * @param {unsubscribedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<unsubscribedParams>} LogObject<unsubscribedParams>
 */
export function unsubscribed(params) {
    return { evid: 1228, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sendVerificationEmail' event (evid: 1229)
 *
 * Event description: send verification email.
 *
 * @param {sendVerificationEmailParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} origin - From which flow the email was sent ("Account settings"\"Post login"))
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<sendVerificationEmailParams>} LogObject<sendVerificationEmailParams>
 */
export function sendVerificationEmail(params) {
    return { evid: 1229, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'remoteCall' event (evid: 123)
 *
 * Event description: Server initiates a remote call to external Wix API.
 *
 * @param {remoteCallParams} params - The parameters for this event
 * @property {string} method - the method name of the remote service/endpoint
 * @property {string} um_user_type - cs
 * @property {string} params - JSON serialized important non-PII parameters which were passed to the service/endpoint
 * @property {string} service - the name of the remote service/endpoint
 * @property {string} request_id - request_id
 * @property {string} user_name - part of email before @
 * @property {GUID} user - the uuid of the user that invoked the operation
 * @return {LogObject<remoteCallParams>} LogObject<remoteCallParams>
 */
export function remoteCall(params) {
    return { evid: 123, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blockUserFromOfacCountries' event (evid: 1230)
 *
 * Event description: block user from OFAC countries.
 *
 * @param {blockUserFromOfacCountriesParams} params - The parameters for this event
 * @property {string} geo - geo
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} isoCode - iso code
 * @property {string} errorCode - error code
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @property {string} isoCity - iso city
 * @return {LogObject<blockUserFromOfacCountriesParams>} LogObject<blockUserFromOfacCountriesParams>
 */
export function blockUserFromOfacCountries(params) {
    return { evid: 1230, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountSettingsChangePasswordSuccess' event (evid: 1231)
 *
 * Event description: When a user successfully changes the password from account settings
 *
 * @param {accountSettingsChangePasswordSuccessParams} params - The parameters for this event
 * @property {string} orgDocID - org doc id
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {number} errorCode - error code
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<accountSettingsChangePasswordSuccessParams>} LogObject<accountSettingsChangePasswordSuccessParams>
 */
export function accountSettingsChangePasswordSuccess(params) {
    return { evid: 1231, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'iamUserRegisterAttemptSrc18Evid1238' event (evid: 1238)
 *
 * Event description: User Login attempt at IAM platform
 *
 * @param {iamUserRegisterAttemptSrc18Evid1238Params} params - The parameters for this event
 * @property {string} email - attempt email
 * @property {GUID} ldSessionId - a unique guid for register flow
 * @return {LogObject<iamUserRegisterAttemptSrc18Evid1238Params>} LogObject<iamUserRegisterAttemptSrc18Evid1238Params>
 */
export function iamUserRegisterAttemptSrc18Evid1238(params) {
    return { evid: 1238, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'iamUserLoginAttemptSrc18Evid1239' event (evid: 1239)
 *
 * Event description: User Login attempt at IAM platform
 *
 * @param {iamUserLoginAttemptSrc18Evid1239Params} params - The parameters for this event
 * @property {string} email - login attempt email
 * @property {GUID} ldSessionId - a unique guid for login flow
 * @property {Url} app_url - app_url
 * @return {LogObject<iamUserLoginAttemptSrc18Evid1239Params>} LogObject<iamUserLoginAttemptSrc18Evid1239Params>
 */
export function iamUserLoginAttemptSrc18Evid1239(params) {
    return { evid: 1239, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'socialLoginSuccess' event (evid: 1240)
 *
 * Event description: social login > success.
 *
 * @param {socialLoginSuccessParams} params - The parameters for this event
 * @property {boolean} isEmailVerified - Email verification flag from social login provider
 * @property {GUID} uuid - uuid
 * @property {string} color - color
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} providerId - provider_id
 * @property {boolean} withpassword - withpassword
 * @property {GUID} ldSessionID - unique session for login dialog
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @property {string} userType - ["SiteBuilding","OneApp"]
 * @property {string} action - origin
 * @return {LogObject<socialLoginSuccessParams>} LogObject<socialLoginSuccessParams>
 */
export function socialLoginSuccess(params) {
    return { evid: 1240, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'socialLoginFailed' event (evid: 1241)
 *
 * Event description: social login > failed.
 *
 * @param {socialLoginFailedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} providerId - provider_id
 * @property {number} errorCode - errc
 * @property {boolean} withpassword - withpassword
 * @property {GUID} ldSessionID - unique session for login dialog
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @property {string} userType - ["SiteBuilding","OneApp"]
 * @property {string} action - action
 * @return {LogObject<socialLoginFailedParams>} LogObject<socialLoginFailedParams>
 */
export function socialLoginFailed(params) {
    return { evid: 1241, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'socialLoginEmptyPassword' event (evid: 1242)
 *
 * Event description: social login > empty password.
 *
 * @param {socialLoginEmptyPasswordParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} providerId - provider_id
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<socialLoginEmptyPasswordParams>} LogObject<socialLoginEmptyPasswordParams>
 */
export function socialLoginEmptyPassword(params) {
    return { evid: 1242, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'socialLoginReassignConnection' event (evid: 1243)
 *
 * Event description: social login > reassign connection.
 *
 * @param {socialLoginReassignConnectionParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} providerId - provider_id
 * @property {number} errorCode - errc
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<socialLoginReassignConnectionParams>} LogObject<socialLoginReassignConnectionParams>
 */
export function socialLoginReassignConnection(params) {
    return { evid: 1243, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'socialLoginConnectTakeOwnership' event (evid: 1244)
 *
 * Event description: social login > connect take_ownership.
 *
 * @param {socialLoginConnectTakeOwnershipParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} providerId - provider_id
 * @property {boolean} premiumUser - is_premium
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<socialLoginConnectTakeOwnershipParams>} LogObject<socialLoginConnectTakeOwnershipParams>
 */
export function socialLoginConnectTakeOwnership(params) {
    return { evid: 1244, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'socialLoginConnect' event (evid: 1245)
 *
 * Event description: social login > connect.
 *
 * @param {socialLoginConnectParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} google_captcha_reason - google_captcha_reason
 * @property {string} providerId - provider_id
 * @property {number} errorCode - errc
 * @property {number} google_captcha_score - google_captcha_score
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<socialLoginConnectParams>} LogObject<socialLoginConnectParams>
 */
export function socialLoginConnect(params) {
    return { evid: 1245, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'socialLoginDisconnect' event (evid: 1246)
 *
 * Event description: social login > disconnect.
 *
 * @param {socialLoginDisconnectParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} providerId - provider_id
 * @property {number} errorCode - errc
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<socialLoginDisconnectParams>} LogObject<socialLoginDisconnectParams>
 */
export function socialLoginDisconnect(params) {
    return { evid: 1246, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'socialLoginListConnections' event (evid: 1247)
 *
 * Event description: social login > list connections.
 *
 * @param {socialLoginListConnectionsParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<socialLoginListConnectionsParams>} LogObject<socialLoginListConnectionsParams>
 */
export function socialLoginListConnections(params) {
    return { evid: 1247, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changePasswordFailed' event (evid: 1248)
 *
 * Event description: change password failed.
 *
 * @param {changePasswordFailedParams} params - The parameters for this event
 * @property {string} orgDocID - org doc id
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {number} errorCode - errc
 * @property {GUID} orgdocid - orig_doc_id
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<changePasswordFailedParams>} LogObject<changePasswordFailedParams>
 */
export function changePasswordFailed(params) {
    return { evid: 1248, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changePasswordPageFailed' event (evid: 1249)
 *
 * Event description: change password page failed.
 *
 * @param {changePasswordPageFailedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {number} errorCode - errc
 * @property {GUID} orgdocid - orig_doc_id
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<changePasswordPageFailedParams>} LogObject<changePasswordPageFailedParams>
 */
export function changePasswordPageFailed(params) {
    return { evid: 1249, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'copyDomainsToClipboard' event (evid: 125)
 *
 * Event description: this would be used to track "Copy domains to clipboard" feature
 *
 * @param {copyDomainsToClipboardParams} params - The parameters for this event
 * @property {string} um_user_type - cs
 * @property {string} user_name - part of email before @
 * @return {LogObject<copyDomainsToClipboardParams>} LogObject<copyDomainsToClipboardParams>
 */
export function copyDomainsToClipboard(params) {
    return { evid: 125, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'superUserLogin' event (evid: 1250)
 *
 * Event description: super user login.
 *
 * @param {superUserLoginParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<superUserLoginParams>} LogObject<superUserLoginParams>
 */
export function superUserLogin(params) {
    return { evid: 1250, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixOauthFlowStarted' event (evid: 1251)
 *
 * Event description: wix oauth flow started.
 *
 * @param {wixOauthFlowStartedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} flowName - flow
 * @property {string} providerId - provider_id
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<wixOauthFlowStartedParams>} LogObject<wixOauthFlowStartedParams>
 */
export function wixOauthFlowStarted(params) {
    return { evid: 1251, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixOauthFlowDecision' event (evid: 1252)
 *
 * Event description: wix oauth flow decision.
 *
 * @param {wixOauthFlowDecisionParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} decision - decision
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} flowName - flow
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<wixOauthFlowDecisionParams>} LogObject<wixOauthFlowDecisionParams>
 */
export function wixOauthFlowDecision(params) {
    return { evid: 1252, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginRecaptchaRequired' event (evid: 1253)
 *
 * Event description: login > recaptcha required.
 *
 * @param {loginRecaptchaRequiredParams} params - The parameters for this event
 * @property {string} email - email
 * @property {GUID} uuid - uuid
 * @property {string} color - color
 * @property {string} reason - the reason why the captcha is required
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<loginRecaptchaRequiredParams>} LogObject<loginRecaptchaRequiredParams>
 */
export function loginRecaptchaRequired(params) {
    return { evid: 1253, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginRecaptchaFailed' event (evid: 1254)
 *
 * Event description: login > recaptcha failed.
 *
 * @param {loginRecaptchaFailedParams} params - The parameters for this event
 * @property {string} email - email
 * @property {GUID} uuid - uuid
 * @property {string} color - color
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} google_captcha_reason - google_captcha_reason
 * @property {number} google_captcha_score - google_captcha_score
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<loginRecaptchaFailedParams>} LogObject<loginRecaptchaFailedParams>
 */
export function loginRecaptchaFailed(params) {
    return { evid: 1254, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginRecaptchaValidated' event (evid: 1255)
 *
 * Event description: login > recaptcha validated.
 *
 * @param {loginRecaptchaValidatedParams} params - The parameters for this event
 * @property {string} email - email
 * @property {GUID} uuid - uuid
 * @property {string} color - color
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} google_captcha_reason - google_captcha_reason
 * @property {number} google_captcha_score - google_captcha_score
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<loginRecaptchaValidatedParams>} LogObject<loginRecaptchaValidatedParams>
 */
export function loginRecaptchaValidated(params) {
    return { evid: 1255, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'resellerFlow' event (evid: 1256)
 *
 * Event description: reseller flow.
 *
 * @param {resellerFlowParams} params - The parameters for this event
 * @property {string} email - email
 * @property {GUID} uuid - uuid
 * @property {string} color - color
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} reseller - reseller
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<resellerFlowParams>} LogObject<resellerFlowParams>
 */
export function resellerFlow(params) {
    return { evid: 1256, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'throttlerBlockedEmail' event (evid: 1257)
 *
 * Event description: throttler blocked email.
 *
 * @param {throttlerBlockedEmailParams} params - The parameters for this event
 * @property {string} ip - ip
 * @property {string} email - email
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<throttlerBlockedEmailParams>} LogObject<throttlerBlockedEmailParams>
 */
export function throttlerBlockedEmail(params) {
    return { evid: 1257, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'throttlerBlockedIp' event (evid: 1258)
 *
 * Event description: throttler blocked ip.
 *
 * @param {throttlerBlockedIpParams} params - The parameters for this event
 * @property {string} ip - ip
 * @property {string} email - email
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<throttlerBlockedIpParams>} LogObject<throttlerBlockedIpParams>
 */
export function throttlerBlockedIp(params) {
    return { evid: 1258, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'authRegisterAttempt' event (evid: 1259)
 *
 * Event description: User signup attempt.
 *
 * @param {authRegisterAttemptParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<authRegisterAttemptParams>} LogObject<authRegisterAttemptParams>
 */
export function authRegisterAttempt(params) {
    return { evid: 1259, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'openUserJourneyTab' event (evid: 126)
 *
 * Event description: this would be used to track opening "User Journey" tab from "User Manager" tab
 *
 * @param {openUserJourneyTabParams} params - The parameters for this event
 * @property {string} um_user_type - cs
 * @property {GUID} user_id - user id
 * @property {GUID} account_id - account id
 * @property {string} user_name - part of email before @
 * @return {LogObject<openUserJourneyTabParams>} LogObject<openUserJourneyTabParams>
 */
export function openUserJourneyTab(params) {
    return { evid: 126, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'authWelcomeMailWasSent' event (evid: 1260)
 *
 * Event description: auth > welcome mail was sent.
 *
 * @param {authWelcomeMailWasSentParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<authWelcomeMailWasSentParams>} LogObject<authWelcomeMailWasSentParams>
 */
export function authWelcomeMailWasSent(params) {
    return { evid: 1260, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'authUserImpersonation' event (evid: 1261)
 *
 * Event description: auth > user impersonation.
 *
 * @param {authUserImpersonationParams} params - The parameters for this event
 * @property {GUID} guid - uuid
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} user_agent - user_agent
 * @property {string} recaptcha - recaptcha
 * @property {string} boUser - email
 * @property {Url} app_url - app_url
 * @return {LogObject<authUserImpersonationParams>} LogObject<authUserImpersonationParams>
 */
export function authUserImpersonation(params) {
    return { evid: 1261, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'resellerDelayedAuth' event (evid: 1262)
 *
 * Event description: reseller delayed auth.
 *
 * @param {resellerDelayedAuthParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<resellerDelayedAuthParams>} LogObject<resellerDelayedAuthParams>
 */
export function resellerDelayedAuth(params) {
    return { evid: 1262, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userSetWixLanguage' event (evid: 1263)
 *
 * Event description: user set wix language
 *
 * @param {userSetWixLanguageParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} to - languge selested
 * @property {string} from - original languge
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<userSetWixLanguageParams>} LogObject<userSetWixLanguageParams>
 */
export function userSetWixLanguage(params) {
    return { evid: 1263, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixUserSessionInvalidated' event (evid: 1264)
 *
 * Event description: wix user session invalidated
 *
 * @param {wixUserSessionInvalidatedParams} params - The parameters for this event
 * @property {GUID} guid - uuid
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {number} errorCode - error code
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<wixUserSessionInvalidatedParams>} LogObject<wixUserSessionInvalidatedParams>
 */
export function wixUserSessionInvalidated(params) {
    return { evid: 1264, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginAttemptWithoutAnExistingEmail' event (evid: 1265)
 *
 * Event description: Fraudulent registration detected
 *
 * @param {loginAttemptWithoutAnExistingEmailParams} params - The parameters for this event
 * @property {string} email - fraudulent email
 * @property {GUID} uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<loginAttemptWithoutAnExistingEmailParams>} LogObject<loginAttemptWithoutAnExistingEmailParams>
 */
export function loginAttemptWithoutAnExistingEmail(params) {
    return { evid: 1265, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'authFraudRegistrationCaptcha' event (evid: 1266)
 *
 * Event description: Fraudulent registration captcha
 *
 * @param {authFraudRegistrationCaptchaParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<authFraudRegistrationCaptchaParams>} LogObject<authFraudRegistrationCaptchaParams>
 */
export function authFraudRegistrationCaptcha(params) {
    return { evid: 1266, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'authUserTriesToLoginWithoutUidx' event (evid: 1267)
 *
 * Event description: user send login request without UIDX
 *
 * @param {authUserTriesToLoginWithoutUidxParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<authUserTriesToLoginWithoutUidxParams>} LogObject<authUserTriesToLoginWithoutUidxParams>
 */
export function authUserTriesToLoginWithoutUidx(params) {
    return { evid: 1267, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'authUserTriesToLoginWithNotMatchUidx' event (evid: 1268)
 *
 * Event description: user send login request with UIDX not match
 *
 * @param {authUserTriesToLoginWithNotMatchUidxParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<authUserTriesToLoginWithNotMatchUidxParams>} LogObject<authUserTriesToLoginWithNotMatchUidxParams>
 */
export function authUserTriesToLoginWithNotMatchUidx(params) {
    return { evid: 1268, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'authResetPasswordToUser' event (evid: 1269)
 *
 * Event description: Reset password to user automatically
 *
 * @param {authResetPasswordToUserParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<authResetPasswordToUserParams>} LogObject<authResetPasswordToUserParams>
 */
export function authResetPasswordToUser(params) {
    return { evid: 1269, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'openUserManagerTab' event (evid: 127)
 *
 * Event description: this would be used to track opening "User Manager" tab from "User Journey" tab
 *
 * @param {openUserManagerTabParams} params - The parameters for this event
 * @property {string} um_user_type - cs
 * @property {GUID} user_id - user id
 * @property {GUID} account_id - account id
 * @property {string} user_name - part of email before @
 * @return {LogObject<openUserManagerTabParams>} LogObject<openUserManagerTabParams>
 */
export function openUserManagerTab(params) {
    return { evid: 127, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'authLoginAttempt' event (evid: 1270)
 *
 * Event description: login attempt
 *
 * @param {authLoginAttemptParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {boolean} isMagicLink - 'true' if using a magic link, 'false' if regular login
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<authLoginAttemptParams>} LogObject<authLoginAttemptParams>
 */
export function authLoginAttempt(params) {
    return { evid: 1270, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'signupRecaptchaRequired' event (evid: 1273)
 *
 * Event description: showing captcha in signup flow
 *
 * @param {signupRecaptchaRequiredParams} params - The parameters for this event
 * @property {string} email - signup email
 * @property {GUID} uuid - uuid
 * @property {string} reason - the reason why the captcha is required
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<signupRecaptchaRequiredParams>} LogObject<signupRecaptchaRequiredParams>
 */
export function signupRecaptchaRequired(params) {
    return { evid: 1273, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'signupRecaptchaFailed' event (evid: 1274)
 *
 * Event description: captcha failed in signup flow
 *
 * @param {signupRecaptchaFailedParams} params - The parameters for this event
 * @property {string} email - signup email
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} google_captcha_reason - reason
 * @property {number} google_captcha_score - score of captcha
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<signupRecaptchaFailedParams>} LogObject<signupRecaptchaFailedParams>
 */
export function signupRecaptchaFailed(params) {
    return { evid: 1274, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'signupRecaptchaValidated' event (evid: 1275)
 *
 * Event description: valid captcha entered in the signup flow
 *
 * @param {signupRecaptchaValidatedParams} params - The parameters for this event
 * @property {string} email - signup email
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} google_captcha_reason - google_captcha_reason
 * @property {number} google_captcha_score - google_captcha_score
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<signupRecaptchaValidatedParams>} LogObject<signupRecaptchaValidatedParams>
 */
export function signupRecaptchaValidated(params) {
    return { evid: 1275, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'authSessionGenerated' event (evid: 1276)
 *
 * Event description: every time session is generated
 *
 * @param {authSessionGeneratedParams} params - The parameters for this event
 * @property {string} context - context of flow in which session is generated
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} user_agent - user_agent
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<authSessionGeneratedParams>} LogObject<authSessionGeneratedParams>
 */
export function authSessionGenerated(params) {
    return { evid: 1276, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkIfUserEmailLoginExistsInSystem' event (evid: 1277)
 *
 * Event description: Server reply after a user used "continue with email".
 * This event represents a reply from the server if the user exists. If the original request was with msid endpoint also replies if the user is site member on that site.
 *
 * @param {checkIfUserEmailLoginExistsInSystemParams} params - The parameters for this event
 * @property {boolean} isConnected - true iff member connnected to user
 * @property {GUID} uuid - uuid if exists
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} originView - origin view
 * @property {GUID} memberId - true if member exists
 * @property {GUID} ldSessionID - id session
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @property {GUID} msid - msid if exists in the request
 * @property {string} userType - ["SiteBuilding","OneApp"]
 * @return {LogObject<checkIfUserEmailLoginExistsInSystemParams>} LogObject<checkIfUserEmailLoginExistsInSystemParams>
 */
export function checkIfUserEmailLoginExistsInSystem(params) {
    return { evid: 1277, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'authenticateMemberFailedWrongPassword' event (evid: 1278)
 *
 * Event description: Server reply after failing authentication attempt (wrong password)
 *
 * @param {authenticateMemberFailedWrongPasswordParams} params - The parameters for this event
 * @property {GUID} uuid - uuid if exists
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} originView - origin view
 * @property {GUID} memberId - member id
 * @property {GUID} ldSessionID - ldSessionID
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @property {GUID} msid - always exists
 * @property {string} userType - ["SiteBuilding","OneApp"]
 * @return {LogObject<authenticateMemberFailedWrongPasswordParams>} LogObject<authenticateMemberFailedWrongPasswordParams>
 */
export function authenticateMemberFailedWrongPassword(params) {
    return { evid: 1278, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'authenticateMember' event (evid: 1279)
 *
 * Event description: Server reply after it verifies the member
 *
 * @param {authenticateMemberParams} params - The parameters for this event
 * @property {GUID} uuid - uuid if exists
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} originView - origin view
 * @property {GUID} memberId - true if member exists
 * @property {GUID} ldSessionID - ldSessionID
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @property {GUID} msid - must exist
 * @property {string} userType - ["SiteBuilding","OneApp"]
 * @return {LogObject<authenticateMemberParams>} LogObject<authenticateMemberParams>
 */
export function authenticateMember(params) {
    return { evid: 1279, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginFormEndPointOnStart' event (evid: 1280)
 *
 * Event description: Sent before the login/signup form is shown to the user, server call to the signin endpoint
 *
 * @param {loginFormEndPointOnStartParams} params - The parameters for this event
 * @property {string} referralInfo - name of the button in the referral page
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} displayVersion - old/ new
 * @property {Url} origin - origin, calculated by server, not counting on query param
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @property {string} userType - Adding user type to login view (each type that use web get its own entry-point)
 * @property {Url} redirectedFrom - redirected_from
 * @return {LogObject<loginFormEndPointOnStartParams>} LogObject<loginFormEndPointOnStartParams>
 */
export function loginFormEndPointOnStart(params) {
    return { evid: 1280, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ssoEndPointOnStart' event (evid: 1281)
 *
 * Event description: SSO end point - On start
 *
 * @param {ssoEndPointOnStartParams} params - The parameters for this event
 * @property {string} referralInfo - name of the button in the referral page
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} displayVersion - old/ new
 * @property {Url} origin - origin, calculated by server, not counting on query param
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @property {string} userType - Adding user type to login view (each type that use web get its own entry-point)
 * @property {Url} redirectedFrom - redirected_from
 * @return {LogObject<ssoEndPointOnStartParams>} LogObject<ssoEndPointOnStartParams>
 */
export function ssoEndPointOnStart(params) {
    return { evid: 1281, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ssoEndPointOnEnd' event (evid: 1282)
 *
 * Event description: SSO end point - On end
 *
 * @param {ssoEndPointOnEndParams} params - The parameters for this event
 * @property {string} referralInfo - name of the button in the referral page
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} displayVersion - old/ new
 * @property {Url} origin - origin, calculated by server, not counting on query param
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @property {string} userType - Adding user type to login view (each type that use web get its own entry-point)
 * @property {Url} redirectedFrom - redirected_from
 * @return {LogObject<ssoEndPointOnEndParams>} LogObject<ssoEndPointOnEndParams>
 */
export function ssoEndPointOnEnd(params) {
    return { evid: 1282, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ssoAuthenticationRequest' event (evid: 1283)
 *
 * Event description: The first step of a channel account using SSO through a 3rd party - call to Wix
 *
 * @param {ssoAuthenticationRequestParams} params - The parameters for this event
 * @property {GUID} sso_id - SSO id
 * @property {string} state - similar to session id in SSO flow
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {GUID} user_id - user_id of the team member trying to log in
 * @property {GUID} account_id - account id of the channel account using SSO
 * @property {string} idp - SSO provider name
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<ssoAuthenticationRequestParams>} LogObject<ssoAuthenticationRequestParams>
 */
export function ssoAuthenticationRequest(params) {
    return { evid: 1283, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ssoRedirectSuccess' event (evid: 1284)
 *
 * Event description: Wix successfully sent the login request to the 3rd party SSO provider
 *
 * @param {ssoRedirectSuccessParams} params - The parameters for this event
 * @property {GUID} sso_id - SSO id
 * @property {string} state - similar to session id in SSO flow
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {GUID} user_id - user_id of the team member trying to log in
 * @property {GUID} account_id - account id of the channel account using SSO
 * @property {string} idp - SSO provider name
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<ssoRedirectSuccessParams>} LogObject<ssoRedirectSuccessParams>
 */
export function ssoRedirectSuccess(params) {
    return { evid: 1284, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ssoRedirectFail' event (evid: 1285)
 *
 * Event description: Login request to the 3rd party SSO provider sent by Wix failed
 *
 * @param {ssoRedirectFailParams} params - The parameters for this event
 * @property {GUID} sso_id - SSO id
 * @property {string} state - similar to session id in SSO flow
 * @property {GUID} uuid - uuid
 * @property {string} reason - reason the redirect to SSO provider failed
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {GUID} user_id - user_id of the team member trying to log in
 * @property {GUID} account_id - account id of the channel account using SSO
 * @property {string} idp - SSO provider name
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<ssoRedirectFailParams>} LogObject<ssoRedirectFailParams>
 */
export function ssoRedirectFail(params) {
    return { evid: 1285, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ssoAuthenticationCallback' event (evid: 1286)
 *
 * Event description: 3rd party SSO provider replies to Wix after an attempt to user verification
 *
 * @param {ssoAuthenticationCallbackParams} params - The parameters for this event
 * @property {GUID} sso_id - sso_id
 * @property {string} state - similar to session id for SSO flow
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {GUID} user_id - user_id of the team member trying to log in
 * @property {GUID} account_id - account id of the channel account using SSO
 * @property {string} idp - SSO provider name
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<ssoAuthenticationCallbackParams>} LogObject<ssoAuthenticationCallbackParams>
 */
export function ssoAuthenticationCallback(params) {
    return { evid: 1286, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ssoAuthenticationSuccess' event (evid: 1287)
 *
 * Event description: 3rd party SSO (single sign on) successful
 *
 * @param {ssoAuthenticationSuccessParams} params - The parameters for this event
 * @property {GUID} sso_id - SSO id
 * @property {string} state - similar to session id in SSO flow
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {GUID} user_id - user_id
 * @property {GUID} account_id - account id of the channel account using SSO
 * @property {string} idp - SSO provider name
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<ssoAuthenticationSuccessParams>} LogObject<ssoAuthenticationSuccessParams>
 */
export function ssoAuthenticationSuccess(params) {
    return { evid: 1287, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ssoAuthenticationFail' event (evid: 1288)
 *
 * Event description: 3rd party SSO (single sign on) wasn't successful
 *
 * @param {ssoAuthenticationFailParams} params - The parameters for this event
 * @property {GUID} sso_id - SSO id
 * @property {string} state - similar to session id in SSO flow
 * @property {GUID} uuid - uuid
 * @property {string} reason - reason the verification failed
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {GUID} user_id - user_id of the team member trying to log in
 * @property {GUID} account_id - account id of the channel account using SSO
 * @property {string} idp - SSO provider name
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<ssoAuthenticationFailParams>} LogObject<ssoAuthenticationFailParams>
 */
export function ssoAuthenticationFail(params) {
    return { evid: 1288, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginAttemptFromNewDeviceByLfndSecurityModel' event (evid: 1289)
 *
 * Event description: Security model of login from new device (LFND) identified the login attempt to Wix.com as coming from a new device. User will be challenged with reCAPTCHA and 2FA (if active) and reset password recommendation will be sent in email.
 *
 * @param {loginAttemptFromNewDeviceByLfndSecurityModelParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<loginAttemptFromNewDeviceByLfndSecurityModelParams>} LogObject<loginAttemptFromNewDeviceByLfndSecurityModelParams>
 */
export function loginAttemptFromNewDeviceByLfndSecurityModel(params) {
    return { evid: 1289, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationRequired' event (evid: 1290)
 *
 * Event description: When the user login, he is required to do Two Factor Authentication (Due to his account settings or Email 2FA enforcement due to LFND model).
 *
 * @param {loginTwoFactorAuthenticationRequiredParams} params - The parameters for this event
 * @property {string} reason - mfa reason (LFND, account settings)
 * @property {string} flowType - mfa method required (Email,Phone,Push(owner app), App)
 * @property {string} flow_type - login using Email
 * @property {Url} app_url - app_url
 * @return {LogObject<loginTwoFactorAuthenticationRequiredParams>} LogObject<loginTwoFactorAuthenticationRequiredParams>
 */
export function loginTwoFactorAuthenticationRequired(params) {
    return { evid: 1290, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'magicLinkCreationSuccess' event (evid: 1300)
 *
 * Event description: Magic Link Created Successfully
 *
 * @param {magicLinkCreationSuccessParams} params - The parameters for this event
 * @property {string} app_def_id - OneApp..
 * @return {LogObject<magicLinkCreationSuccessParams>} LogObject<magicLinkCreationSuccessParams>
 */
export function magicLinkCreationSuccess(params) {
    return { evid: 1300, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'magicLinkCreationFail' event (evid: 1301)
 *
 * Event description: Magic Link Creation failed
 *
 * @param {magicLinkCreationFailParams} params - The parameters for this event
 * @property {string} errorMessage - revoked / expired / general / not found
 * @property {string} app_def_id - OneApp..
 * @return {LogObject<magicLinkCreationFailParams>} LogObject<magicLinkCreationFailParams>
 */
export function magicLinkCreationFail(params) {
    return { evid: 1301, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'magicLinkGetSuccess' event (evid: 1302)
 *
 * Event description: Magic Link Get Success
 *
 * @param {magicLinkGetSuccessParams} params - The parameters for this event
 * @property {string} app_def_id - OneApp..
 * @return {LogObject<magicLinkGetSuccessParams>} LogObject<magicLinkGetSuccessParams>
 */
export function magicLinkGetSuccess(params) {
    return { evid: 1302, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'magicLinkGetFail' event (evid: 1303)
 *
 * Event description: Magic Link Get failed
 *
 * @param {magicLinkGetFailParams} params - The parameters for this event
 * @property {string} errorMessage - revoked / expired / general / not found
 * @property {string} app_def_id - OneApp..
 * @return {LogObject<magicLinkGetFailParams>} LogObject<magicLinkGetFailParams>
 */
export function magicLinkGetFail(params) {
    return { evid: 1303, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'magicLinkRevokeSuccess' event (evid: 1304)
 *
 * Event description: Magic Link Revoke Success
 *
 * @param {magicLinkRevokeSuccessParams} params - The parameters for this event
 * @property {string} app_def_id - OneApp..
 * @return {LogObject<magicLinkRevokeSuccessParams>} LogObject<magicLinkRevokeSuccessParams>
 */
export function magicLinkRevokeSuccess(params) {
    return { evid: 1304, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'magicLinkRevokeFail' event (evid: 1305)
 *
 * Event description: Magic Link Get failed
 *
 * @param {magicLinkRevokeFailParams} params - The parameters for this event
 * @property {string} errorMessage - revoked / expired / general / not found
 * @property {string} app_def_id - OneApp..
 * @return {LogObject<magicLinkRevokeFailParams>} LogObject<magicLinkRevokeFailParams>
 */
export function magicLinkRevokeFail(params) {
    return { evid: 1305, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginFromNewDevice' event (evid: 1501)
 *
 * Event description: reports on every login from an unknown device
 *
 * @param {loginFromNewDeviceParams} params - The parameters for this event
 * @property {boolean} client_id_is_new - true iff client_id value is unknown
 * @property {GUID} client_id - cidx
 * @property {boolean} country_code_is_new - true iff country_code value is unknown
 * @property {GUID} uid - user guid
 * @property {boolean} user_agent_is_new - true iff user_agent value is unknown
 * @property {boolean} ip_is_new - true iff ip value is unknown
 * @return {LogObject<loginFromNewDeviceParams>} LogObject<loginFromNewDeviceParams>
 */
export function loginFromNewDevice(params) {
    return { evid: 1501, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginTroubleshooterFindMyEmailNoMatch' event (evid: 1600)
 *
 * Event description: When user clicks on next & there's no match between site url and email/phone entered
 *
 * @param {loginTroubleshooterFindMyEmailNoMatchParams} params - The parameters for this event
 * @property {string} context - context of scenario: find-email
 * @property {string} reason - reason for no match error - email/site url
 * @property {GUID} ldSessionID - login session id
 * @property {string} siteUrl - site url that was entered
 * @property {string} view - -
 * @return {LogObject<loginTroubleshooterFindMyEmailNoMatchParams>} LogObject<loginTroubleshooterFindMyEmailNoMatchParams>
 */
export function loginTroubleshooterFindMyEmailNoMatch(params) {
    return { evid: 1600, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restoreEmailSmsSent' event (evid: 1601)
 *
 * Event description: When user entered a valid phone and a sms was sent
 *
 * @param {restoreEmailSmsSentParams} params - The parameters for this event
 * @property {GUID} ldSessionID - -
 * @return {LogObject<restoreEmailSmsSentParams>} LogObject<restoreEmailSmsSentParams>
 */
export function restoreEmailSmsSent(params) {
    return { evid: 1601, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restoreEmailSmsReceived' event (evid: 1602)
 *
 * Event description: the user received the sms
 *
 * @param {restoreEmailSmsReceivedParams} params - The parameters for this event
 * @property {GUID} ldSessionID - -
 * @return {LogObject<restoreEmailSmsReceivedParams>} LogObject<restoreEmailSmsReceivedParams>
 */
export function restoreEmailSmsReceived(params) {
    return { evid: 1602, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restoreEmailFindWebsiteAddress' event (evid: 1603)
 *
 * Event description: When user entered a valid Wix website (or only valid user name)
 *
 * @param {restoreEmailFindWebsiteAddressParams} params - The parameters for this event
 * @property {string} urlType - type of url: premium\free\unconnected domain
 * @property {GUID} ldSessionID - -
 * @return {LogObject<restoreEmailFindWebsiteAddressParams>} LogObject<restoreEmailFindWebsiteAddressParams>
 */
export function restoreEmailFindWebsiteAddress(params) {
    return { evid: 1603, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restoreEmailUnableToFindWebsiteAddress' event (evid: 1604)
 *
 * Event description: When user entered a invalid Wix website
 *
 * @param {restoreEmailUnableToFindWebsiteAddressParams} params - The parameters for this event
 * @property {string} urlType - type of url: premium\free\unconnected domain
 * @property {string} urlAddress - the wrong url address
 * @property {GUID} ldSessionID - -
 * @return {LogObject<restoreEmailUnableToFindWebsiteAddressParams>} LogObject<restoreEmailUnableToFindWebsiteAddressParams>
 */
export function restoreEmailUnableToFindWebsiteAddress(params) {
    return { evid: 1604, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sampleEvent' event (evid: 1700)
 *
 * Event description: sample event.
 *
 * @param {sampleEventParams} params - The parameters for this event
 * @return {LogObject<sampleEventParams>} LogObject<sampleEventParams>
 */
export function sampleEvent(params) {
    return { evid: 1700, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'phoneRemoved' event (evid: 1701)
 *
 * Event description: phone deleted from account info
 *
 * @param {phoneRemovedParams} params - The parameters for this event
 * @property {string} errorMessage - null if no error
 * @property {string} identifier - identifier
 * @property {string} scope - scope
 * @property {string} hashed_phone - hashed_phone
 * @property {boolean} status - true = removed successfully
 * @return {LogObject<phoneRemovedParams>} LogObject<phoneRemovedParams>
 */
export function phoneRemoved(params) {
    return { evid: 1701, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'updatedAccountSettingsData' event (evid: 1702)
 *
 * Event description: success with saving changes button for user name / email address / phone number
 *
 * @param {updatedAccountSettingsDataParams} params - The parameters for this event
 * @property {string} errorMessage - null if no error
 * @property {string} identifier - identifier
 * @property {string} scope - scope
 * @property {string} hashed_phone - hashed phone
 * @property {boolean} is_verified - is the number saved passed the verification process
 * @property {string} origin - From which flow the event happened ("Account settings"\"Post login"))
 * @property {boolean} status - true = updated successfully
 * @property {GUID} msid - msid
 * @return {LogObject<updatedAccountSettingsDataParams>} LogObject<updatedAccountSettingsDataParams>
 */
export function updatedAccountSettingsData(params) {
    return { evid: 1702, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'recoveryPhoneNumberUpdated' event (evid: 1703)
 *
 * Event description: The user successfully updated the recovery phone number after clicking on 'edit' in account settings
 *
 * @param {recoveryPhoneNumberUpdatedParams} params - The parameters for this event
 * @property {string} identifier - identifier
 * @property {string} scope - scope
 * @property {string} hashed_phone - hashed phone
 * @property {boolean} is_verified - did the number saved pass the verification process
 * @property {boolean} status - true = updated successfully
 * @return {LogObject<recoveryPhoneNumberUpdatedParams>} LogObject<recoveryPhoneNumberUpdatedParams>
 */
export function recoveryPhoneNumberUpdated(params) {
    return { evid: 1703, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faEnforcementUserExcludedSrc18Evid2' event (evid: 2)
 *
 * Event description: When a user chooses to exclude himself from the 2fa enforcement (From the KB)
 *
 * @param {faEnforcementUserExcludedSrc18Evid2Params} params - The parameters for this event
 * @property {boolean} is_success - Was the action successful
 * @property {GUID} user_id - The excluded user_id
 * @return {LogObject<faEnforcementUserExcludedSrc18Evid2Params>} LogObject<faEnforcementUserExcludedSrc18Evid2Params>
 */
export function faEnforcementUserExcludedSrc18Evid2(params) {
    return { evid: 2, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cheetahSubscripitionFailed' event (evid: 2000)
 *
 * Event description: cheetah subscripition failed.
 *
 * @param {cheetahSubscripitionFailedParams} params - The parameters for this event
 * @property {string} email - email
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} message - message
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<cheetahSubscripitionFailedParams>} LogObject<cheetahSubscripitionFailedParams>
 */
export function cheetahSubscripitionFailed(params) {
    return { evid: 2000, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'workspaceSelectorFormLoadSrc18Evid2001' event (evid: 2001)
 *
 * Event description: Account selector page loaded
 *
 * @param {workspaceSelectorFormLoadSrc18Evid2001Params} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<workspaceSelectorFormLoadSrc18Evid2001Params>} LogObject<workspaceSelectorFormLoadSrc18Evid2001Params>
 */
export function workspaceSelectorFormLoadSrc18Evid2001(params) {
    return { evid: 2001, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'workspaceSelectorWorkspaceSelected' event (evid: 2002)
 *
 * Event description: The user chose the workspace he accepts the invite
 *
 * @param {workspaceSelectorWorkspaceSelectedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {GUID} invite_id - the invite id the user chose to accept
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @property {GUID} account_id_selected - the chosen account id
 * @return {LogObject<workspaceSelectorWorkspaceSelectedParams>} LogObject<workspaceSelectorWorkspaceSelectedParams>
 */
export function workspaceSelectorWorkspaceSelected(params) {
    return { evid: 2002, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ownerApp2FaSetupEnableSuccess' event (evid: 2005)
 *
 * Event description: When a user successfully enables the owner app 2-factor authentication
 *
 * @param {ownerApp2FaSetupEnableSuccessParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<ownerApp2FaSetupEnableSuccessParams>} LogObject<ownerApp2FaSetupEnableSuccessParams>
 */
export function ownerApp2FaSetupEnableSuccess(params) {
    return { evid: 2005, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ownerApp2FaSetupDisableSuccess' event (evid: 2006)
 *
 * Event description: When a user successfully disables the owner app 2-factor authentication
 *
 * @param {ownerApp2FaSetupDisableSuccessParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} px_source - px_source
 * @property {string} px - px
 * @property {string} recaptcha - recaptcha
 * @property {Url} app_url - app_url
 * @return {LogObject<ownerApp2FaSetupDisableSuccessParams>} LogObject<ownerApp2FaSetupDisableSuccessParams>
 */
export function ownerApp2FaSetupDisableSuccess(params) {
    return { evid: 2006, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginOwaLoginBackupAsDefaultSrc18Evid3' event (evid: 3)
 *
 * Event description: When user login and doesn't have OWA on the phone and notifications on - he will be required to login by the backup method as default
 *
 * @param {loginOwaLoginBackupAsDefaultSrc18Evid3Params} params - The parameters for this event
 * @property {string} method - backup method required as default
 * @property {string} filter_reason - filter_reason
 * @property {string} eligible_installation_ids - eligible_installation_ids
 * @return {LogObject<loginOwaLoginBackupAsDefaultSrc18Evid3Params>} LogObject<loginOwaLoginBackupAsDefaultSrc18Evid3Params>
 */
export function loginOwaLoginBackupAsDefaultSrc18Evid3(params) {
    return { evid: 3, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'failedRegistrationEventHandling' event (evid: 3012)
 *
 * Event description: Failed registration event handling in account info
 *
 * @param {failedRegistrationEventHandlingParams} params - The parameters for this event
 * @property {string} userType - user type: ["SiteBuilding","OneApp",...]
 * @property {string} userId - user id
 * @return {LogObject<failedRegistrationEventHandlingParams>} LogObject<failedRegistrationEventHandlingParams>
 */
export function failedRegistrationEventHandling(params) {
    return { evid: 3012, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'failedLoginEventHandling' event (evid: 3013)
 *
 * Event description: Failed login event handling in account info
 *
 * @param {failedLoginEventHandlingParams} params - The parameters for this event
 * @property {string} userType - user type: ["SiteBuilding","OneApp",...]
 * @property {string} userId - user id
 * @return {LogObject<failedLoginEventHandlingParams>} LogObject<failedLoginEventHandlingParams>
 */
export function failedLoginEventHandling(params) {
    return { evid: 3013, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'redirectedToNodeNewLogin' event (evid: 3401)
 *
 * Event description: Redirect from old login to new login (Got to node)
 *
 * @param {redirectedToNodeNewLoginParams} params - The parameters for this event
 * @property {string} redirectUrl - redirect user to this url
 * @return {LogObject<redirectedToNodeNewLoginParams>} LogObject<redirectedToNodeNewLoginParams>
 */
export function redirectedToNodeNewLogin(params) {
    return { evid: 3401, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scimSetupEnableSuccess' event (evid: 3501)
 *
 * Event description: Account enabled successfully SCIM service
 *
 * @param {scimSetupEnableSuccessParams} params - The parameters for this event
 * @property {GUID} scim_id - SCIM id (account_id)
 * @return {LogObject<scimSetupEnableSuccessParams>} LogObject<scimSetupEnableSuccessParams>
 */
export function scimSetupEnableSuccess(params) {
    return { evid: 3501, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scimSetupEnableFailed' event (evid: 3502)
 *
 * Event description: Account failed enabling SCIM service
 *
 * @param {scimSetupEnableFailedParams} params - The parameters for this event
 * @property {string} reason - reason for failure
 * @property {GUID} scim_id - SCIM id (account_id)
 * @return {LogObject<scimSetupEnableFailedParams>} LogObject<scimSetupEnableFailedParams>
 */
export function scimSetupEnableFailed(params) {
    return { evid: 3502, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scimSetupDisableSuccess' event (evid: 3503)
 *
 * Event description: Account disabled successfully SCIM service
 *
 * @param {scimSetupDisableSuccessParams} params - The parameters for this event
 * @property {GUID} scim_id - SCIM id (account_id)
 * @return {LogObject<scimSetupDisableSuccessParams>} LogObject<scimSetupDisableSuccessParams>
 */
export function scimSetupDisableSuccess(params) {
    return { evid: 3503, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scimSetupDisableFailed' event (evid: 3504)
 *
 * Event description: Account failed disabling SCIM service
 *
 * @param {scimSetupDisableFailedParams} params - The parameters for this event
 * @property {string} reason - reason for failure
 * @property {GUID} scim_id - SCIM id (account_id)
 * @return {LogObject<scimSetupDisableFailedParams>} LogObject<scimSetupDisableFailedParams>
 */
export function scimSetupDisableFailed(params) {
    return { evid: 3504, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scimChangeGroupRole' event (evid: 3505)
 *
 * Event description: The account changed group role
 *
 * @param {scimChangeGroupRoleParams} params - The parameters for this event
 * @property {GUID} group_id - SCIM group id
 * @property {string} role_ids - group role ids
 * @property {GUID} scim_id - SCIM id (account_id)
 * @return {LogObject<scimChangeGroupRoleParams>} LogObject<scimChangeGroupRoleParams>
 */
export function scimChangeGroupRole(params) {
    return { evid: 3505, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scimCreateUser' event (evid: 3601)
 *
 * Event description: The account created user with SCIM
 *
 * @param {scimCreateUserParams} params - The parameters for this event
 * @property {string} first_name - Users first name
 * @property {GUID} created_user_id - The user_id of the created user
 * @property {string} last_name - Users last name
 * @property {GUID} scim_id - SCIM id (account_id)
 * @return {LogObject<scimCreateUserParams>} LogObject<scimCreateUserParams>
 */
export function scimCreateUser(params) {
    return { evid: 3601, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scimUpdateUserDetails' event (evid: 3602)
 *
 * Event description: The changes that was made on SCIM user
 *
 * @param {scimUpdateUserDetailsParams} params - The parameters for this event
 * @property {GUID} group_id - SCIM group id
 * @property {string} changed_field - the changed field (for exmaple - first name/ last name)
 * @property {string} fieldValue - the new value for the changed field
 * @property {GUID} scim_id - SCIM id (account_id)
 * @property {GUID} changedUserId - The user_id
 * @return {LogObject<scimUpdateUserDetailsParams>} LogObject<scimUpdateUserDetailsParams>
 */
export function scimUpdateUserDetails(params) {
    return { evid: 3602, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scimUpdateGroupDetails' event (evid: 3603)
 *
 * Event description: The changes that was made on SCIM group
 *
 * @param {scimUpdateGroupDetailsParams} params - The parameters for this event
 * @property {GUID} group_id - SCIM group id
 * @property {string} changed_field - the changed field (for exmaple - first name/ last name)
 * @property {string} fieldValue - the new value for the changed field
 * @property {GUID} scim_id - SCIM id (account_id)
 * @return {LogObject<scimUpdateGroupDetailsParams>} LogObject<scimUpdateGroupDetailsParams>
 */
export function scimUpdateGroupDetails(params) {
    return { evid: 3603, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scimCreateGroup' event (evid: 3604)
 *
 * Event description: Creating new group on SCIM
 *
 * @param {scimCreateGroupParams} params - The parameters for this event
 * @property {GUID} group_id - SCIM group id
 * @property {string} role_id - the role id of this group
 * @property {string} role_name - the role name of this group
 * @property {string} group_name - groups name
 * @property {GUID} scim_id - SCIM id (account_id)
 * @return {LogObject<scimCreateGroupParams>} LogObject<scimCreateGroupParams>
 */
export function scimCreateGroup(params) {
    return { evid: 3604, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scimDeleteGroup' event (evid: 3605)
 *
 * Event description: Deleting a group on SCIM
 *
 * @param {scimDeleteGroupParams} params - The parameters for this event
 * @property {GUID} group_id - SCIM group id
 * @property {GUID} scim_id - SCIM id (account_id)
 * @return {LogObject<scimDeleteGroupParams>} LogObject<scimDeleteGroupParams>
 */
export function scimDeleteGroup(params) {
    return { evid: 3605, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scimDeleteUser' event (evid: 3606)
 *
 * Event description: Deleting a user on SCIM
 *
 * @param {scimDeleteUserParams} params - The parameters for this event
 * @property {GUID} group_id - SCIM group id
 * @property {GUID} scim_id - SCIM id (account_id)
 * @property {GUID} deleted_user_id - the deleted user_id
 * @return {LogObject<scimDeleteUserParams>} LogObject<scimDeleteUserParams>
 */
export function scimDeleteUser(params) {
    return { evid: 3606, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scimAddUserToGroup' event (evid: 3607)
 *
 * Event description: Adding a user (existing user) to SCIM group
 *
 * @param {scimAddUserToGroupParams} params - The parameters for this event
 * @property {GUID} group_id - SCIM group id
 * @property {GUID} added_user_id - the added user_id
 * @property {GUID} scim_id - SCIM id (account_id)
 * @return {LogObject<scimAddUserToGroupParams>} LogObject<scimAddUserToGroupParams>
 */
export function scimAddUserToGroup(params) {
    return { evid: 3607, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scimDeleteUserFromGroup' event (evid: 3608)
 *
 * Event description: Delete a user to SCIM group
 *
 * @param {scimDeleteUserFromGroupParams} params - The parameters for this event
 * @property {GUID} group_id - SCIM group id
 * @property {GUID} scim_id - SCIM id (account_id)
 * @property {GUID} deleted_user_id - the deleted user_id
 * @return {LogObject<scimDeleteUserFromGroupParams>} LogObject<scimDeleteUserFromGroupParams>
 */
export function scimDeleteUserFromGroup(params) {
    return { evid: 3608, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scimCreateDefaultRole' event (evid: 3609)
 *
 * Event description: Creating a default role for SCIM (this role will be assigned to all new users without roles).
 *
 * @param {scimCreateDefaultRoleParams} params - The parameters for this event
 * @property {string} context - context of changing default role ("setup"/"change")
 * @property {string} role_id - Default role id
 * @property {string} role_name - Default role name
 * @property {GUID} scim_id - SCIM id (account_id)
 * @return {LogObject<scimCreateDefaultRoleParams>} LogObject<scimCreateDefaultRoleParams>
 */
export function scimCreateDefaultRole(params) {
    return { evid: 3609, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'abtestEvent' event (evid: 666)
 *
 * Event description: abtest event.
 *
 * @param {abtestEventParams} params - The parameters for this event
 * @property {DateTime} date - date time of the log entry
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} metaSiteId - meta site id
 * @property {number} testGroupId - test_group
 * @property {string} city - city
 * @property {string} device_id - device_id
 * @property {string} ip - ip
 * @property {string} lng - lng
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} udger_ua_class - udger_ua_class
 * @property {string} role - roles
 * @property {Url} url - url
 * @property {string} reg_color - reg_color
 * @property {boolean} is_validation_excluded - is_validation_excluded
 * @property {string} geo - geo
 * @property {GUID} uuid - unique user identificator
 * @property {string} host - host
 * @property {string} isp_name - isp
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {GUID} visitor_id - visitor_id
 * @property {number} area_code - area_code
 * @property {string} os_name - os_name
 * @property {string} brand_id - brand_id
 * @property {string} udger_ua_family - udger_ua_family
 * @property {GUID} gsi - gsi
 * @property {number} catalog_version - catalog_version
 * @property {string} user_agent - user_agent
 * @property {string} nv_invalid_reason - nv_invalid_reason
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {GUID} cuid - unique client/computer id
 * @property {string} udger_os_name - udger_os_name
 * @property {boolean} is_internal - is_internal
 * @property {string} country_code - country_code
 * @property {GUID} logged_account_id - logged_account_id
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} experimentId - experiment
 * @property {string} udger_ua - udger_ua
 * @property {string} nv_destination - nv_destination
 * @property {string} browser_family - browser_family
 * @property {string} ip_hash - ip_hash
 * @property {string} bot_name - bot_name
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} bsi - bsi
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {string} bi_project_id - bi_project_id
 * @property {string} postal_code - postal_code
 * @property {GUID} impersonating_user_id - impersonating_user_id
 * @property {string} productName - product_name
 * @property {string} region - region
 * @property {GUID} logged_user_id - logged_user_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} browser_version - browser_version
 * @property {GUID} target_account_id - target_account_id
 * @property {string} extra_fields - extra_fields
 * @property {GUID} msid - meta site id
 * @property {string} browser_name - browser_name
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} label_id - label of the ab test
 * @property {string} country_name - country_name
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<abtestEventParams>} LogObject<abtestEventParams>
 */
export function abtestEvent(params) {
    return { evid: 666, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'firstAnonymous' event (evid: 1000)
 *
 * Event description: first anonymous.
 *
 * @param {firstAnonymousParams} params - The parameters for this event
 * @property {DateTime} date_created - date_created
 * @property {DateTime} _artificial_ts - date_created
 * @property {Url} http_referrer - http_referrer
 * @property {string} utm_campaign - campaign_id
 * @property {string} ad_position - ad_position
 * @property {string} statusCode - response status code
 * @property {string} search_terms - search_terms
 * @property {string} ttclid - ttclid
 * @property {string} fbp_cookie - Facebook tracking cookie
 * @property {string} browser_language - browser_language
 * @property {string} fbc_cookie - Facebook tracking cookie
 * @property {string} googlead_domain - googlead_domain
 * @property {string} ad_group - ad_group
 * @property {string} ad_match_type - ad_match_type
 * @property {string} subsub - subsub
 * @property {string} segment - segment
 * @property {string} gclid - gclid
 * @property {string} user_agent - user_agent
 * @property {string} wbraid - wbraid
 * @property {string} gbraid - gbraid
 * @property {string} ad_domain - ad_domain
 * @property {string} subsegment - subsegment
 * @property {string} purpose_header - purpose_header
 * @property {string} profile - profile
 * @property {string} ad_keywords - ad_keywords
 * @property {string} experiment_id - experiment_id
 * @property {string} ad_id - ad_id
 * @property {string} referrer - referrer
 * @property {string} googlead_referral - googlead_referral
 * @property {Url} app_url - app_url
 * @property {string} se_address - se_address
 * @property {string} se_name - se_name
 * @property {string} referral - referrer
 * @property {string} irclickid - UTM param from http referrer
 * @property {string} impact_click_id - UTM param from http referrer
 * @return {LogObject<firstAnonymousParams>} LogObject<firstAnonymousParams>
 */
export function firstAnonymous(params) {
    return { evid: 1000, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSsoAuthenticationRequestCallback' event (evid: 1256001)
 *
 * Event description: Site members SSO (from UoU side) Authentication request / callback.
 * Request: The first step of a site using SSO through a 3rd party - call to Wix; Callback: 3rd party SSO provider replies to Wix after an attempt to user verificatio
 *
 * @param {siteMembersSsoAuthenticationRequestCallbackParams} params - The parameters for this event
 * @property {GUID} visitorId - Visitor ID of of UoU
 * @property {GUID} sso_id - Identifier of SSO IDP
 * @property {string} state - Session ID for SSO
 * @property {string} contactId - ID of member initiating SSO request
 * @property {string} type - request / callback
 * @property {GUID} msid - MSID of site
 * @return {LogObject<siteMembersSsoAuthenticationRequestCallbackParams>} LogObject<siteMembersSsoAuthenticationRequestCallbackParams>
 */
export function siteMembersSsoAuthenticationRequestCallback(params) {
    return { evid: 1256001, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSsoRedirectResult' event (evid: 1256002)
 *
 * Event description: Site members SSO (from UoU side) redirected state to IDP to complete site authentication (success/fail)
 *
 * @param {siteMembersSsoRedirectResultParams} params - The parameters for this event
 * @property {GUID} visitorId - Visitor ID of of UoU
 * @property {GUID} sso_id - Identifier of SSO IDP
 * @property {string} state - Session ID for SSO
 * @property {string} result - success / fail
 * @property {string} contactId - ID of member initiating SSO request
 * @property {GUID} msid - MSID of site
 * @return {LogObject<siteMembersSsoRedirectResultParams>} LogObject<siteMembersSsoRedirectResultParams>
 */
export function siteMembersSsoRedirectResult(params) {
    return { evid: 1256002, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSsoAuthenticationResult' event (evid: 1256003)
 *
 * Event description: Site members SSO (from UoU side) authentication result from IDP to complete site authentication (success/fail)
 *
 * @param {siteMembersSsoAuthenticationResultParams} params - The parameters for this event
 * @property {GUID} visitorId - Visitor ID of of UoU
 * @property {GUID} sso_id - Identifier of SSO IDP
 * @property {string} state - Session ID for SSO
 * @property {string} result - success / fail
 * @property {string} contactId - ID of member initiating SSO request
 * @property {GUID} msid - MSID of site
 * @return {LogObject<siteMembersSsoAuthenticationResultParams>} LogObject<siteMembersSsoAuthenticationResultParams>
 */
export function siteMembersSsoAuthenticationResult(params) {
    return { evid: 1256003, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesGetContributorsQuotaFromPremiumCall' event (evid: 1256502)
 *
 * Event description: Server call to Premium to get the quota for collaborators on the site depending on the premium package
 *
 * @param {rolesGetContributorsQuotaFromPremiumCallParams} params - The parameters for this event
 * @property {GUID} meta_site_id - msid
 * @return {LogObject<rolesGetContributorsQuotaFromPremiumCallParams>} LogObject<rolesGetContributorsQuotaFromPremiumCallParams>
 */
export function rolesGetContributorsQuotaFromPremiumCall(params) {
    return { evid: 1256502, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesGetContributorsQuotaFromPremiumCallResponse' event (evid: 1256503)
 *
 * Event description: Response from Premium on the quota for collaborators on the site depending on the premium package was received
 *
 * @param {rolesGetContributorsQuotaFromPremiumCallResponseParams} params - The parameters for this event
 * @property {number} contributors_quota - How many contributors can be added to the site based on the premium package quota (empty if the call didn't return)
 * @property {string} response - success/fail
 * @property {GUID} meta_site_id - site_id
 * @return {LogObject<rolesGetContributorsQuotaFromPremiumCallResponseParams>} LogObject<rolesGetContributorsQuotaFromPremiumCallResponseParams>
 */
export function rolesGetContributorsQuotaFromPremiumCallResponse(params) {
    return { evid: 1256503, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'roles2ndCheckIfPremiumForCollaboratorsQuotaWidget' event (evid: 1256504)
 *
 * Event description: Checking with Premium if site is premium despite getting "free site" initially when checking the quota for collaborators
 *
 * @param {roles2ndCheckIfPremiumForCollaboratorsQuotaWidgetParams} params - The parameters for this event
 * @property {GUID} meta_site_id - site id
 * @return {LogObject<roles2ndCheckIfPremiumForCollaboratorsQuotaWidgetParams>} LogObject<roles2ndCheckIfPremiumForCollaboratorsQuotaWidgetParams>
 */
export function roles2ndCheckIfPremiumForCollaboratorsQuotaWidget(params) {
    return { evid: 1256504, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersPasswordChangedSuccessfully' event (evid: 1301)
 *
 * Event description: Last stage in forget password funnel. This event fired when password succefully changed.
 *
 * @param {siteMembersPasswordChangedSuccessfullyParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {string} context - {Manually,Automatically/Reset Password success}
 * @property {GUID} vsi - vsi
 * @property {GUID} ldSessionID - --
 * @property {string} layout - full screen/pop up
 * @property {GUID} contact_id - --
 * @property {GUID} member_id - site_member_id
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersPasswordChangedSuccessfullyParams>} LogObject<siteMembersPasswordChangedSuccessfullyParams>
 */
export function siteMembersPasswordChangedSuccessfully(params) {
    return { evid: 1301, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSignUpSuccess' event (evid: 1302)
 *
 * Event description: Success Sign up
 *
 * @param {siteMembersSignUpSuccessParams} params - The parameters for this event
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} connectorId - ID of the IDP used for the signup
 * @property {string} initator - who open the component {UoU,automatically defined by user, app}
 * @property {boolean} waiting_email_confirm - does uou need to confirm their email?
 * @property {string} providerId - name of the IDP used for the signup ("wix" / "google" / "facebook")
 * @property {GUID} vsi - vsi
 * @property {string} form_type - default/custom/corvid
 * @property {GUID} app_id - if user drag it from editor enter '42'
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} layout - full screen/pop up
 * @property {GUID} contact_id - contact_id
 * @property {boolean} waiting_owner_approval - is waiting for member request approval?
 * @property {string} recaptcha - recaptcha score
 * @property {GUID} member_id - site_member_id
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersSignUpSuccessParams>} LogObject<siteMembersSignUpSuccessParams>
 */
export function siteMembersSignUpSuccess(params) {
    return { evid: 1302, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSignUpFailed' event (evid: 1303)
 *
 * Event description: Monitor the failed sign up reasons
 *
 * @param {siteMembersSignUpFailedParams} params - The parameters for this event
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} context - {Sign up manually, Social}
 * @property {GUID} connectorId - ID of the IDP used for the signup
 * @property {string} reason - display which fields was error and hence the fail {Invalid Email, Blank Fields, Password is different, Email is already in use}
 * @property {string} providerId - name of the IDP used for the signup ("wix" / "google" / "facebook")
 * @property {GUID} vsi - vsi
 * @property {string} form_type - default/custom/corvid
 * @property {GUID} ldSessionID - --
 * @property {string} layout - full screen/pop up
 * @property {string} recaptcha - recaptcha score
 * @property {GUID} member_id - site_member_id
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersSignUpFailedParams>} LogObject<siteMembersSignUpFailedParams>
 */
export function siteMembersSignUpFailed(params) {
    return { evid: 1303, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersLogInFunnelFailed' event (evid: 1304)
 *
 * Event description: Monitor the failed login reasons (include forot password funnel)
 *
 * @param {siteMembersLogInFunnelFailedParams} params - The parameters for this event
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} context - {Login/ Reset Password - mail/Reset Password - Enter Password/Social}
 * @property {GUID} connectorId - ID of the IDP used for the signup ("wix" / "google" / "facebook")
 * @property {string} reason - Reason for failed Login - {Wrong Email or password,Field cannot be blank, Email is invalid, User is blocked}
 * @property {string} providerId - name of the IDP used for the signup ("wix" / "google" / "facebook")
 * @property {GUID} vsi - vsi
 * @property {string} form_type - default/custom/corvid
 * @property {GUID} ldSessionID - --
 * @property {string} layout - full screen/pop up
 * @property {string} recaptcha - recaptcha score
 * @property {GUID} member_id - site_member_id
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersLogInFunnelFailedParams>} LogObject<siteMembersLogInFunnelFailedParams>
 */
export function siteMembersLogInFunnelFailed(params) {
    return { evid: 1304, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersLogInSuccess' event (evid: 1305)
 *
 * Event description: Success Login
 *
 * @param {siteMembersLogInSuccessParams} params - The parameters for this event
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} _visitorId - visitor_id
 * @property {GUID} connectorId - ID of the IDP used for the signup ("wix" / "google" / "facebook")
 * @property {string} initator - who open the component {UoU,automatically defined by user, app}
 * @property {GUID} visitor_id - visitor_id
 * @property {string} providerId - name of the IDP used for the signup ("wix" / "google" / "facebook")
 * @property {boolean} isSiteOwner - is_site_owner
 * @property {GUID} vsi - vsi
 * @property {string} form_type - default/custom/corvid
 * @property {GUID} app_id - ifuser drag it from editor enter '42'
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} layout - full screen/pop up
 * @property {GUID} contact_id - contact_id
 * @property {string} recaptcha - recaptcha score
 * @property {string} member_id - site_member_id
 * @property {GUID} msid - msid
 * @return {LogObject<siteMembersLogInSuccessParams>} LogObject<siteMembersLogInSuccessParams>
 */
export function siteMembersLogInSuccess(params) {
    return { evid: 1305, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersForgetPasswordFunnelServerSubmitSuccess' event (evid: 1306)
 *
 * Event description: fired when user click OK and server submit form succefully. Will be fired also if there is a security issue.
 *
 * @param {siteMembersForgetPasswordFunnelServerSubmitSuccessParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_blocked - flag indicates weather the server sends but there was a block from security.
 * @property {string} context - {Request Email/ New Password post mail}
 * @property {GUID} vsi - vsi
 * @property {GUID} ldSessionID - --
 * @property {GUID} contact_id - --
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersForgetPasswordFunnelServerSubmitSuccessParams>} LogObject<siteMembersForgetPasswordFunnelServerSubmitSuccessParams>
 */
export function siteMembersForgetPasswordFunnelServerSubmitSuccess(params) {
    return { evid: 1306, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersPleaseCheckYourEmailWindow' event (evid: 1307)
 *
 * Event description: Open Confirm Email (part of the forgot password funnel)
 *
 * @param {siteMembersPleaseCheckYourEmailWindowParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} ldSessionID - --
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersPleaseCheckYourEmailWindowParams>} LogObject<siteMembersPleaseCheckYourEmailWindowParams>
 */
export function siteMembersPleaseCheckYourEmailWindow(params) {
    return { evid: 1307, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersClickedResetPasswordLinkFromEmail' event (evid: 1308)
 *
 * Event description: Following a member's request to reset their password, the flow of clicking the email link and setting a new password was completed successfully.
 *
 * @param {siteMembersClickedResetPasswordLinkFromEmailParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} meta_site_id - msid
 * @property {GUID} vsi - vsi
 * @property {GUID} contact_id - ID of the member
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersClickedResetPasswordLinkFromEmailParams>} LogObject<siteMembersClickedResetPasswordLinkFromEmailParams>
 */
export function siteMembersClickedResetPasswordLinkFromEmail(params) {
    return { evid: 1308, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersRecaptchaRequired' event (evid: 1309)
 *
 * Event description: monitor captcha events of site members
 *
 * @param {siteMembersRecaptchaRequiredParams} params - The parameters for this event
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} reason - Reason for why the captcha is required
 * @property {GUID} vsi - vsi
 * @property {GUID} ldSessionID - --
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersRecaptchaRequiredParams>} LogObject<siteMembersRecaptchaRequiredParams>
 */
export function siteMembersRecaptchaRequired(params) {
    return { evid: 1309, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersRecaptchaValidated' event (evid: 1310)
 *
 * Event description: monitor captcha events of site members - approved captcha
 *
 * @param {siteMembersRecaptchaValidatedParams} params - The parameters for this event
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_owner - is the logged in member also the site owner
 * @property {GUID} vsi - vsi
 * @property {GUID} site_member_id - site member id
 * @property {GUID} ldSessionID - --
 * @property {GUID} contact_id - contact id of the verified member
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersRecaptchaValidatedParams>} LogObject<siteMembersRecaptchaValidatedParams>
 */
export function siteMembersRecaptchaValidated(params) {
    return { evid: 1310, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersRecaptchaFailed' event (evid: 1311)
 *
 * Event description: monitor captcha events of site members - failed captcha
 *
 * @param {siteMembersRecaptchaFailedParams} params - The parameters for this event
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} reason - reason for captcha
 * @property {GUID} vsi - vsi
 * @property {GUID} site_member_id - site member id
 * @property {GUID} ldSessionID - --
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersRecaptchaFailedParams>} LogObject<siteMembersRecaptchaFailedParams>
 */
export function siteMembersRecaptchaFailed(params) {
    return { evid: 1311, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersGotErrorFromSocialLoginProvider' event (evid: 1312)
 *
 * Event description: Error after social login click
 *
 * @param {siteMembersGotErrorFromSocialLoginProviderParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {string} socialNetwork - {FB, Google+}
 * @property {string} context - {Login/ sign up}
 * @property {GUID} vsi - vsi
 * @property {GUID} ldSessionID - --
 * @property {string} layout - full screen/pop up
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @property {string} view - {desktop,mobile}
 * @return {LogObject<siteMembersGotErrorFromSocialLoginProviderParams>} LogObject<siteMembersGotErrorFromSocialLoginProviderParams>
 */
export function siteMembersGotErrorFromSocialLoginProvider(params) {
    return { evid: 1312, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSuccessfullyVerifiedFirstSocialLoginToExistingWixAccount' event (evid: 1313)
 *
 * Event description: Success after social login click request.
 *
 * @param {siteMembersSuccessfullyVerifiedFirstSocialLoginToExistingWixAccountParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {string} socialNetwork - {FB, Google+}
 * @property {string} context - {Login/ sign up}
 * @property {GUID} vsi - vsi
 * @property {GUID} ldSessionID - --
 * @property {string} layout - full screen/pop up
 * @property {GUID} contact_id - contact_id
 * @property {GUID} member_id - site_member_id
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @property {string} view - {desktop,mobile}
 * @return {LogObject<siteMembersSuccessfullyVerifiedFirstSocialLoginToExistingWixAccountParams>} LogObject<siteMembersSuccessfullyVerifiedFirstSocialLoginToExistingWixAccountParams>
 */
export function siteMembersSuccessfullyVerifiedFirstSocialLoginToExistingWixAccount(params) {
    return { evid: 1313, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersClickedConfirmYourEmailLinkFromEmail' event (evid: 1314)
 *
 * Event description: Member clicked on the link in the Email that sent to him from Wix (part of signup flow)
 *
 * @param {siteMembersClickedConfirmYourEmailLinkFromEmailParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} invite_id - unique invite id
 * @property {GUID} msid - --
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersClickedConfirmYourEmailLinkFromEmailParams>} LogObject<siteMembersClickedConfirmYourEmailLinkFromEmailParams>
 */
export function siteMembersClickedConfirmYourEmailLinkFromEmail(params) {
    return { evid: 1314, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersDeleteMember' event (evid: 1315)
 *
 * Event description: User attempted to delete a member. Note that the event is generated from different artifacts in different scenarios: when successful is generated from "wix-sm-webapp" (and saved to sites_19), but unsuccessful due to subscription is generated from "members.members-ng-api" (and saved to users_19).
 *
 * @param {membersDeleteMemberParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} contact_id - Contact ID of attempted deleted member
 * @property {GUID} member_id - Member ID of attempted deleted member
 * @property {boolean} is_successful - Was the deletion attempt successful?
 * @property {boolean} is_bulk_action - indication of "bulk" deletion
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @property {string} reasonOfFailure - Reason for failure to delete member ('member has an active subscription')
 * @return {LogObject<membersDeleteMemberParams>} LogObject<membersDeleteMemberParams>
 */
export function membersDeleteMember(params) {
    return { evid: 1315, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersApproveMember' event (evid: 1316)
 *
 * Event description: member approved
 *
 * @param {membersApproveMemberParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} contact_id - contact_id to be approved
 * @property {GUID} member_id - member_id to be approved
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<membersApproveMemberParams>} LogObject<membersApproveMemberParams>
 */
export function membersApproveMember(params) {
    return { evid: 1316, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersBlockMember' event (evid: 1317)
 *
 * Event description: Attempt to block member (spamCleanup field indicates of it's a Wix initiated block as part of Spam cleanup process. Note that the event is generated from different artifacts in different scenarios: when successful is generated from "wix-sm-webapp" (and saved to sites_19), but unsuccessful due to subscription is generated from "members.members-ng-api" (saved to users_19).
 *
 * @param {membersBlockMemberParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {boolean} spamCleanup - 1 - Wix initiated block (part of spam effort), 0 User attempted to block member
 * @property {GUID} contact_id - Contact ID of the attempted blocked member
 * @property {GUID} member_id - Member ID of the attempted blocked member
 * @property {boolean} is_successful - Was the blocking attempt successful?
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @property {string} reasonOfFailure - Reason the attempt was failed ('member has an active subscription')
 * @return {LogObject<membersBlockMemberParams>} LogObject<membersBlockMemberParams>
 */
export function membersBlockMember(params) {
    return { evid: 1317, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersJoinAPlace' event (evid: 1318)
 *
 * Event description: When a member joins a digital place (msid). Should include the member uuid and the place msid.
 *
 * @param {membersJoinAPlaceParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} memberId - userId
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @property {string} addType - exists and connected to user / exists in site context / created (new)
 * @return {LogObject<membersJoinAPlaceParams>} LogObject<membersJoinAPlaceParams>
 */
export function membersJoinAPlace(params) {
    return { evid: 1318, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersVerificationLinkSentToEmail' event (evid: 1319)
 *
 * Event description: User signup to site and an email verification message sent
 *
 * @param {siteMembersVerificationLinkSentToEmailParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} invite_id - unique invite id
 * @property {GUID} msid - --
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersVerificationLinkSentToEmailParams>} LogObject<siteMembersVerificationLinkSentToEmailParams>
 */
export function siteMembersVerificationLinkSentToEmail(params) {
    return { evid: 1319, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersPostLoginCallToPagesEndpoint' event (evid: 1320)
 *
 * Event description: The event is sent when a site member logs in, and the "pages" endpoint (api/wix-sm/v1/authorize/{siteId}/pages) is called without an smSession cookie (the event is meant to monitor members login issues)
 *
 * @param {siteMembersPostLoginCallToPagesEndpointParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {string} initator - who open the component {UoU,automatically defined by user, app}
 * @property {string} providerId - google/facebook/apple/wix
 * @property {boolean} isSiteOwner - true/false
 * @property {GUID} vsi - vsi
 * @property {GUID} contact_id - contact_id
 * @property {string} member_id - site_member_id
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersPostLoginCallToPagesEndpointParams>} LogObject<siteMembersPostLoginCallToPagesEndpointParams>
 */
export function siteMembersPostLoginCallToPagesEndpoint(params) {
    return { evid: 1320, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersMemberLoginAttemptWithoutAnExistingEmail' event (evid: 1321)
 *
 * Event description: site member fraudulent login attempt detected
 *
 * @param {siteMembersMemberLoginAttemptWithoutAnExistingEmailParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} form_type - default/custom/corvid
 * @property {string} layout - full screen/pop up
 * @property {GUID} member_id - site_member_id
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersMemberLoginAttemptWithoutAnExistingEmailParams>} LogObject<siteMembersMemberLoginAttemptWithoutAnExistingEmailParams>
 */
export function siteMembersMemberLoginAttemptWithoutAnExistingEmail(params) {
    return { evid: 1321, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersResetMemberPasswordByOwner' event (evid: 1322)
 *
 * Event description: The user (site owner) resets the password for one of his site members
 *
 * @param {siteMembersResetMemberPasswordByOwnerParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} uuid - user id
 * @property {GUID} vsi - vsi
 * @property {string} status - success/error
 * @property {GUID} contact_id - contact_id
 * @property {string} member_id - site_member_id
 * @property {boolean} is_successful - is_successful
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @property {string} reasonOfFailure - reason_of_failure
 * @return {LogObject<siteMembersResetMemberPasswordByOwnerParams>} LogObject<siteMembersResetMemberPasswordByOwnerParams>
 */
export function siteMembersResetMemberPasswordByOwner(params) {
    return { evid: 1322, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersLogInFaild' event (evid: 1323)
 *
 * Event description: Failed to log in Login (due to PasswordNeedToBeReset)
 *
 * @param {siteMembersLogInFaildParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} failReason - failReason
 * @property {string} member_id - site_member_id
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersLogInFaildParams>} LogObject<siteMembersLogInFaildParams>
 */
export function siteMembersLogInFaild(params) {
    return { evid: 1323, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSignupRecaptchaRequired' event (evid: 1324)
 *
 * Event description: captcha required for site members signup
 *
 * @param {siteMembersSignupRecaptchaRequiredParams} params - The parameters for this event
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} reason - Reason for why the captcha is required [BlacklistedIP / BlacklistedMetaSite / EmailPatternValidationFailed / ThrottledByEmail / ThrottledByCollection / ThrottledByIP / Generic]
 * @property {GUID} vsi - vsi
 * @property {GUID} ldSessionID - --
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersSignupRecaptchaRequiredParams>} LogObject<siteMembersSignupRecaptchaRequiredParams>
 */
export function siteMembersSignupRecaptchaRequired(params) {
    return { evid: 1324, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSignupRecaptchaValidated' event (evid: 1325)
 *
 * Event description: captcha for site members signup validated
 *
 * @param {siteMembersSignupRecaptchaValidatedParams} params - The parameters for this event
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} reason - reason for captcha [BlacklistedIP / BlacklistedMetaSite / EmailPatternValidationFailed / ThrottledByEmail / ThrottledByCollection / ThrottledByIP / Generic]
 * @property {GUID} vsi - vsi
 * @property {GUID} site_member_id - site member id
 * @property {GUID} ldSessionID - --
 * @property {GUID} contact_id - contact id of the verified member
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersSignupRecaptchaValidatedParams>} LogObject<siteMembersSignupRecaptchaValidatedParams>
 */
export function siteMembersSignupRecaptchaValidated(params) {
    return { evid: 1325, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSignupRecaptchaFailed' event (evid: 1326)
 *
 * Event description: Site Members - Signup - reCaptcha Failed.
 *
 * @param {siteMembersSignupRecaptchaFailedParams} params - The parameters for this event
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} reason - reason for captcha [BlacklistedIP / BlacklistedMetaSite / EmailPatternValidationFailed / ThrottledByEmail / ThrottledByCollection / ThrottledByIP / Generic]
 * @property {GUID} vsi - vsi
 * @property {GUID} site_member_id - site member id
 * @property {GUID} ldSessionID - --
 * @property {GUID} contact_id - contact_id
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersSignupRecaptchaFailedParams>} LogObject<siteMembersSignupRecaptchaFailedParams>
 */
export function siteMembersSignupRecaptchaFailed(params) {
    return { evid: 1326, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersContactWasSetAsSiteMember' event (evid: 1327)
 *
 * Event description: The contact was set as site member by the site owner
 *
 * @param {siteMembersContactWasSetAsSiteMemberParams} params - The parameters for this event
 * @property {GUID} uuid - user id of the site owner
 * @property {GUID} contact_id - contact id
 * @return {LogObject<siteMembersContactWasSetAsSiteMemberParams>} LogObject<siteMembersContactWasSetAsSiteMemberParams>
 */
export function siteMembersContactWasSetAsSiteMember(params) {
    return { evid: 1327, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSetPasswordEmailSentToAContactSetAsSiteMember' event (evid: 1328)
 *
 * Event description: Set password email sent to a contact which was set as site member by the site owner
 *
 * @param {siteMembersSetPasswordEmailSentToAContactSetAsSiteMemberParams} params - The parameters for this event
 * @property {GUID} contact_id - contact id
 * @property {GUID} uuid - user id of the site owner
 * @return {LogObject<siteMembersSetPasswordEmailSentToAContactSetAsSiteMemberParams>} LogObject<siteMembersSetPasswordEmailSentToAContactSetAsSiteMemberParams>
 */
export function siteMembersSetPasswordEmailSentToAContactSetAsSiteMember(params) {
    return { evid: 1328, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersChangeMemberLoginEmailSuccess' event (evid: 1329)
 *
 * Event description: Members - Change Member Login Email Success.
 *
 * @param {membersChangeMemberLoginEmailSuccessParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} contact_id - contact_id of the site member
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<membersChangeMemberLoginEmailSuccessParams>} LogObject<membersChangeMemberLoginEmailSuccessParams>
 */
export function membersChangeMemberLoginEmailSuccess(params) {
    return { evid: 1329, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersChangeMemberLoginEmailFailed' event (evid: 1330)
 *
 * Event description: Site member attempted to reset password using email link
 *
 * @param {membersChangeMemberLoginEmailFailedParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} meta_site_id - msid
 * @property {GUID} vsi - vsi
 * @property {GUID} contact_id - contact_id of the site member
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<membersChangeMemberLoginEmailFailedParams>} LogObject<membersChangeMemberLoginEmailFailedParams>
 */
export function membersChangeMemberLoginEmailFailed(params) {
    return { evid: 1330, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSignupRecaptchaTokenSent' event (evid: 1331)
 *
 * Event description: reCaptcha Token was sent to server during reCaptcha verification on signup
 *
 * @param {siteMembersSignupRecaptchaTokenSentParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {string} reason - reason for captcha
 * @property {GUID} vsi - vsi
 * @property {GUID} site_member_id - site member id
 * @property {GUID} ldSessionID - --
 * @property {GUID} contact_id - contact id of the verified member
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersSignupRecaptchaTokenSentParams>} LogObject<siteMembersSignupRecaptchaTokenSentParams>
 */
export function siteMembersSignupRecaptchaTokenSent(params) {
    return { evid: 1331, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersLoginRecaptchaTokenSent' event (evid: 1332)
 *
 * Event description: reCaptcha Token was sent to server during reCaptcha verification on login
 *
 * @param {siteMembersLoginRecaptchaTokenSentParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {string} reason - reason for captcha
 * @property {GUID} vsi - vsi
 * @property {GUID} site_member_id - site member id
 * @property {GUID} ldSessionID - --
 * @property {GUID} contact_id - contact id of the verified member
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersLoginRecaptchaTokenSentParams>} LogObject<siteMembersLoginRecaptchaTokenSentParams>
 */
export function siteMembersLoginRecaptchaTokenSent(params) {
    return { evid: 1332, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersFacebookSignUpTokenUsedInSite' event (evid: 1338)
 *
 * Event description: Facebook sign up token was used in site (should be used once --> this event is used to monitor irregular activity where token is used again)
 *
 * @param {siteMembersFacebookSignUpTokenUsedInSiteParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {string} collection_id - Original site to use the FB token (unique installation ID per site)
 * @property {string} target_collection_id - unique installation ID for the site in which the token is currently used
 * @property {GUID} vsi - vsi
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersFacebookSignUpTokenUsedInSiteParams>} LogObject<siteMembersFacebookSignUpTokenUsedInSiteParams>
 */
export function siteMembersFacebookSignUpTokenUsedInSite(params) {
    return { evid: 1338, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersEmailConfirmationForNewMembersCodeValidationSuccess' event (evid: 1342)
 *
 * Event description: Members successfully enters the 6 digit OTP sent to their email and successfully email is verified
 *
 * @param {siteMembersEmailConfirmationForNewMembersCodeValidationSuccessParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersEmailConfirmationForNewMembersCodeValidationSuccessParams>} LogObject<siteMembersEmailConfirmationForNewMembersCodeValidationSuccessParams>
 */
export function siteMembersEmailConfirmationForNewMembersCodeValidationSuccess(params) {
    return { evid: 1342, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersEmailConfirmationForNewMembersCodeValidationFail' event (evid: 1343)
 *
 * Event description: Members enters the 6 digit OTP sent to their email but validation failed
 *
 * @param {siteMembersEmailConfirmationForNewMembersCodeValidationFailParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {string} reason - Reason for failure
 * @property {GUID} vsi - vsi
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersEmailConfirmationForNewMembersCodeValidationFailParams>} LogObject<siteMembersEmailConfirmationForNewMembersCodeValidationFailParams>
 */
export function siteMembersEmailConfirmationForNewMembersCodeValidationFail(params) {
    return { evid: 1343, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersRegistrationEmailConfirmationSettingsChange' event (evid: 1344)
 *
 * Event description: User has changed the settings for email confirmation requirement for members registration:
 * "enabled-during" (member will be required to validate the email during the signup) / "enabled-after" (member will be required to validate the email after the signup) / "disabled"
 *
 * @param {siteMembersRegistrationEmailConfirmationSettingsChangeParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} selection - "enabled-during" / "enabled-after" / "disabled"
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersRegistrationEmailConfirmationSettingsChangeParams>} LogObject<siteMembersRegistrationEmailConfirmationSettingsChangeParams>
 */
export function siteMembersRegistrationEmailConfirmationSettingsChange(params) {
    return { evid: 1344, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersWhoCanBeAMemberSettingsChange' event (evid: 1345)
 *
 * Event description: User has changed the settings for "who can be a member" requirement for members registration (everyone / only people I approve)
 *
 * @param {siteMembersWhoCanBeAMemberSettingsChangeParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} selection - "everyone-who-signs-up" / "people-i-approve"
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersWhoCanBeAMemberSettingsChangeParams>} LogObject<siteMembersWhoCanBeAMemberSettingsChangeParams>
 */
export function siteMembersWhoCanBeAMemberSettingsChange(params) {
    return { evid: 1345, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSignupRecaptchaSettingsChange' event (evid: 1346)
 *
 * Event description: User has changed the settings for reCAPTCHA requirement for members registration (disable / always / invisible = challenge only for suspected bots)
 *
 * @param {siteMembersSignupRecaptchaSettingsChangeParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} selection - "enabled-always" / "enabled-invisible" / "disable"
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersSignupRecaptchaSettingsChangeParams>} LogObject<siteMembersSignupRecaptchaSettingsChangeParams>
 */
export function siteMembersSignupRecaptchaSettingsChange(params) {
    return { evid: 1346, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersLoginRecaptchaSettingsChange' event (evid: 1347)
 *
 * Event description: User has changed the settings for reCAPTCHA requirement for members login (disable / always / invisible = challenge only for suspected bots)
 *
 * @param {siteMembersLoginRecaptchaSettingsChangeParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} selection - "enabled-always" / "enabled-invisible" / "disable"
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersLoginRecaptchaSettingsChangeParams>} LogObject<siteMembersLoginRecaptchaSettingsChangeParams>
 */
export function siteMembersLoginRecaptchaSettingsChange(params) {
    return { evid: 1347, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSignupAttempt' event (evid: 1348)
 *
 * Event description: A member attempted to sign-up to the site using credential (email + password).
 *
 * @param {siteMembersSignupAttemptParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} ldSessionID - site members signup session id
 * @property {GUID} contact_id - contact_id
 * @property {GUID} msid - the site the member tried to signup to
 * @property {GUID} _visitorId - visitor_id
 * @property {GUID} metaSiteId - the site the member tried to signup to
 * @return {LogObject<siteMembersSignupAttemptParams>} LogObject<siteMembersSignupAttemptParams>
 */
export function siteMembersSignupAttempt(params) {
    return { evid: 1348, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersLoginAttempt' event (evid: 1349)
 *
 * Event description: A member attempted to login to the site using credential (email + password).
 *
 * @param {siteMembersLoginAttemptParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {string} provider_id - name of the IDP used for the signup ("wix" / "google" / "facebook")
 * @property {GUID} vsi - vsi
 * @property {GUID} ldSessionID - site members signup session id
 * @property {GUID} msid - the site the member tried to signup to
 * @property {GUID} _visitorId - visitor_id
 * @property {GUID} contactid - site member id
 * @property {GUID} metaSiteId - the site the member tried to signup to
 * @return {LogObject<siteMembersLoginAttemptParams>} LogObject<siteMembersLoginAttemptParams>
 */
export function siteMembersLoginAttempt(params) {
    return { evid: 1349, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersIdpAuthenticationAttempt' event (evid: 1350)
 *
 * Event description: A member attempted to sign-up/login to the site using an IDP (social / SSO). Connection ID can be correlated with the IDP's name (Google, Facebook etc.).
 *
 * @param {siteMembersIdpAuthenticationAttemptParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} connectionId - connection_id
 * @property {GUID} metaSiteId - msid
 * @return {LogObject<siteMembersIdpAuthenticationAttemptParams>} LogObject<siteMembersIdpAuthenticationAttemptParams>
 */
export function siteMembersIdpAuthenticationAttempt(params) {
    return { evid: 1350, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersBiTableUpdate' event (evid: 1351)
 *
 * Event description: The production table of "wix_sitemembers" has been updated - this event indicated the contact IDs changed in the table and used for the update process of the Identity DWH table "site_members_enriched"
 *
 * @param {siteMembersBiTableUpdateParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} collectionId - collection ID is the Site members instance id on the site - can be connected to MSID using WT
 * @property {string} object - object containing the columns and values of the updated contact id
 * @property {boolean} isDeleted - bool indicator if deleted
 * @property {GUID} vsi - vsi
 * @property {GUID} contactId - contact_id of updated members
 * @property {GUID} memberId - the site member ID as appears in the production table
 * @property {GUID} msid - msid of the members
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteMembersBiTableUpdateParams>} LogObject<siteMembersBiTableUpdateParams>
 */
export function siteMembersBiTableUpdate(params) {
    return { evid: 1351, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSsoSettingsActivationStatusUpdate' event (evid: 1352)
 *
 * Event description: Site owner changed the SSO activation status of site
 *
 * @param {siteMembersSsoSettingsActivationStatusUpdateParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} msid - msid
 * @property {GUID} _visitorId - visitor_id
 * @property {string} connection_status - enabled / disabled
 * @return {LogObject<siteMembersSsoSettingsActivationStatusUpdateParams>} LogObject<siteMembersSsoSettingsActivationStatusUpdateParams>
 */
export function siteMembersSsoSettingsActivationStatusUpdate(params) {
    return { evid: 1352, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSsoSettingsIsRequiredStatusUpdate' event (evid: 1353)
 *
 * Event description: Site owner changed the SSO is required status of site
 *
 * @param {siteMembersSsoSettingsIsRequiredStatusUpdateParams} params - The parameters for this event
 * @property {boolean} is_sso_required - 'true' = mandatory, 'false' = optional
 * @return {LogObject<siteMembersSsoSettingsIsRequiredStatusUpdateParams>} LogObject<siteMembersSsoSettingsIsRequiredStatusUpdateParams>
 */
export function siteMembersSsoSettingsIsRequiredStatusUpdate(params) {
    return { evid: 1353, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersAssignMemberToGroup' event (evid: 2101)
 *
 * Event description: assign members to role/group
 *
 * @param {membersAssignMemberToGroupParams} params - The parameters for this event
 * @property {GUID} group_id - group id
 * @property {string} initiator_name - who initiate the assign
 * @property {GUID} visitor_id - visitor id
 * @property {GUID} memberId - member id
 * @property {GUID} contact_id - contact_id of the member
 * @property {GUID} msid - msid
 * @return {LogObject<membersAssignMemberToGroupParams>} LogObject<membersAssignMemberToGroupParams>
 */
export function membersAssignMemberToGroup(params) {
    return { evid: 2101, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersNewGroupCreated' event (evid: 2102)
 *
 * Event description: new group created
 *
 * @param {membersNewGroupCreatedParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {string} initiator_name - roles/paid plans
 * @property {GUID} msid - msid
 * @property {string} group - group name
 * @return {LogObject<membersNewGroupCreatedParams>} LogObject<membersNewGroupCreatedParams>
 */
export function membersNewGroupCreated(params) {
    return { evid: 2102, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersEditGroup' event (evid: 2106)
 *
 * Event description: member group edited
 *
 * @param {membersEditGroupParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {GUID} msid - msid
 * @property {string} group - group new name
 * @return {LogObject<membersEditGroupParams>} LogObject<membersEditGroupParams>
 */
export function membersEditGroup(params) {
    return { evid: 2106, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersDeleteGroup' event (evid: 2107)
 *
 * Event description: member group deleted
 *
 * @param {membersDeleteGroupParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {GUID} msid - msid
 * @property {string} group - group name
 * @return {LogObject<membersDeleteGroupParams>} LogObject<membersDeleteGroupParams>
 */
export function membersDeleteGroup(params) {
    return { evid: 2107, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersGroupPermissionDeleted' event (evid: 2108)
 *
 * Event description: group permission changed (delete)
 *
 * @param {membersGroupPermissionDeletedParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {string} resource_type - page_id
 * @property {GUID} resource - deprecated
 * @property {string} permission_id - permission id
 * @property {GUID} msid - msid
 * @return {LogObject<membersGroupPermissionDeletedParams>} LogObject<membersGroupPermissionDeletedParams>
 */
export function membersGroupPermissionDeleted(params) {
    return { evid: 2108, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersDeleteMemberFromGroup' event (evid: 2109)
 *
 * Event description: delete member from group
 *
 * @param {membersDeleteMemberFromGroupParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {GUID} visitor_id - visitor id
 * @property {GUID} contact_id - contact_id of the member
 * @property {GUID} msid - msid
 * @return {LogObject<membersDeleteMemberFromGroupParams>} LogObject<membersDeleteMemberFromGroupParams>
 */
export function membersDeleteMemberFromGroup(params) {
    return { evid: 2109, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersGroupPermissionAdded' event (evid: 2110)
 *
 * Event description: group permission changed (add)
 *
 * @param {membersGroupPermissionAddedParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {string} resource_type - page_id
 * @property {GUID} resource - deprecated
 * @property {string} permission_id - permission id
 * @property {GUID} msid - msid
 * @return {LogObject<membersGroupPermissionAddedParams>} LogObject<membersGroupPermissionAddedParams>
 */
export function membersGroupPermissionAdded(params) {
    return { evid: 2110, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesAddRoleInviteSendStart' event (evid: 3000)
 *
 * Event description: user clicked on 'invite' in add role window - server start
 *
 * @param {rolesAddRoleInviteSendStartParams} params - The parameters for this event
 * @property {GUID} meta_site_id - msid
 * @property {GUID} metaSiteId - msid
 * @property {GUID} uuid - uuid
 * @property {GUID} givenBy - uuid that invited a contributor
 * @property {string} inviteEmail - invited email - deprecated
 * @property {GUID} msid - msid
 * @return {LogObject<rolesAddRoleInviteSendStartParams>} LogObject<rolesAddRoleInviteSendStartParams>
 */
export function rolesAddRoleInviteSendStart(params) {
    return { evid: 3000, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesAddRoleInviteSendEnd' event (evid: 3001)
 *
 * Event description: user clicked on 'invite' in add role window - server end
 *
 * @param {rolesAddRoleInviteSendEndParams} params - The parameters for this event
 * @property {GUID} meta_site_id
 * @property {GUID} metaSiteId
 * @property {GUID} sent_by_identity_id - sent_by_identity_id
 * @property {string} policyIds - invite role ids
 * @property {GUID} invited_uuid - invited_uuid
 * @property {GUID} uuid - uuid
 * @property {string} inviteRole - invited role
 * @property {GUID} givenBy - uuid that invited a contributor
 * @property {string} inviteEmail - invited email, deprecated
 * @property {GUID} inviteId - invite id
 * @property {GUID} msid
 * @property {string} sent_by_identity_type - sent_by_identity_type
 * @return {LogObject<rolesAddRoleInviteSendEndParams>} LogObject<rolesAddRoleInviteSendEndParams>
 */
export function rolesAddRoleInviteSendEnd(params) {
    return { evid: 3001, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesResendEmailInvitationStart' event (evid: 3002)
 *
 * Event description: user clicked on 'resend' invite - server start
 *
 * @param {rolesResendEmailInvitationStartParams} params - The parameters for this event
 * @property {GUID} meta_site_id - msid
 * @property {GUID} metaSiteId - msid
 * @property {GUID} uuid - uuid
 * @property {GUID} msid - msid
 * @return {LogObject<rolesResendEmailInvitationStartParams>} LogObject<rolesResendEmailInvitationStartParams>
 */
export function rolesResendEmailInvitationStart(params) {
    return { evid: 3002, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesResendEmailInvitationEnd' event (evid: 3003)
 *
 * Event description: user clicked on 'resend' invite - server end
 *
 * @param {rolesResendEmailInvitationEndParams} params - The parameters for this event
 * @property {GUID} meta_site_id - msid
 * @property {GUID} metaSiteId - msid
 * @property {string} policyIds - the policy ids (role ids) chosen in the invite
 * @property {GUID} uuid - uuid
 * @property {string} inviteRole - invite role
 * @property {string} inviteEmail - invited email, deprecated
 * @property {GUID} inviteId - invite id
 * @property {GUID} msid - msid
 * @return {LogObject<rolesResendEmailInvitationEndParams>} LogObject<rolesResendEmailInvitationEndParams>
 */
export function rolesResendEmailInvitationEnd(params) {
    return { evid: 3003, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesAddRoleAcceptFromEmailView' event (evid: 3004)
 *
 * Event description: When a user clicks to accept an invite from email page view
 *
 * @param {rolesAddRoleAcceptFromEmailViewParams} params - The parameters for this event
 * @property {GUID} meta_site_id - msid
 * @property {GUID} metaSiteId - msid
 * @property {string} policyIds - invite role ids
 * @property {GUID} uuid - uuid
 * @property {GUID} inviteId - invite id
 * @property {GUID} msid - msid
 * @return {LogObject<rolesAddRoleAcceptFromEmailViewParams>} LogObject<rolesAddRoleAcceptFromEmailViewParams>
 */
export function rolesAddRoleAcceptFromEmailView(params) {
    return { evid: 3004, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesLoginSignupAuthorizationRequest' event (evid: 3005)
 *
 * Event description: mail accepted - server check login request -inviteAcceptBegin
 *
 * @param {rolesLoginSignupAuthorizationRequestParams} params - The parameters for this event
 * @property {GUID} meta_site_id - msid
 * @property {GUID} metaSiteId - msid
 * @property {GUID} uuid - uuid
 * @property {GUID} msid - msid
 * @return {LogObject<rolesLoginSignupAuthorizationRequestParams>} LogObject<rolesLoginSignupAuthorizationRequestParams>
 */
export function rolesLoginSignupAuthorizationRequest(params) {
    return { evid: 3005, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesLoginSignupAuthorizationRequestSuccess' event (evid: 3006)
 *
 * Event description: mail accepted - server check login request -inviteAcceptEnd
 *
 * @param {rolesLoginSignupAuthorizationRequestSuccessParams} params - The parameters for this event
 * @property {GUID} meta_site_id - msid
 * @property {GUID} metaSiteId - msid
 * @property {string} policyIds - invite role ids
 * @property {GUID} invitedByAccountId - the account id that sent the invite
 * @property {GUID} uuid - uuid
 * @property {GUID} acceptedBy - uuid of accepted user
 * @property {GUID} givenBy - user id that invited a contributor
 * @property {GUID} inviteId - invite id
 * @property {GUID} msid - msid
 * @property {string} acceptEmail - accepted email, deprecated
 * @return {LogObject<rolesLoginSignupAuthorizationRequestSuccessParams>} LogObject<rolesLoginSignupAuthorizationRequestSuccessParams>
 */
export function rolesLoginSignupAuthorizationRequestSuccess(params) {
    return { evid: 3006, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesDeleteInviteRoleDeleteClickServer' event (evid: 3007)
 *
 * Event description: user clicked on 'delete' role
 *
 * @param {rolesDeleteInviteRoleDeleteClickServerParams} params - The parameters for this event
 * @property {GUID} meta_site_id - msid
 * @property {GUID} metaSiteId - msid
 * @property {GUID} uuid - uuid
 * @property {GUID} msid - msid
 * @return {LogObject<rolesDeleteInviteRoleDeleteClickServerParams>} LogObject<rolesDeleteInviteRoleDeleteClickServerParams>
 */
export function rolesDeleteInviteRoleDeleteClickServer(params) {
    return { evid: 3007, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesDeleteInviteRoleDeleteClickSuccessServer' event (evid: 3008)
 *
 * Event description: user clicked on 'delete' role - success response
 *
 * @param {rolesDeleteInviteRoleDeleteClickSuccessServerParams} params - The parameters for this event
 * @property {GUID} meta_site_id - msid
 * @property {GUID} metaSiteId - msid
 * @property {string} policyIds - role ids
 * @property {GUID} uuid - uuid
 * @property {GUID} inviteId - invite id
 * @property {GUID} msid - msid
 * @return {LogObject<rolesDeleteInviteRoleDeleteClickSuccessServerParams>} LogObject<rolesDeleteInviteRoleDeleteClickSuccessServerParams>
 */
export function rolesDeleteInviteRoleDeleteClickSuccessServer(params) {
    return { evid: 3008, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesInviteExpired' event (evid: 3009)
 *
 * Event description: invite expired - because the 30 day limitation passed or because the owner deleted the invite before it was accepted
 *
 * @param {rolesInviteExpiredParams} params - The parameters for this event
 * @property {GUID} meta_site_id - msid
 * @property {GUID} metaSiteId - msid
 * @property {GUID} uuid - uuid
 * @property {string} errorDesc - expired time or expired delete
 * @property {string} inviteEmail - invited email, deprecated
 * @property {GUID} inviteId - invite id
 * @property {GUID} msid - msid
 * @return {LogObject<rolesInviteExpiredParams>} LogObject<rolesInviteExpiredParams>
 */
export function rolesInviteExpired(params) {
    return { evid: 3009, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesWelcomeScreenPageView' event (evid: 3010)
 *
 * Event description: page view of the welcome screen after clicking on accept invite from email
 *
 * @param {rolesWelcomeScreenPageViewParams} params - The parameters for this event
 * @property {GUID} meta_site_id - msid
 * @property {GUID} metaSiteId - msid
 * @property {boolean} isMobile - true if the page is seen from mobile
 * @property {string} inviteeType - the type of the invite, Studio or Wix
 * @property {GUID} uuid - uuid
 * @property {GUID} acceptedBy - uuid of accepted user
 * @property {string} origin - opened the page from email/direct link
 * @property {GUID} givenBy - uuid that invited a contributor
 * @property {boolean} alreadyAccepted - true id invite was already accepted
 * @property {GUID} inviteId - invite id
 * @property {GUID} msid - msid
 * @return {LogObject<rolesWelcomeScreenPageViewParams>} LogObject<rolesWelcomeScreenPageViewParams>
 */
export function rolesWelcomeScreenPageView(params) {
    return { evid: 3010, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesMobileAcceptPageView' event (evid: 3011)
 *
 * Event description: page view after the welcome screen, in case the user accepted from mobile
 *
 * @param {rolesMobileAcceptPageViewParams} params - The parameters for this event
 * @property {GUID} meta_site_id - msid
 * @property {GUID} metaSiteId - msid
 * @property {GUID} uuid - uuid
 * @property {GUID} acceptedBy - uuid of accepted user
 * @property {string} origin - opened the page from email/direct link
 * @property {GUID} givenBy - uuid that invited a contributor
 * @property {GUID} inviteId - invite id
 * @property {GUID} msid - msid
 * @return {LogObject<rolesMobileAcceptPageViewParams>} LogObject<rolesMobileAcceptPageViewParams>
 */
export function rolesMobileAcceptPageView(params) {
    return { evid: 3011, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesSetUserWorkspaceAsStudioContributors' event (evid: 3017)
 *
 * Event description: When we set the user workspace to Studio after the user accepted the invite to contribute to a site.
 *
 * @param {rolesSetUserWorkspaceAsStudioContributorsParams} params - The parameters for this event
 * @property {GUID} acceptedBy - user_id of accepted user
 * @property {GUID} invite_id - the invite_id
 * @property {GUID} givenBy - user id that invited a contributor
 * @return {LogObject<rolesSetUserWorkspaceAsStudioContributorsParams>} LogObject<rolesSetUserWorkspaceAsStudioContributorsParams>
 */
export function rolesSetUserWorkspaceAsStudioContributors(params) {
    return { evid: 3017, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'teamCollaborationAssignStatusUpdated' event (evid: 3021)
 *
 * Event description: when assign status change due to:
 * -manual assign/unassigned by site owner
 * -contributor was deleted from site
 *
 * Event Explain:
 * https://docs.google.com/presentation/d/1ehSNHHF-9jOEvmMj3dnfrJgw3uY8TP-dlqPB6rzBczA/edit?usp=sharing
 *
 * @param {teamCollaborationAssignStatusUpdatedParams} params - The parameters for this event
 * @property {string} contributor_id - id of the assignee, triggered as array
 * @property {GUID} workflow_id - deprecate
 * @property {string} contact_id - deprecate
 * @property {string} task_id - deprecate
 * @property {GUID} msid - msid
 * @property {string} value - ’assign / unassign’
 * @return {LogObject<teamCollaborationAssignStatusUpdatedParams>} LogObject<teamCollaborationAssignStatusUpdatedParams>
 */
export function teamCollaborationAssignStatusUpdated(params) {
    return { evid: 3021, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'teamCollaborationAssignStatusUpdatedServer' event (evid: 3022)
 *
 * Event description: when assign status change due to:
 * -manual assign/unassigned by site owner
 * -contributor was deleted from site
 *
 * Event Explain:
 * https://docs.google.com/presentation/d/1ehSNHHF-9jOEvmMj3dnfrJgw3uY8TP-dlqPB6rzBczA/edit?usp=sharing
 *
 * @param {teamCollaborationAssignStatusUpdatedServerParams} params - The parameters for this event
 * @property {string} id - unique id for item
 * @property {string} contributor_id - id of the assignee, triggered as array
 * @property {string} type - tasks/contact/workflow
 * @property {GUID} msid - msid
 * @property {string} value - ’assign / unassign’
 * @property {number} number_of_items - for bulk actions
 * @return {LogObject<teamCollaborationAssignStatusUpdatedServerParams>} LogObject<teamCollaborationAssignStatusUpdatedServerParams>
 */
export function teamCollaborationAssignStatusUpdatedServer(params) {
    return { evid: 3022, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'teamManagementAddMembersInviteSendEnd' event (evid: 3031)
 *
 * Event description: When a user clicks on 'invite' in add team members window - server end (Account level)
 *
 * @param {teamManagementAddMembersInviteSendEndParams} params - The parameters for this event
 * @property {GUID} givenByUser - the user ID that invited the member
 * @property {GUID} sent_by_identity_id - the id of the entity that sent the invite: user_id for type=user, and app_def_id for identity=app
 * @property {string} policyIds - invite role_ids
 * @property {GUID} invitedToAccountId - the account ID that the invitee is invited to
 * @property {string} inviteRole - invited role
 * @property {string} hashed_mail - hashed mail of the person who got this email
 * @property {GUID} givenByAccountId - the account ID that invited the member
 * @property {string} invite_type - all (all sites & folders) / specific (specific sites & folders)
 * @property {GUID} inviteId - invite ID
 * @property {number} num_sites - number of sites included in the invite, if it was specific
 * @property {string} sent_by_identity_type - The identity type of the entity that sent the invite - user/app
 * @property {number} num_folders - number of folders included in the invite, if it was specific
 * @property {GUID} metaSiteId - msid
 * @return {LogObject<teamManagementAddMembersInviteSendEndParams>} LogObject<teamManagementAddMembersInviteSendEndParams>
 */
export function teamManagementAddMembersInviteSendEnd(params) {
    return { evid: 3031, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'teamManagementRemoveMembersPostRemovalRequestSuccess' event (evid: 3032)
 *
 * Event description: when the server finishes to remove the user from the team
 *
 * @param {teamManagementRemoveMembersPostRemovalRequestSuccessParams} params - The parameters for this event
 * @property {GUID} removedFromAccountId - the account ID that the user is removed from
 * @property {GUID} removedByUserId - the user id that removed the member
 * @property {GUID} removedUserId - user id of the user that was removed from the team
 * @return {LogObject<teamManagementRemoveMembersPostRemovalRequestSuccessParams>} LogObject<teamManagementRemoveMembersPostRemovalRequestSuccessParams>
 */
export function teamManagementRemoveMembersPostRemovalRequestSuccess(params) {
    return { evid: 3032, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'teamManagementMemberChangedRolePostChangeRequestSuccess' event (evid: 3033)
 *
 * Event description: when the server finishes to change the user role in the team
 *
 * @param {teamManagementMemberChangedRolePostChangeRequestSuccessParams} params - The parameters for this event
 * @property {string} newRole - the new role of the user
 * @property {GUID} changedByUserId - the user id that invited a member (user that sent the invite)
 * @property {GUID} changedInAccountId - the account ID that invited the member
 * @property {GUID} changedUserId - user id of the user that accepted the invite (not necessarily the user that received the email)
 * @return {LogObject<teamManagementMemberChangedRolePostChangeRequestSuccessParams>} LogObject<teamManagementMemberChangedRolePostChangeRequestSuccessParams>
 */
export function teamManagementMemberChangedRolePostChangeRequestSuccess(params) {
    return { evid: 3033, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'teamManagementAddMembersAcceptFromEmailView' event (evid: 3034)
 *
 * Event description: When a user clicks to accept an invite from email page view
 *
 * @param {teamManagementAddMembersAcceptFromEmailViewParams} params - The parameters for this event
 * @property {GUID} invitedToAccountId - the account ID that the invitee is invited to
 * @property {GUID} givenByAccountId - the account ID that invited the member
 * @property {GUID} inviteId - invite ID
 * @return {LogObject<teamManagementAddMembersAcceptFromEmailViewParams>} LogObject<teamManagementAddMembersAcceptFromEmailViewParams>
 */
export function teamManagementAddMembersAcceptFromEmailView(params) {
    return { evid: 3034, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'teamManagementAddMembersPostSignupRequestSuccess' event (evid: 3036)
 *
 * Event description: After the welcome invite sign up flow, the server finishes the acceptance flow - inviteAcceptEnd
 *
 * @param {teamManagementAddMembersPostSignupRequestSuccessParams} params - The parameters for this event
 * @property {GUID} givenByUser - the user id that invited a member (user that sent the invite)
 * @property {string} policyIds - invite role_ids
 * @property {GUID} invitedToAccountId - the account ID that the invitee is invited to
 * @property {string} invite_policy_ids - The invite policy ids (role ids)
 * @property {string} inviteRole - the role that was sent in the invite
 * @property {string} hashed_mail - the hashed mail of the person who accepted this invite
 * @property {GUID} givenByAccountId - the account ID that invited the member
 * @property {string} invite_type - all/specific
 * @property {GUID} acceptedByUser - user id of the user that accepted the invite (not necessarily the user that received the email)
 * @property {GUID} inviteId - invite ID
 * @property {number} num_sites - the number of sites in the invite, if it's specific
 * @property {number} num_folders - the number of folders in the invite, if it's specific
 * @property {GUID} metaSiteId - msid
 * @return {LogObject<teamManagementAddMembersPostSignupRequestSuccessParams>} LogObject<teamManagementAddMembersPostSignupRequestSuccessParams>
 */
export function teamManagementAddMembersPostSignupRequestSuccess(params) {
    return { evid: 3036, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'teamManagementRemoveInvitePostRemovalRequestSuccess' event (evid: 3037)
 *
 * Event description: when the server finishes to remove the invite (before it gets approved by the user - proposal phase)
 *
 * @param {teamManagementRemoveInvitePostRemovalRequestSuccessParams} params - The parameters for this event
 * @property {GUID} givenByUser - the user id that invited a member (user that sent the invite)
 * @property {GUID} invitedToAccountId - the account ID that the invitee is invited to
 * @property {string} inviteRole - the role that was sent in the invite
 * @property {GUID} givenByAccountId - the account ID that invited the member
 * @property {string} invite_role_id - the invite role_id
 * @property {GUID} inviteId - invite ID
 * @return {LogObject<teamManagementRemoveInvitePostRemovalRequestSuccessParams>} LogObject<teamManagementRemoveInvitePostRemovalRequestSuccessParams>
 */
export function teamManagementRemoveInvitePostRemovalRequestSuccess(params) {
    return { evid: 3037, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'teamManagementUpdateInvitePostUpdateRequestSuccess' event (evid: 3038)
 *
 * Event description: when the server finishes to update the invite (before it gets approved by the user - proposal phase)
 *
 * @param {teamManagementUpdateInvitePostUpdateRequestSuccessParams} params - The parameters for this event
 * @property {GUID} givenByUser - the user id that invited a member (user that sent the invite)
 * @property {GUID} invitedToAccountId - the account ID that the invitee is invited to
 * @property {string} inviteRole - the role that was sent in the invite
 * @property {GUID} givenByAccountId - the account ID that invited the member
 * @property {string} invite_role_id - the invite role_id
 * @property {GUID} inviteId - invite ID
 * @return {LogObject<teamManagementUpdateInvitePostUpdateRequestSuccessParams>} LogObject<teamManagementUpdateInvitePostUpdateRequestSuccessParams>
 */
export function teamManagementUpdateInvitePostUpdateRequestSuccess(params) {
    return { evid: 3038, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'teamManagementInviteExpired' event (evid: 3039)
 *
 * Event description: invite expired - because the 30 day limitation passed or because the team account deleted the invite before it was accepted
 *
 * @param {teamManagementInviteExpiredParams} params - The parameters for this event
 * @property {GUID} givenByUser - the user ID that invited a member (user that sent the invite)
 * @property {GUID} invitedToAccountId - the account ID that the invitee is invited to
 * @property {string} errorDesc - the error description
 * @property {GUID} inviteId - invite ID
 * @return {LogObject<teamManagementInviteExpiredParams>} LogObject<teamManagementInviteExpiredParams>
 */
export function teamManagementInviteExpired(params) {
    return { evid: 3039, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'teamManagementWelcomeScreenPageView' event (evid: 3040)
 *
 * Event description: Page view of the welcome screen after clicking on accept invite from email
 *
 * @param {teamManagementWelcomeScreenPageViewParams} params - The parameters for this event
 * @property {boolean} isMobile - true if the page is seen from mobile
 * @property {GUID} invitedToAccountId - the account ID that the invitee is invited to
 * @property {string} origin - opened the page from email/direct link
 * @property {boolean} alreadyAccepted - true id invite was already accepted
 * @property {GUID} acceptedByUser - user ID of the user that accepted the invite (not necessarily the user that received the email)
 * @property {GUID} inviteId - invite ID
 * @property {boolean} isLoggedIn - true/false if the user arrived to this page when he was already logged in
 * @return {LogObject<teamManagementWelcomeScreenPageViewParams>} LogObject<teamManagementWelcomeScreenPageViewParams>
 */
export function teamManagementWelcomeScreenPageView(params) {
    return { evid: 3040, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'teamManagementCreateRole' event (evid: 3041)
 *
 * Event description: The user created a new custom role, account/site level
 *
 * @param {teamManagementCreateRoleParams} params - The parameters for this event
 * @property {string} custom_role_scopes - the scopes chosen for the custom role
 * @property {number} num_scopes - number of scopes chosen for the role
 * @property {string} context - site/account
 * @property {string} role_id - the new role_id
 * @return {LogObject<teamManagementCreateRoleParams>} LogObject<teamManagementCreateRoleParams>
 */
export function teamManagementCreateRole(params) {
    return { evid: 3041, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'teamManagementUpdateRole' event (evid: 3042)
 *
 * Event description: The user updated an existing custom role
 *
 * @param {teamManagementUpdateRoleParams} params - The parameters for this event
 * @property {string} prev_custom_role_scopes - the previous scopes chosen for the custom roles
 * @property {number} num_scopes - number of scopes chosen for the role
 * @property {string} new_custom_role_scopes - the new scopes chosen for the custom role
 * @property {string} role_id - the role_id
 * @return {LogObject<teamManagementUpdateRoleParams>} LogObject<teamManagementUpdateRoleParams>
 */
export function teamManagementUpdateRole(params) {
    return { evid: 3042, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'teamManagementDeleteRole' event (evid: 3043)
 *
 * Event description: The user deleted a custom role
 *
 * @param {teamManagementDeleteRoleParams} params - The parameters for this event
 * @property {number} num_scopes - deprecated
 * @property {string} role_id - the role_id
 * @return {LogObject<teamManagementDeleteRoleParams>} LogObject<teamManagementDeleteRoleParams>
 */
export function teamManagementDeleteRole(params) {
    return { evid: 3043, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'teamManagementUpdateTeammateRole' event (evid: 3044)
 *
 * Event description: The user changed the role of a teammate/team
 *
 * @param {teamManagementUpdateTeammateRoleParams} params - The parameters for this event
 * @property {GUID} teammate_id - the account_id of the team/teammate who's role is being updated
 * @property {string} new_role_ids - new role ids
 * @property {string} prev_role_ids - previous role ids
 * @property {GUID} updated_on_account_id - the account id to which the user who's role is being updated belongs to
 * @property {string} assignment_type - assignment_type
 * @property {string} invite_type - all/specific
 * @property {string} num_of_sites - number of sites in specific update
 * @property {number} num_sites - num_sites
 * @property {number} num_folders - number of folders in specific update
 * @return {LogObject<teamManagementUpdateTeammateRoleParams>} LogObject<teamManagementUpdateTeammateRoleParams>
 */
export function teamManagementUpdateTeammateRole(params) {
    return { evid: 3044, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'teamManagementRemoveTeammate' event (evid: 3045)
 *
 * Event description: The user removed a member from his account/site team - server success
 *
 * @param {teamManagementRemoveTeammateParams} params - The parameters for this event
 * @property {GUID} removed_from_account_id - the account_id that the user is removed from
 * @property {GUID} teammate_id - the account_id of the removed team/teammate (if status is pending then invite_id)
 * @return {LogObject<teamManagementRemoveTeammateParams>} LogObject<teamManagementRemoveTeammateParams>
 */
export function teamManagementRemoveTeammate(params) {
    return { evid: 3045, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'coBrandingUserColoredForCoBranding' event (evid: 3046)
 *
 * Event description: User colored as co-branding user: either signed up after receiving an invite from a co-branding partner, or existing user who joined as a contributor to a co-branding partner account
 *
 * @param {coBrandingUserColoredForCoBrandingParams} params - The parameters for this event
 * @property {GUID} invited_by_account_id - invited_by_account_id
 * @property {boolean} new_user - true/false
 * @property {GUID} user_id - uuid of the accepting user
 * @property {string} value - value
 * @return {LogObject<coBrandingUserColoredForCoBrandingParams>} LogObject<coBrandingUserColoredForCoBrandingParams>
 */
export function coBrandingUserColoredForCoBranding(params) {
    return { evid: 3046, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesAndPermissionsAccountLevelCreateRole' event (evid: 3047)
 *
 * Event description: The user changed the role of a contributor in his site
 *
 * @param {rolesAndPermissionsAccountLevelCreateRoleParams} params - The parameters for this event
 * @property {string} new_role_ids - new role ids
 * @property {GUID} updated_on_msid - msid the contributor belongs to
 * @property {string} prev_role_ids - previous role ids
 * @property {string} contributor_id - the account_id of the contributor who's role is being updated
 * @property {GUID} meta_site_owner_id - Site owner account id
 * @return {LogObject<rolesAndPermissionsAccountLevelCreateRoleParams>} LogObject<rolesAndPermissionsAccountLevelCreateRoleParams>
 */
export function rolesAndPermissionsAccountLevelCreateRole(params) {
    return { evid: 3047, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesAndPermissionsAccountLevelUpdateRole' event (evid: 3048)
 *
 * Event description: The user removed a contributor from his site team - server success
 *
 * @param {rolesAndPermissionsAccountLevelUpdateRoleParams} params - The parameters for this event
 * @property {GUID} contributor_id - the account_id of the removed contributor
 * @property {GUID} removed_from_msid - the msid that the contributor is removed from
 * @property {GUID} meta_site_owner_id - site owner account id
 * @return {LogObject<rolesAndPermissionsAccountLevelUpdateRoleParams>} LogObject<rolesAndPermissionsAccountLevelUpdateRoleParams>
 */
export function rolesAndPermissionsAccountLevelUpdateRole(params) {
    return { evid: 3048, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'coBrandingAccountAgencyColoredForCoBranding' event (evid: 3070)
 *
 * Event description: Account colored as co-branding agencies
 *
 * @param {coBrandingAccountAgencyColoredForCoBrandingParams} params - The parameters for this event
 * @property {GUID} uuid - user id
 * @property {string} account_id - account_id of the agency
 * @property {string} value - added / removed
 * @return {LogObject<coBrandingAccountAgencyColoredForCoBrandingParams>} LogObject<coBrandingAccountAgencyColoredForCoBrandingParams>
 */
export function coBrandingAccountAgencyColoredForCoBranding(params) {
    return { evid: 3070, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'copyOfRolesAndPermissionsAddTeammate' event (evid: 3110)
 *
 * Event description: The user added a member to his account/site team - server success
 *
 * @param {copyOfRolesAndPermissionsAddTeammateParams} params - The parameters for this event
 * @property {GUID} teammate_id - the account_id of the removed team/teammate (if status is pending then invite_id)
 * @property {GUID} user_id - user id of the teammate , was created for the labels in user profile.
 * @property {GUID} added_to_account_id - the account_id that the user is added to
 * @return {LogObject<copyOfRolesAndPermissionsAddTeammateParams>} LogObject<copyOfRolesAndPermissionsAddTeammateParams>
 */
export function copyOfRolesAndPermissionsAddTeammate(params) {
    return { evid: 3110, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userProfileRolesAndPermissionsSiteLevelRemoveContributor' event (evid: 3112)
 *
 * Event description: The user removed a contributor from his site team - server success
 * This event is the same as 19:3048 and was built in order to use the BI profile, the difference : the field uuid is the uuid of the contributor that was removed.
 *
 * @param {userProfileRolesAndPermissionsSiteLevelRemoveContributorParams} params - The parameters for this event
 * @property {string} dsc - dsc
 * @property {number} response_time - ts
 * @property {string} builderType - builder_type
 * @property {string} errscp - errscp
 * @property {string} errn - errn
 * @property {string} p4 - p4
 * @property {string} majorver - majorver
 * @property {string} trgt - trgt
 * @property {boolean} isLiveEditor - is_live_editor
 * @property {number} response_code - response_code
 * @property {number} ts - ts
 * @property {string} viewmode - viewmode
 * @property {string} error_description_short - error_description_short
 * @property {string} p3 - p3
 * @property {GUID} did - site_id
 * @property {boolean} isSg - is_sg
 * @property {GUID} removed_from_msid - the msid that the contributor is removed from
 * @property {string} p2 - p2
 * @property {number} errc - errc
 * @property {GUID} meta_site_owner_id - site owner account id
 * @property {string} stack - stacktrace
 * @property {number} sev - sev
 * @property {number} cat - cat
 * @property {string} errormsg - dsc
 * @property {string} p1 - p1
 * @property {GUID} msid - msid
 * @property {number} iss - iss
 * @return {LogObject<userProfileRolesAndPermissionsSiteLevelRemoveContributorParams>} LogObject<userProfileRolesAndPermissionsSiteLevelRemoveContributorParams>
 */
export function userProfileRolesAndPermissionsSiteLevelRemoveContributor(params) {
    return { evid: 3112, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'coBrandingAccountCoBrandingFeatureUpdateRequest' event (evid: 3118)
 *
 * Event description: will be sent once you get an update from Premium about a user that becomes cobranded.
 *
 * @param {coBrandingAccountCoBrandingFeatureUpdateRequestParams} params - The parameters for this event
 * @property {GUID} uuid - user id
 * @property {string} account_id - account_id of the agency
 * @property {string} value - added / removed
 * @return {LogObject<coBrandingAccountCoBrandingFeatureUpdateRequestParams>} LogObject<coBrandingAccountCoBrandingFeatureUpdateRequestParams>
 */
export function coBrandingAccountCoBrandingFeatureUpdateRequest(params) {
    return { evid: 3118, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'isPermittedCall' event (evid: 3119)
 *
 * Event description: isPermitted call logs;
 * see documentation of isPermitted here: https://bo.wix.com/wix-docs/rest/internal-tools/api-gateway-service/api-gateway-service/is-permitted  contains also data from identityResponse, see documentation here: https://bo.wix.com/wix-docs/rest/internal-tools/api-gateway-service/identificationresponse/identification-response-object
 *
 * @param {isPermittedCallParams} params - The parameters for this event
 * @property {boolean} svSession - Is existing visitor's cookie
 * @property {GUID} visitorId - Copied from an input signedInstance.aid, when present - can be empty. Used for cases when the resolved Identity is SITEMEMBER (can have value when the Identity is VISITOR, as well), to indicate the id of the original visitor, who has later became SiteMember
 * @property {GUID} metasiteId - relevant info from resourceContext.siteContext object
 * @property {string} permission - The permission to check on
 * @property {boolean} published - Site is published.
 * @property {string} apiName - api_name
 * @property {GUID} accountId - relevat info from resourceContext.accountContext object
 * @property {boolean} smSession - Is existing site-member's cookie
 * @property {string} appDefId - appDefId of the origin app that initiated the flow - can be empty
 * @property {boolean} isPermitted - isPermitted result - False (permission denied) or True (permission approved)
 * @property {boolean} wixSession2 - Is existing user's cookie
 * @property {boolean} isLogInAccountOwner - applicable only for USERs:  TRUE - if the User is the Account owner of the loggedInAccountId FALSE - if the User is not the Account owner of the loggedInAccountId None - if there' not enough input to determine
 * @property {string} callingArtifact - calling_artifact
 * @property {boolean} authorization_header - Is existing authorization header
 * @property {string} identityType - identity_type
 * @property {boolean} hasUserRole - applicable only for SITEMEMBERs - indicates a siteMember has user role ('true' if site member isAdmin='true')
 * @property {boolean} isWixStaff - determines if the user is Wix staff (@wix.com)
 * @return {LogObject<isPermittedCallParams>} LogObject<isPermittedCallParams>
 */
export function isPermittedCall(params) {
    return { evid: 3119, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subAccountCreation' event (evid: 3124)
 *
 * Event description: A new account was created (possibly belonging to a parent account - optional)
 *
 * @param {subAccountCreationParams} params - The parameters for this event
 * @property {GUID} parent_account_id - parent_account_id
 * @property {string} user_agent - user_agent
 * @property {GUID} account_id - account_id that was created
 * @property {boolean} existing_account - true/false (is there already a wix account for this email address)
 * @return {LogObject<subAccountCreationParams>} LogObject<subAccountCreationParams>
 */
export function subAccountCreation(params) {
    return { evid: 3124, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'closeAccountSuccess' event (evid: 3126)
 *
 * Event description: user closed account successfully
 *
 * @param {closeAccountSuccessParams} params - The parameters for this event
 * @property {boolean} last_account - is this the users only account? (in studio the user can have multiple accounts)
 * @property {GUID} account_id - the closed account id / workspace id
 * @return {LogObject<closeAccountSuccessParams>} LogObject<closeAccountSuccessParams>
 */
export function closeAccountSuccess(params) {
    return { evid: 3126, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'closeAccountFailed' event (evid: 3127)
 *
 * Event description: user tried to close his account and failed
 *
 * @param {closeAccountFailedParams} params - The parameters for this event
 * @property {string} reason - reason the user failed to close his account (premium site)
 * @property {GUID} account_id - the closed account id / workspace id
 * @return {LogObject<closeAccountFailedParams>} LogObject<closeAccountFailedParams>
 */
export function closeAccountFailed(params) {
    return { evid: 3127, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersChangeEmailSuccess' event (evid: 6003)
 *
 * Event description: When the member changes his email or the site owner changes the members email. this event indicates successful change.
 *
 * @param {siteMembersChangeEmailSuccessParams} params - The parameters for this event
 * @property {string} role_type - whether the member changed the email or the user ("user"\"member")
 * @property {GUID} contact_id - the members contact id
 * @property {GUID} meta_site_id - MSID of relevant site
 * @return {LogObject<siteMembersChangeEmailSuccessParams>} LogObject<siteMembersChangeEmailSuccessParams>
 */
export function siteMembersChangeEmailSuccess(params) {
    return { evid: 6003, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersChangeEmailFailed' event (evid: 6004)
 *
 * Event description: When the member changes his email or the site owner changes the members email. this event indicates failure in the change.
 *
 * @param {siteMembersChangeEmailFailedParams} params - The parameters for this event
 * @property {string} role_type - whether the member changed the email or the user ("user"\"member")
 * @property {string} error_info - why the change failed
 * @property {GUID} contact_id - the members contact id
 * @property {GUID} meta_site_id - MSID of the site
 * @return {LogObject<siteMembersChangeEmailFailedParams>} LogObject<siteMembersChangeEmailFailedParams>
 */
export function siteMembersChangeEmailFailed(params) {
    return { evid: 6004, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersChangePasswordSuccess' event (evid: 6005)
 *
 * Event description: When the member changes his password successfully from the site.
 *
 * @param {siteMembersChangePasswordSuccessParams} params - The parameters for this event
 * @property {GUID} contact_id - the members contact id
 * @property {GUID} meta_site_id - MSID of the site
 * @return {LogObject<siteMembersChangePasswordSuccessParams>} LogObject<siteMembersChangePasswordSuccessParams>
 */
export function siteMembersChangePasswordSuccess(params) {
    return { evid: 6005, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersChangePasswordFailed' event (evid: 6006)
 *
 * Event description: When the member changes his password and fails on the site.
 *
 * @param {siteMembersChangePasswordFailedParams} params - The parameters for this event
 * @property {string} error_info - why the change failed
 * @property {GUID} contact_id - the members contact id
 * @property {GUID} meta_site_id - MSID of the site
 * @return {LogObject<siteMembersChangePasswordFailedParams>} LogObject<siteMembersChangePasswordFailedParams>
 */
export function siteMembersChangePasswordFailed(params) {
    return { evid: 6006, src: 19, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ownerApp2FaSetupEnableClick' event (evid: 10909)
 *
 * Event description: When the user clicks on "Enable" on the Owner app 2fa in the Account settings dashboard
 *
 * @param {ownerApp2FaSetupEnableClickParams} params - The parameters for this event
 * @property {string} origin - account settings page/phone modal/app modal/second best
 * @return {LogObject<ownerApp2FaSetupEnableClickParams>} LogObject<ownerApp2FaSetupEnableClickParams>
 */
export function ownerApp2FaSetupEnableClick(params) {
    return { evid: 10909, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ownerApp2FaSetupUserClickedOnChoosingDeviceScreen' event (evid: 10910)
 *
 * Event description: In the owner app 2fa setup flow, the user clicks on "Next" after he chooses a device to do the Authentication.
 *
 * @param {ownerApp2FaSetupUserClickedOnChoosingDeviceScreenParams} params - The parameters for this event
 * @property {string} origin - account settings page/phone modal/app modal/second best
 * @property {string} chosenDevice - Which device the user chose for verifying the 2fa ("This device"\"another device")
 * @property {string} button_clicked - Indicates which button the user clicked.  ('Cancel' / 'Continue' / 'exit')
 * @property {boolean} isHover - Indicates whether the user hovered over the information icon
 * @return {LogObject<ownerApp2FaSetupUserClickedOnChoosingDeviceScreenParams>} LogObject<ownerApp2FaSetupUserClickedOnChoosingDeviceScreenParams>
 */
export function ownerApp2FaSetupUserClickedOnChoosingDeviceScreen(params) {
    return { evid: 10910, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ownerApp2FaSetupClickOnApproveFromTheOwnerApp' event (evid: 10911)
 *
 * Event description: When the user gets a popup in his owner app to verify his identity (for the Owner app 2fa flow), he clicks on "Approve"
 *
 * @param {ownerApp2FaSetupClickOnApproveFromTheOwnerAppParams} params - The parameters for this event
 * @property {string} context - enable 2fa \ login
 * @return {LogObject<ownerApp2FaSetupClickOnApproveFromTheOwnerAppParams>} LogObject<ownerApp2FaSetupClickOnApproveFromTheOwnerAppParams>
 */
export function ownerApp2FaSetupClickOnApproveFromTheOwnerApp(params) {
    return { evid: 10911, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ownerApp2FaSetupClickOnDenyFromTheOwnerApp' event (evid: 10912)
 *
 * Event description: When the user gets a popup in his owner app to verify his identity (for the Owner app 2fa flow), he clicks on "Deny"
 *
 * @param {ownerApp2FaSetupClickOnDenyFromTheOwnerAppParams} params - The parameters for this event
 * @property {string} context - enable 2fa \ login
 * @return {LogObject<ownerApp2FaSetupClickOnDenyFromTheOwnerAppParams>} LogObject<ownerApp2FaSetupClickOnDenyFromTheOwnerAppParams>
 */
export function ownerApp2FaSetupClickOnDenyFromTheOwnerApp(params) {
    return { evid: 10912, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ownerApp2FaSetupClickOnResendRequest' event (evid: 10913)
 *
 * Event description: In the owner app 2fa setup flow, the user clicks on "Resend request" after he chooses a device to do the Authentication.
 *
 * @param {ownerApp2FaSetupClickOnResendRequestParams} params - The parameters for this event
 * @property {string} origin - account settings page/phone modal/app modal/second best
 * @property {string} screenName - The name of the screen
 * @return {LogObject<ownerApp2FaSetupClickOnResendRequestParams>} LogObject<ownerApp2FaSetupClickOnResendRequestParams>
 */
export function ownerApp2FaSetupClickOnResendRequest(params) {
    return { evid: 10913, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ownerApp2FaSetupChoosingABackup' event (evid: 10926)
 *
 * Event description: In the owner app 2fa setup flow, the user clicks on "Setup Backup" after he chooses a 2FA backup (such as SMS 2fa\Email 2fa)
 *
 *
 * @param {ownerApp2FaSetupChoosingABackupParams} params - The parameters for this event
 * @property {string} mfaType - Additional mfa type (sms\auth app\email)
 * @return {LogObject<ownerApp2FaSetupChoosingABackupParams>} LogObject<ownerApp2FaSetupChoosingABackupParams>
 */
export function ownerApp2FaSetupChoosingABackup(params) {
    return { evid: 10926, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ownerApp2FaSetupUserClickedOnScanTheQrCodeScreen' event (evid: 10927)
 *
 * Event description: In the owner app 2fa setup flow, the user clicks on one of the options in the "Scan the QR code" screen. (download owner app page)
 *
 * @param {ownerApp2FaSetupUserClickedOnScanTheQrCodeScreenParams} params - The parameters for this event
 * @property {string} button_clicked - Indicates which button the user clicked. Possible values include: 'Learn how,' 'Learn why,' 'Cancel,' 'Continue,' 'Exit screen,' or '?'
 * @property {boolean} Is_successful - Indicates if all the steps were successful
 * @return {LogObject<ownerApp2FaSetupUserClickedOnScanTheQrCodeScreenParams>} LogObject<ownerApp2FaSetupUserClickedOnScanTheQrCodeScreenParams>
 */
export function ownerApp2FaSetupUserClickedOnScanTheQrCodeScreen(params) {
    return { evid: 10927, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ownerApp2FaSetupDisableClick' event (evid: 10928)
 *
 * Event description: When the user clicks on "Disable" on the Owner app 2fa in the Account settings dashboard
 *
 * @param {ownerApp2FaSetupDisableClickParams} params - The parameters for this event
 * @return {LogObject<ownerApp2FaSetupDisableClickParams>} LogObject<ownerApp2FaSetupDisableClickParams>
 */
export function ownerApp2FaSetupDisableClick(params) {
    return { evid: 10928, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ownerApp2FaSetupDisableConfirm' event (evid: 10929)
 *
 * Event description: When the user clicks on "Disable" in the disable modal of the verification with the owner app, to confirm the action.
 *
 * @param {ownerApp2FaSetupDisableConfirmParams} params - The parameters for this event
 * @return {LogObject<ownerApp2FaSetupDisableConfirmParams>} LogObject<ownerApp2FaSetupDisableConfirmParams>
 */
export function ownerApp2FaSetupDisableConfirm(params) {
    return { evid: 10929, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mfaSetupDisableAllMethodsDisableAllClick' event (evid: 10930)
 *
 * Event description: When the user clicks on "Disable All" in the disable modal after trying to enable Owner app 2fa and another 2fa method.
 *
 * @param {mfaSetupDisableAllMethodsDisableAllClickParams} params - The parameters for this event
 * @return {LogObject<mfaSetupDisableAllMethodsDisableAllClickParams>} LogObject<mfaSetupDisableAllMethodsDisableAllClickParams>
 */
export function mfaSetupDisableAllMethodsDisableAllClick(params) {
    return { evid: 10930, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'workspaceSettingsLeaveStudioFindOutMoreButtonClick' event (evid: 10931)
 *
 * Event description: User clicked the Leave Studio "find out more" CTA on the bottom of the Workspace Settings in Studio and loaded the "Leave Wix Studio and the Partner Program?" modal
 *
 * @param {workspaceSettingsLeaveStudioFindOutMoreButtonClickParams} params - The parameters for this event
 * @return {LogObject<workspaceSettingsLeaveStudioFindOutMoreButtonClickParams>} LogObject<workspaceSettingsLeaveStudioFindOutMoreButtonClickParams>
 */
export function workspaceSettingsLeaveStudioFindOutMoreButtonClick(params) {
    return { evid: 10931, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ssoAndScimSettingsDashboard' event (evid: 11100)
 *
 * Event description: SSO and SCIM settings dashboard.
 *
 * @param {ssoAndScimSettingsDashboardParams} params - The parameters for this event
 * @property {string} button_clicked - the button the user clicked on ("Set up SSO"/"Set up SCIM")
 * @property {string} context - team context ("Employees"/"Clients")
 * @property {GUID} scim_id - SCIM id (account_id)
 * @return {LogObject<ssoAndScimSettingsDashboardParams>} LogObject<ssoAndScimSettingsDashboardParams>
 */
export function ssoAndScimSettingsDashboard(params) {
    return { evid: 11100, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scimSettingsSetupStages' event (evid: 11101)
 *
 * Event description: All SCIM setup stages - get started, set default role, send code, generate token (by this order). in addition, there is resend code action.
 *
 * @param {scimSettingsSetupStagesParams} params - The parameters for this event
 * @property {string} button_clicked - the button the user clicked on (get started, set default role, send code, generate token, resend code)")
 * @property {GUID} scim_id - SCIM id (account_id)
 * @property {string} error_info - Error of the stage if didn't succeeded
 * @return {LogObject<scimSettingsSetupStagesParams>} LogObject<scimSettingsSetupStagesParams>
 */
export function scimSettingsSetupStages(params) {
    return { evid: 11101, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scimSettingsDisableScim' event (evid: 11102)
 *
 * Event description: The user clicked on "Disable SCIM"
 *
 * @param {scimSettingsDisableScimParams} params - The parameters for this event
 * @property {GUID} sso_id - SSO id
 * @property {GUID} scim_id - SCIM id (account_id)
 * @property {string} error_info - The error of why SCIM didn't succeeded to disable
 * @return {LogObject<scimSettingsDisableScimParams>} LogObject<scimSettingsDisableScimParams>
 */
export function scimSettingsDisableScim(params) {
    return { evid: 11102, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scimSettingsClickOnManageDefaultRole' event (evid: 11103)
 *
 * Event description: The user clicked on "manage roles" on the default roles in SCIM settings
 *
 * @param {scimSettingsClickOnManageDefaultRoleParams} params - The parameters for this event
 * @property {GUID} scim_id - SCIM id (account_id)
 * @return {LogObject<scimSettingsClickOnManageDefaultRoleParams>} LogObject<scimSettingsClickOnManageDefaultRoleParams>
 */
export function scimSettingsClickOnManageDefaultRole(params) {
    return { evid: 11103, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scimSettingsClickOnChangeDefaultRole' event (evid: 11104)
 *
 * Event description: The user clicked on "manage roles" on the default roles in SCIM settings
 *
 * @param {scimSettingsClickOnChangeDefaultRoleParams} params - The parameters for this event
 * @property {GUID} scim_id - SCIM id (account_id)
 * @return {LogObject<scimSettingsClickOnChangeDefaultRoleParams>} LogObject<scimSettingsClickOnChangeDefaultRoleParams>
 */
export function scimSettingsClickOnChangeDefaultRole(params) {
    return { evid: 11104, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scimSettingsClickOnChangeGroupRole' event (evid: 11105)
 *
 * Event description: The user clicked on "Change role" on a specific\number of groups in SCIM settings
 *
 * @param {scimSettingsClickOnChangeGroupRoleParams} params - The parameters for this event
 * @property {string} number_of_groups - Number of groups (or all if the user chose all groups)
 * @property {GUID} scim_id - SCIM id (account_id)
 * @return {LogObject<scimSettingsClickOnChangeGroupRoleParams>} LogObject<scimSettingsClickOnChangeGroupRoleParams>
 */
export function scimSettingsClickOnChangeGroupRole(params) {
    return { evid: 11105, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scimSettingsChangeGroupRole' event (evid: 11106)
 *
 * Event description: The user clicked on "manage roles" on the default roles in SCIM settings
 *
 * @param {scimSettingsChangeGroupRoleParams} params - The parameters for this event
 * @property {string} number_of_groups - Number of groups (or all if user chose all groups)
 * @property {number} number_of_roles - Number of roles
 * @property {string} role_ids - list of all role_ids chosen
 * @property {string} number_of_folders - Number of folders (or all if user chose all folders)
 * @property {GUID} scim_id - SCIM id (account_id)
 * @property {string} numberOfSites - Number of sites (or all if user chose all sites)
 * @return {LogObject<scimSettingsChangeGroupRoleParams>} LogObject<scimSettingsChangeGroupRoleParams>
 */
export function scimSettingsChangeGroupRole(params) {
    return { evid: 11106, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'workspaceSelectorFormLoad' event (evid: 11400)
 *
 * Event description: Workspace selector page loaded - after the user accepts the invitation to join as a collaborator
 *
 * @param {workspaceSelectorFormLoadParams} params - The parameters for this event
 * @property {string} origin_info - From which flow\page the user was referred to this page
 * @return {LogObject<workspaceSelectorFormLoadParams>} LogObject<workspaceSelectorFormLoadParams>
 */
export function workspaceSelectorFormLoad(params) {
    return { evid: 11400, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'workspaceSelectorAccountSelected' event (evid: 11401)
 *
 * Event description: After the user accepts the invitation to join as a collaborator, the user chooses with witch account he will join
 *
 * @param {workspaceSelectorAccountSelectedParams} params - The parameters for this event
 * @property {GUID} account_id_selected - the chosen account id
 * @property {string} origin_info - From which flow\page the user was referred to this page
 * @return {LogObject<workspaceSelectorAccountSelectedParams>} LogObject<workspaceSelectorAccountSelectedParams>
 */
export function workspaceSelectorAccountSelected(params) {
    return { evid: 11401, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'workspaceSelectorUserClickedBack' event (evid: 11402)
 *
 * Event description: the user clicked back on the workspace selector back to the collaborator invite
 *
 * @param {workspaceSelectorUserClickedBackParams} params - The parameters for this event
 * @return {LogObject<workspaceSelectorUserClickedBackParams>} LogObject<workspaceSelectorUserClickedBackParams>
 */
export function workspaceSelectorUserClickedBack(params) {
    return { evid: 11402, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersAreaNotificationSettingsPageStartLoading' event (evid: 1144)
 *
 * Event description: When the Notification Settings page in Members Area is starting to load
 *
 * @param {membersAreaNotificationSettingsPageStartLoadingParams} params - The parameters for this event
 * @property {GUID} instance_id - the instance id
 * @property {GUID} biToken - site guid
 * @property {string} referral_info - refferal param
 * @property {GUID} visitor_id - visitor id
 * @property {GUID} vsi - vsi
 * @property {GUID} site_member_id - UUID of the member
 * @property {string} platform - deprecated
 * @return {LogObject<membersAreaNotificationSettingsPageStartLoadingParams>} LogObject<membersAreaNotificationSettingsPageStartLoadingParams>
 */
export function membersAreaNotificationSettingsPageStartLoading(params) {
    return { evid: 1144, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersLoginRecaptchaRequired' event (evid: 1191)
 *
 * Event description: Captcha for site members required during login
 *
 * @param {siteMembersLoginRecaptchaRequiredParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} context - context
 * @property {GUID} visitor_id - visitor id
 * @property {string} reason - reason for captcha
 * @property {GUID} vsi - vsi
 * @property {string} layout - full screen/pop up
 * @property {string} platform - platform
 * @return {LogObject<siteMembersLoginRecaptchaRequiredParams>} LogObject<siteMembersLoginRecaptchaRequiredParams>
 */
export function siteMembersLoginRecaptchaRequired(params) {
    return { evid: 1191, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersCustomLoginChooseMemberLoginForm' event (evid: 1192)
 *
 * Event description: The user chose 'member login form' from the member signup menu
 *
 * @param {siteMembersCustomLoginChooseMemberLoginFormParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @return {LogObject<siteMembersCustomLoginChooseMemberLoginFormParams>} LogObject<siteMembersCustomLoginChooseMemberLoginFormParams>
 */
export function siteMembersCustomLoginChooseMemberLoginForm(params) {
    return { evid: 1192, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersCustomLoginLoginFormTypeSelection' event (evid: 1193)
 *
 * Event description: The user selected the login form type from the dropdown menu - default/custom/corvid
 *
 * @param {siteMembersCustomLoginLoginFormTypeSelectionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {boolean} has_custom_signup - true/false (does the user currently have custom signup form)
 * @property {GUID} vsi - vsi
 * @property {string} selection - default/custom/corvid
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @return {LogObject<siteMembersCustomLoginLoginFormTypeSelectionParams>} LogObject<siteMembersCustomLoginLoginFormTypeSelectionParams>
 */
export function siteMembersCustomLoginLoginFormTypeSelection(params) {
    return { evid: 1193, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersCustomLoginClickOnEdit' event (evid: 1194)
 *
 * Event description: The user clicked on 'edit' from the custom login form menu (3 dots), or clicked on the login dialog
 *
 * @param {siteMembersCustomLoginClickOnEditParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {string} origin - where the user clicked in order to edit - menu/dialog
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @return {LogObject<siteMembersCustomLoginClickOnEditParams>} LogObject<siteMembersCustomLoginClickOnEditParams>
 */
export function siteMembersCustomLoginClickOnEdit(params) {
    return { evid: 1194, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersCustomLoginRestoreLoginButtonFromErrorMessage' event (evid: 1195)
 *
 * Event description: Sent  if the user clicks on "restore login button" from the error message that pops when he removes the login button
 *
 * @param {siteMembersCustomLoginRestoreLoginButtonFromErrorMessageParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @return {LogObject<siteMembersCustomLoginRestoreLoginButtonFromErrorMessageParams>} LogObject<siteMembersCustomLoginRestoreLoginButtonFromErrorMessageParams>
 */
export function siteMembersCustomLoginRestoreLoginButtonFromErrorMessage(params) {
    return { evid: 1195, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersCustomLoginOpenLoginElementsPanel' event (evid: 1196)
 *
 * Event description: The user clicked on 'add login elements'
 *
 * @param {siteMembersCustomLoginOpenLoginElementsPanelParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @return {LogObject<siteMembersCustomLoginOpenLoginElementsPanelParams>} LogObject<siteMembersCustomLoginOpenLoginElementsPanelParams>
 */
export function siteMembersCustomLoginOpenLoginElementsPanel(params) {
    return { evid: 1196, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersCustomLoginAddElementFromLoginElementsPanel' event (evid: 1197)
 *
 * Event description: The user added an element back from Login Elements
 *
 * @param {siteMembersCustomLoginAddElementFromLoginElementsPanelParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {string} element_name - the element that the user added
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @return {LogObject<siteMembersCustomLoginAddElementFromLoginElementsPanelParams>} LogObject<siteMembersCustomLoginAddElementFromLoginElementsPanelParams>
 */
export function siteMembersCustomLoginAddElementFromLoginElementsPanel(params) {
    return { evid: 1197, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersCustomLoginDeleteElement' event (evid: 1198)
 *
 * Event description: The user deleted an element from custom login form
 *
 * @param {siteMembersCustomLoginDeleteElementParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {string} element_name - the element that the user deleted, social component/email/password
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @return {LogObject<siteMembersCustomLoginDeleteElementParams>} LogObject<siteMembersCustomLoginDeleteElementParams>
 */
export function siteMembersCustomLoginDeleteElement(params) {
    return { evid: 1198, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersCustomLoginTurnSocialButtonOnOrOff' event (evid: 1199)
 *
 * Event description: The user turned on/off one of the social buttons in the social component (currently, Google or Facebook)
 *
 * @param {siteMembersCustomLoginTurnSocialButtonOnOrOffParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @property {string} social_network - google/facebook
 * @property {string} hosting - editor/onboarding
 * @property {string} action - turn on/turn off
 * @return {LogObject<siteMembersCustomLoginTurnSocialButtonOnOrOffParams>} LogObject<siteMembersCustomLoginTurnSocialButtonOnOrOffParams>
 */
export function siteMembersCustomLoginTurnSocialButtonOnOrOff(params) {
    return { evid: 1199, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersCustomLoginOpenLoginSettings' event (evid: 1200)
 *
 * Event description: The user clicked on login settings
 *
 * @param {siteMembersCustomLoginOpenLoginSettingsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @return {LogObject<siteMembersCustomLoginOpenLoginSettingsParams>} LogObject<siteMembersCustomLoginOpenLoginSettingsParams>
 */
export function siteMembersCustomLoginOpenLoginSettings(params) {
    return { evid: 1200, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesAndPermissionsInvitePeopleInviteErrorDueToInsufficientQuota' event (evid: 12008)
 *
 * Event description: The user attempted to send an invite to a new collaborator despite reaching the maximal number of collaborators allowed by the quota in the premium package.
 *
 * @param {rolesAndPermissionsInvitePeopleInviteErrorDueToInsufficientQuotaParams} params - The parameters for this event
 * @property {number} contributors_quota - How many contributors can be added to the site based on the premium package quota
 * @property {number} contributors_count - How many contributors are actually active on the site
 * @return {LogObject<rolesAndPermissionsInvitePeopleInviteErrorDueToInsufficientQuotaParams>} LogObject<rolesAndPermissionsInvitePeopleInviteErrorDueToInsufficientQuotaParams>
 */
export function rolesAndPermissionsInvitePeopleInviteErrorDueToInsufficientQuota(params) {
    return { evid: 12008, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesAndPermissionsInvitePeopleUserClickOnUpgrade' event (evid: 12009)
 *
 * Event description: User clicked on "upgrade" premium package from invite collaborators page
 *
 * @param {rolesAndPermissionsInvitePeopleUserClickOnUpgradeParams} params - The parameters for this event
 * @property {number} contributors_quota - How many contributors can be added to the site based on the premium package quota
 * @property {number} contributors_count - How many contributors are actually active on the site
 * @property {string} origin - where in the page did the user click: email_bar / quota_box
 * @return {LogObject<rolesAndPermissionsInvitePeopleUserClickOnUpgradeParams>} LogObject<rolesAndPermissionsInvitePeopleUserClickOnUpgradeParams>
 */
export function rolesAndPermissionsInvitePeopleUserClickOnUpgrade(params) {
    return { evid: 12009, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersCustomLoginChangeLoginSettings' event (evid: 1201)
 *
 * Event description: The user made a change in login settings - chose either to first show new member signup or existing member login
 *
 * @param {siteMembersCustomLoginChangeLoginSettingsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {string} first_option - what the user chose to show first - signup/login
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @return {LogObject<siteMembersCustomLoginChangeLoginSettingsParams>} LogObject<siteMembersCustomLoginChangeLoginSettingsParams>
 */
export function siteMembersCustomLoginChangeLoginSettings(params) {
    return { evid: 1201, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesAndPermissionsInvitePeopleHoverInformationIcon' event (evid: 12014)
 *
 * Event description: Users hover over the 'Information' icon in the Collaborators bar.
 *
 * @param {rolesAndPermissionsInvitePeopleHoverInformationIconParams} params - The parameters for this event
 * @return {LogObject<rolesAndPermissionsInvitePeopleHoverInformationIconParams>} LogObject<rolesAndPermissionsInvitePeopleHoverInformationIconParams>
 */
export function rolesAndPermissionsInvitePeopleHoverInformationIcon(params) {
    return { evid: 12014, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesAndPermissionsInvitePeopleCtaLearnMoreLink' event (evid: 12015)
 *
 * Event description: Users click on the 'Learn more' link in the information tooltip
 *
 * @param {rolesAndPermissionsInvitePeopleCtaLearnMoreLinkParams} params - The parameters for this event
 * @return {LogObject<rolesAndPermissionsInvitePeopleCtaLearnMoreLinkParams>} LogObject<rolesAndPermissionsInvitePeopleCtaLearnMoreLinkParams>
 */
export function rolesAndPermissionsInvitePeopleCtaLearnMoreLink(params) {
    return { evid: 12015, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersCustomLoginResetToDefaultFromLoginSettings' event (evid: 1202)
 *
 * Event description: The user clicked on 'snap to latest version' in the elements panel
 *
 * @param {siteMembersCustomLoginResetToDefaultFromLoginSettingsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} elements - which elements were in the custom login form when restored to default
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @return {LogObject<siteMembersCustomLoginResetToDefaultFromLoginSettingsParams>} LogObject<siteMembersCustomLoginResetToDefaultFromLoginSettingsParams>
 */
export function siteMembersCustomLoginResetToDefaultFromLoginSettings(params) {
    return { evid: 1202, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersCustomLoginChangeLayoutOfSocialButtons' event (evid: 1203)
 *
 * Event description: The user changed the layout of the social buttons - button/icon
 *
 * @param {siteMembersCustomLoginChangeLayoutOfSocialButtonsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {string} layout - layout
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @return {LogObject<siteMembersCustomLoginChangeLayoutOfSocialButtonsParams>} LogObject<siteMembersCustomLoginChangeLayoutOfSocialButtonsParams>
 */
export function siteMembersCustomLoginChangeLayoutOfSocialButtons(params) {
    return { evid: 1203, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersCustomLoginClickOnGfpp' event (evid: 1204)
 *
 * Event description: The user clicked on the question mark (?) gfpp in one of sections of the custom login form
 *
 * @param {siteMembersCustomLoginClickOnGfppParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {string} section - login form/login settings/login elements/social component/social component settings
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @return {LogObject<siteMembersCustomLoginClickOnGfppParams>} LogObject<siteMembersCustomLoginClickOnGfppParams>
 */
export function siteMembersCustomLoginClickOnGfpp(params) {
    return { evid: 1204, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersLoginCustomLoginLoad' event (evid: 1205)
 *
 * Event description: The custom login component was loaded after a site member clicked on "login" in the site
 *
 * @param {siteMembersLoginCustomLoginLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @return {LogObject<siteMembersLoginCustomLoginLoadParams>} LogObject<siteMembersLoginCustomLoginLoadParams>
 */
export function siteMembersLoginCustomLoginLoad(params) {
    return { evid: 1205, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersLoginSucesss' event (evid: 1206)
 *
 * Event description: Client event - site member login successful
 *
 * @param {siteMembersLoginSucesssParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} provider_id - wix/facebook/google
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} form_type - default/custom/corvid
 * @property {GUID} site_member_id - site member id
 * @property {string} platform - platform
 * @return {LogObject<siteMembersLoginSucesssParams>} LogObject<siteMembersLoginSucesssParams>
 */
export function siteMembersLoginSucesss(params) {
    return { evid: 1206, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersLoginFail' event (evid: 1207)
 *
 * Event description: Client event - site member login failed
 *
 * @param {siteMembersLoginFailParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} provider_id - wix/facebook/google
 * @property {GUID} visitor_id - visitor id
 * @property {string} errorReason - why log in failed
 * @property {GUID} vsi - vsi
 * @property {string} form_type - default/custom/corvid
 * @property {string} platform - platform
 * @return {LogObject<siteMembersLoginFailParams>} LogObject<siteMembersLoginFailParams>
 */
export function siteMembersLoginFail(params) {
    return { evid: 1207, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersCustomLoginClickOnAddToSite' event (evid: 1211)
 *
 * Event description: The user clicked on 'add to site' button from the custom login form dialog
 *
 * @param {siteMembersCustomLoginClickOnAddToSiteParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @return {LogObject<siteMembersCustomLoginClickOnAddToSiteParams>} LogObject<siteMembersCustomLoginClickOnAddToSiteParams>
 */
export function siteMembersCustomLoginClickOnAddToSite(params) {
    return { evid: 1211, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersAreaNotificationSettingsPageFinishLoading' event (evid: 1214)
 *
 * Event description: When the Notification Settings page in Members Area is finish loading
 *
 * @param {membersAreaNotificationSettingsPageFinishLoadingParams} params - The parameters for this event
 * @property {GUID} instance_id - the instance id
 * @property {GUID} biToken - site guid
 * @property {string} referral_info - refferal param
 * @property {GUID} visitor_id - visitor id
 * @property {GUID} vsi - vsi
 * @property {GUID} site_member_id - UUID of the member
 * @property {string} platform - deprecated
 * @property {number} loading_time - loading time of page in ms (from event 1144 - page start loading)
 * @return {LogObject<membersAreaNotificationSettingsPageFinishLoadingParams>} LogObject<membersAreaNotificationSettingsPageFinishLoadingParams>
 */
export function membersAreaNotificationSettingsPageFinishLoading(params) {
    return { evid: 1214, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesAndPermissionsInviteUserClicksSrc5Evid1236' event (evid: 1236)
 *
 * Event description: Users clicks on the Roles and permission invite page
 *
 * @param {rolesAndPermissionsInviteUserClicksSrc5Evid1236Params} params - The parameters for this event
 * @property {number} Contributors_quota - Number of contributors in users quota on this site
 * @property {string} previous_values - previous value before the user clicked on it (True\False\value}
 * @property {boolean} is_valid_email - Is the email valid
 * @property {string} role_name - the role name choosed
 * @property {number} contributors_count - number of contributors on this site
 * @property {string} context - site \ account
 * @property {string} new_value - new value after the user clicked on it (True\False\value}
 * @property {string} element_title - the element title (Roles \ Emails)
 * @property {string} element_name - the element name (for example the role name)
 * @property {boolean} has_ai_assistant - Does the user has ai assistant in this page
 * @return {LogObject<rolesAndPermissionsInviteUserClicksSrc5Evid1236Params>} LogObject<rolesAndPermissionsInviteUserClicksSrc5Evid1236Params>
 */
export function rolesAndPermissionsInviteUserClicksSrc5Evid1236(params) {
    return { evid: 1236, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersAreaSettingsClickOnToggle' event (evid: 1255)
 *
 * Event description: When a member enter the settings page in members area and clicks on a toggle
 *
 * @param {membersAreaSettingsClickOnToggleParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} channel - notifications channel
 * @property {boolean} toggle_state - True - ON, False - OFF
 * @property {string} toggleName - the name of the toggle. f.e. likes,comment etc.
 * @property {GUID} biToken - msid
 * @property {string} description - toggle description. f.e. Notify me when members comment on my posts
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} site_member_id - UUID of the member
 * @property {string} title - title name. f.e. blog notifications
 * @property {string} platform - deprecated
 * @return {LogObject<membersAreaSettingsClickOnToggleParams>} LogObject<membersAreaSettingsClickOnToggleParams>
 */
export function membersAreaSettingsClickOnToggle(params) {
    return { evid: 1255, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersMembersListClickOn3Dots' event (evid: 1399)
 *
 * Event description: user click on a button located on the header of the members list page
 * https://docs.google.com/presentation/d/1xlGzxrb38PQp9Ihh_rIacUm7ocbeq6ylO5lpYw2ERjQ/edit?usp=sharing
 *
 * @param {membersMembersListClickOn3DotsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - user id
 * @property {GUID} visitor_id - visitor id
 * @property {string} button_name - more actions / member permissions
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @return {LogObject<membersMembersListClickOn3DotsParams>} LogObject<membersMembersListClickOn3DotsParams>
 */
export function membersMembersListClickOn3Dots(params) {
    return { evid: 1399, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersMembersListSendResetPasswordEmailModal' event (evid: 1451)
 *
 * Event description: users sent the reset password email/ cancel
 *
 * @param {membersMembersListSendResetPasswordEmailModalParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} subjectChanged - true / false
 * @property {GUID} uuid - user id
 * @property {boolean} messageChanged - true / false
 * @property {GUID} visitor_id - visitor_id
 * @property {string} button_name - send/cancel/x
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @return {LogObject<membersMembersListSendResetPasswordEmailModalParams>} LogObject<membersMembersListSendResetPasswordEmailModalParams>
 */
export function membersMembersListSendResetPasswordEmailModal(params) {
    return { evid: 1451, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersMembersPageUserClicksOnMemberOptions3Dots' event (evid: 1489)
 *
 * Event description: user click on member options
 *
 * @param {siteMembersMembersPageUserClicksOnMemberOptions3DotsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - user id
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @property {string} view - page name
 * @return {LogObject<siteMembersMembersPageUserClicksOnMemberOptions3DotsParams>} LogObject<siteMembersMembersPageUserClicksOnMemberOptions3DotsParams>
 */
export function siteMembersMembersPageUserClicksOnMemberOptions3Dots(params) {
    return { evid: 1489, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersMembersPageUsersActionInMembersListOffering' event (evid: 1490)
 *
 * Event description: a generic event for the upper offering in the members list page
 * https://docs.google.com/presentation/d/1xlGzxrb38PQp9Ihh_rIacUm7ocbeq6ylO5lpYw2ERjQ/edit?usp=sharing
 *
 * @param {siteMembersMembersPageUsersActionInMembersListOfferingParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - user id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} offeringName - badges / pending members
 * @property {GUID} vsi - vsi
 * @property {string} selection - close/ manage badges / view&approve / learn more
 * @property {string} platform - platform
 * @return {LogObject<siteMembersMembersPageUsersActionInMembersListOfferingParams>} LogObject<siteMembersMembersPageUsersActionInMembersListOfferingParams>
 */
export function siteMembersMembersPageUsersActionInMembersListOffering(params) {
    return { evid: 1490, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersMemberPermissionsMoveBetweenTabs' event (evid: 1491)
 *
 * Event description: user moves between tabs in the groups settings in member permission
 *
 * @param {membersMemberPermissionsMoveBetweenTabsParams} params - The parameters for this event
 * @property {GUID} instance_id - iid
 * @property {GUID} biToken - msid
 * @property {string} tab_name - tab name
 * @property {GUID} uuid - uuid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @property {string} group_name - The group (role) name
 * @property {string} group_id - The group (role) id
 * @return {LogObject<membersMemberPermissionsMoveBetweenTabsParams>} LogObject<membersMemberPermissionsMoveBetweenTabsParams>
 */
export function membersMemberPermissionsMoveBetweenTabs(params) {
    return { evid: 1491, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersMemberPermissionsSaveCancelChange' event (evid: 1492)
 *
 * Event description: user save/cancel permissions change
 *
 * @param {membersMemberPermissionsSaveCancelChangeParams} params - The parameters for this event
 * @property {GUID} instance_id - instid
 * @property {GUID} biToken - msid
 * @property {string} tab_name - tab_name
 * @property {GUID} visitor_id - visitor id
 * @property {GUID} vsi - vsi
 * @property {string} selection - Save/Cancel
 * @property {string} platform - plat
 * @property {string} group_name - The group (role) name
 * @property {string} group_id - The group (role) id
 * @return {LogObject<membersMemberPermissionsSaveCancelChangeParams>} LogObject<membersMemberPermissionsSaveCancelChangeParams>
 */
export function membersMemberPermissionsSaveCancelChange(params) {
    return { evid: 1492, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersPendingMembersApproveBlockPendingMemberClick' event (evid: 1499)
 *
 * Event description: user clicks on Approve/Block pending member click
 * https://docs.google.com/presentation/d/1xlGzxrb38PQp9Ihh_rIacUm7ocbeq6ylO5lpYw2ERjQ/edit?usp=sharing
 *
 * @param {siteMembersPendingMembersApproveBlockPendingMemberClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - user id
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} contact_id - id of contact
 * @property {string} platform - platform
 * @property {string} value - Approve/Block
 * @return {LogObject<siteMembersPendingMembersApproveBlockPendingMemberClickParams>} LogObject<siteMembersPendingMembersApproveBlockPendingMemberClickParams>
 */
export function siteMembersPendingMembersApproveBlockPendingMemberClick(params) {
    return { evid: 1499, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersMemberPageMoveBetweenTabs' event (evid: 1509)
 *
 * Event description: user moves between tabs in the groups settings in members main page
 *
 * @param {membersMemberPageMoveBetweenTabsParams} params - The parameters for this event
 * @property {GUID} instance_id - iid
 * @property {GUID} biToken - msid
 * @property {string} tab_name - tab name
 * @property {GUID} uuid - uuid
 * @property {GUID} visitor_id - visitor id
 * @property {GUID} vsi - vsi
 * @property {string} platform - plt
 * @return {LogObject<membersMemberPageMoveBetweenTabsParams>} LogObject<membersMemberPageMoveBetweenTabsParams>
 */
export function membersMemberPageMoveBetweenTabs(params) {
    return { evid: 1509, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersErrorEventInteractionNotClosed' event (evid: 1600)
 *
 * Event description: A detailed error event, sent when the interaction is not closed (indicate members errors on viewer (TB)).
 *
 * @param {siteMembersErrorEventInteractionNotClosedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} ga - _ga cookie
 * @property {string} context - context
 * @property {string} interaction_name - interaction_name
 * @property {GUID} visitor_id - visitor_id
 * @property {string} error - error received (test)
 * @property {GUID} vsi - vsi
 * @property {string} origin - the origin of the request
 * @property {string} request_id - request_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} platform - platform
 * @property {string} error_code - error code (number)
 * @return {LogObject<siteMembersErrorEventInteractionNotClosedParams>} LogObject<siteMembersErrorEventInteractionNotClosedParams>
 */
export function siteMembersErrorEventInteractionNotClosed(params) {
    return { evid: 1600, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSetContactsAsMembersClickOnImportContacts' event (evid: 1637)
 *
 * Event description: User without contacts in his site clicked on 'import contacts' in the empty state of the modal for 'set contacts as members'
 *
 * @param {siteMembersSetContactsAsMembersClickOnImportContactsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - user id
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @return {LogObject<siteMembersSetContactsAsMembersClickOnImportContactsParams>} LogObject<siteMembersSetContactsAsMembersClickOnImportContactsParams>
 */
export function siteMembersSetContactsAsMembersClickOnImportContacts(params) {
    return { evid: 1637, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSetContactsAsMembersClickOnApplyLabel' event (evid: 1638)
 *
 * Event description: The user chose specific contacts' labels to be included in the set contacts as members action
 *
 * @param {siteMembersSetContactsAsMembersClickOnApplyLabelParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - user id
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {number} num_labels - number of labels chosen
 * @property {string} platform - platform
 * @return {LogObject<siteMembersSetContactsAsMembersClickOnApplyLabelParams>} LogObject<siteMembersSetContactsAsMembersClickOnApplyLabelParams>
 */
export function siteMembersSetContactsAsMembersClickOnApplyLabel(params) {
    return { evid: 1638, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSetContactsAsMembersModalAction' event (evid: 1639)
 *
 * Event description: The user chose 'email members' or 'cancel' in the choose contacts modal (to be set as site members)
 *
 * @param {siteMembersSetContactsAsMembersModalActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - user id
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @property {string} action - email members/cancel
 * @return {LogObject<siteMembersSetContactsAsMembersModalActionParams>} LogObject<siteMembersSetContactsAsMembersModalActionParams>
 */
export function siteMembersSetContactsAsMembersModalAction(params) {
    return { evid: 1639, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSetContactsAsMembersSuccessClientEvent' event (evid: 1640)
 *
 * Event description: The user successfully set a list of contacts as site members
 *
 * @param {siteMembersSetContactsAsMembersSuccessClientEventParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - user id
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {number} num_contacts - how many contacts were set as members
 * @property {string} platform - platform
 * @return {LogObject<siteMembersSetContactsAsMembersSuccessClientEventParams>} LogObject<siteMembersSetContactsAsMembersSuccessClientEventParams>
 */
export function siteMembersSetContactsAsMembersSuccessClientEvent(params) {
    return { evid: 1640, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSetContactsAsMembersFailedClientEvent' event (evid: 1641)
 *
 * Event description: The user failed in setting a list of contacts as site members
 *
 * @param {siteMembersSetContactsAsMembersFailedClientEventParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - user id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} reason - reason the action failed
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @return {LogObject<siteMembersSetContactsAsMembersFailedClientEventParams>} LogObject<siteMembersSetContactsAsMembersFailedClientEventParams>
 */
export function siteMembersSetContactsAsMembersFailedClientEvent(params) {
    return { evid: 1641, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersContactWasSetAsSiteMemberSrc5Evid1642' event (evid: 1642)
 *
 * Event description: The user chose 'select all'  when he's supposed to choose which contacts to set as members in the modal
 *
 * @param {siteMembersContactWasSetAsSiteMemberSrc5Evid1642Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - user id
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @return {LogObject<siteMembersContactWasSetAsSiteMemberSrc5Evid1642Params>} LogObject<siteMembersContactWasSetAsSiteMemberSrc5Evid1642Params>
 */
export function siteMembersContactWasSetAsSiteMemberSrc5Evid1642(params) {
    return { evid: 1642, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersClickOnCopyLinkFromInAppBrowserLoginComponent' event (evid: 1643)
 *
 * Event description: The visitor clicked on "copy link" in the login component in in-app browser, in order to use social login with FB/Google
 *
 * @param {siteMembersClickOnCopyLinkFromInAppBrowserLoginComponentParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @return {LogObject<siteMembersClickOnCopyLinkFromInAppBrowserLoginComponentParams>} LogObject<siteMembersClickOnCopyLinkFromInAppBrowserLoginComponentParams>
 */
export function siteMembersClickOnCopyLinkFromInAppBrowserLoginComponent(params) {
    return { evid: 1643, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersEmailConfirmationForNewMembersEnablesDisables' event (evid: 1653)
 *
 * Event description: Sent every time the user chooses to enable/disable the email confirmation requirement for all new site members toggle in the signup settings modal
 *
 * @param {siteMembersEmailConfirmationForNewMembersEnablesDisablesParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - user id
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @property {string} action - enable/disable
 * @return {LogObject<siteMembersEmailConfirmationForNewMembersEnablesDisablesParams>} LogObject<siteMembersEmailConfirmationForNewMembersEnablesDisablesParams>
 */
export function siteMembersEmailConfirmationForNewMembersEnablesDisables(params) {
    return { evid: 1653, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersEmailConfirmationRequirementForNewMembersSuccessfullySaved' event (evid: 1657)
 *
 * Event description: The user saved the Signup, Login and Security - who can be a site member; email confirmation requirement for all new site members; reCAPTCHA settings
 *
 * @param {siteMembersEmailConfirmationRequirementForNewMembersSuccessfullySavedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} who_can_be_a_member - "everyone-who-signs-up" / "people-i-approve"
 * @property {GUID} uuid - user id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} email_confirmation_action - Determines the settings for email confirmation using OTP for new members: "enabled-after" / "enabled-during" / "disable"
 * @property {GUID} vsi - vsi
 * @property {string} signup_recaptcha - Determines the settings for recaptcha setting during signup: "enabled-always" (will present a challenge to everyone) / "enabled-invisible" (will present a challenge only for suspected bots) / "disable" (will not present a challenge)
 * @property {string} platform - platform
 * @property {string} action - ** Please ignore **
 * @property {string} login_recaptcha - Determines the settings for recaptcha setting during login: "enabled-always" (will present a challenge to everyone) / "enabled-invisible" (will present a challenge only for suspected bots) / "disable" (will not present a challenge)
 * @return {LogObject<siteMembersEmailConfirmationRequirementForNewMembersSuccessfullySavedParams>} LogObject<siteMembersEmailConfirmationRequirementForNewMembersSuccessfullySavedParams>
 */
export function siteMembersEmailConfirmationRequirementForNewMembersSuccessfullySaved(params) {
    return { evid: 1657, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bizManagerShowWarningMessage' event (evid: 1670)
 *
 * Event description: warning message is shown
 *
 * @param {bizManagerShowWarningMessageParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} item_name - signup, permissions_table, member_profile
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @return {LogObject<bizManagerShowWarningMessageParams>} LogObject<bizManagerShowWarningMessageParams>
 */
export function bizManagerShowWarningMessage(params) {
    return { evid: 1670, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'email2FaSetupEnableClick' event (evid: 1672)
 *
 * Event description: The user click on 'enable' to enable Email 2FA
 *
 * @param {email2FaSetupEnableClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - account settings page/phone modal/app modal/second best
 * @property {string} platform - platform
 * @return {LogObject<email2FaSetupEnableClickParams>} LogObject<email2FaSetupEnableClickParams>
 */
export function email2FaSetupEnableClick(params) {
    return { evid: 1672, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'email2FaSetupSendCode' event (evid: 1673)
 *
 * Event description: The user clicks on 'send code' or 'resend code' in the email 2fa setup modal
 *
 * @param {email2FaSetupSendCodeParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} action - send/resend
 * @property {string} origin - The origin of the page (Account settings\ 2fa enforcement)
 * @return {LogObject<email2FaSetupSendCodeParams>} LogObject<email2FaSetupSendCodeParams>
 */
export function email2FaSetupSendCode(params) {
    return { evid: 1673, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'email2FaSetupSendCodeSuccess' event (evid: 1674)
 *
 * Event description: The code was successfully sent to the user's email after he clicked on send code
 *
 * @param {email2FaSetupSendCodeSuccessParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} action - send/resend
 * @property {string} origin - The origin of the page (Account settings\ 2fa enforcement)
 * @return {LogObject<email2FaSetupSendCodeSuccessParams>} LogObject<email2FaSetupSendCodeSuccessParams>
 */
export function email2FaSetupSendCodeSuccess(params) {
    return { evid: 1674, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'email2FaSetupSendCodeFail' event (evid: 1675)
 *
 * Event description: The code was not sent to the user's email after he clicked on send code
 *
 * @param {email2FaSetupSendCodeFailParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} action - send/resend
 * @property {string} origin - The origin of the page (Account settings\ 2fa enforcement)
 * @return {LogObject<email2FaSetupSendCodeFailParams>} LogObject<email2FaSetupSendCodeFailParams>
 */
export function email2FaSetupSendCodeFail(params) {
    return { evid: 1675, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'email2FaSetupChangeAccountEmail' event (evid: 1676)
 *
 * Event description: The user clicks on 'change account email' in the email 2fa setup modal
 *
 * @param {email2FaSetupChangeAccountEmailParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<email2FaSetupChangeAccountEmailParams>} LogObject<email2FaSetupChangeAccountEmailParams>
 */
export function email2FaSetupChangeAccountEmail(params) {
    return { evid: 1676, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'email2FaSetupEnterCode' event (evid: 1677)
 *
 * Event description: The user clicks on 'ok' in the email 2fa setup modal after entering the 6-digit code he received by email
 *
 * @param {email2FaSetupEnterCodeParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {boolean} is_valid - did the user enter the correct code sent to his email
 * @property {string} platform - platform
 * @property {string} origin - The origin of the page (Account settings\ 2fa enforcement)
 * @return {LogObject<email2FaSetupEnterCodeParams>} LogObject<email2FaSetupEnterCodeParams>
 */
export function email2FaSetupEnterCode(params) {
    return { evid: 1677, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'email2FaSetupCodeErrorMessage' event (evid: 1678)
 *
 * Event description: The user sees an error message after entering a code in the email 2fa setup modal
 *
 * @param {email2FaSetupCodeErrorMessageParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} error_reason - reason for error message
 * @property {string} platform - platform
 * @property {number} error_code - error numeric code
 * @property {string} origin - The origin of the page (Account settings\ 2fa enforcement)
 * @return {LogObject<email2FaSetupCodeErrorMessageParams>} LogObject<email2FaSetupCodeErrorMessageParams>
 */
export function email2FaSetupCodeErrorMessage(params) {
    return { evid: 1678, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'email2FaSetupEnableSuccessClient' event (evid: 1679)
 *
 * Event description: The user successfully enabled 2FA by Email
 *
 * @param {email2FaSetupEnableSuccessClientParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<email2FaSetupEnableSuccessClientParams>} LogObject<email2FaSetupEnableSuccessClientParams>
 */
export function email2FaSetupEnableSuccessClient(params) {
    return { evid: 1679, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'email2FaSetupDisableClick' event (evid: 1680)
 *
 * Event description: The user clicked on 'disable' to disable Email 2FA
 *
 * @param {email2FaSetupDisableClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<email2FaSetupDisableClickParams>} LogObject<email2FaSetupDisableClickParams>
 */
export function email2FaSetupDisableClick(params) {
    return { evid: 1680, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'email2FaSetupDisableConfirm' event (evid: 1681)
 *
 * Event description: The user clicks on "disable" in the disable modal for email 2FA
 * (confirms disable)
 *
 * @param {email2FaSetupDisableConfirmParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<email2FaSetupDisableConfirmParams>} LogObject<email2FaSetupDisableConfirmParams>
 */
export function email2FaSetupDisableConfirm(params) {
    return { evid: 1681, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountSettingsChangeEmailAddressClickOnSure' event (evid: 1682)
 *
 * Event description: The user tries to change email address while email 2FA is enabled, sees the email 2FA modal warning him it will be disabled and clicks on 'sure'
 *
 * @param {accountSettingsChangeEmailAddressClickOnSureParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<accountSettingsChangeEmailAddressClickOnSureParams>} LogObject<accountSettingsChangeEmailAddressClickOnSureParams>
 */
export function accountSettingsChangeEmailAddressClickOnSure(params) {
    return { evid: 1682, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ssoSettingsUpdateSsoSettings' event (evid: 1683)
 *
 * Event description: The user updated the SSO settings page
 *
 * @param {ssoSettingsUpdateSsoSettingsParams} params - The parameters for this event
 * @property {GUID} sso_id - sso_id
 * @property {string} view_type - view_type
 * @property {boolean} is_first_update - Is it the first time the user updates SSO settings. The first time will not have sso_id.
 * @property {string} sso_user_type - DIFM/DIY (is the SSO of type Do It For Me/ Do It Yourself)
 * @property {string} platform - platform
 * @return {LogObject<ssoSettingsUpdateSsoSettingsParams>} LogObject<ssoSettingsUpdateSsoSettingsParams>
 */
export function ssoSettingsUpdateSsoSettings(params) {
    return { evid: 1683, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cachePredictionSrc5Evid1726' event (evid: 1726)
 *
 * Event description: cache prediction for site members
 *
 * @param {cachePredictionSrc5Evid1726Params} params - The parameters for this event
 * @return {LogObject<cachePredictionSrc5Evid1726Params>} LogObject<cachePredictionSrc5Evid1726Params>
 */
export function cachePredictionSrc5Evid1726(params) {
    return { evid: 1726, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersAuthenticationPagesAppInstalledSrc5Evid1731' event (evid: 1731)
 *
 * Event description: When the user installs the Site members authentication pages (Signup & login, Forgot password, Create new password, Email confirmation, Reset password, Admin approval and Access restriction for members pages), with the installation status.
 *
 * @param {siteMembersAuthenticationPagesAppInstalledSrc5Evid1731Params} params - The parameters for this event
 * @property {string} meta_site_id - msid
 * @property {string} app_id - The app_id
 * @property {string} error - The error type
 * @property {boolean} is_success - Was the application installed successfully
 * @return {LogObject<siteMembersAuthenticationPagesAppInstalledSrc5Evid1731Params>} LogObject<siteMembersAuthenticationPagesAppInstalledSrc5Evid1731Params>
 */
export function siteMembersAuthenticationPagesAppInstalledSrc5Evid1731(params) {
    return { evid: 1731, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'app2FaSetupEnableClick' event (evid: 1738)
 *
 * Event description: The user clicked on 'enable' in the account settings page, or clicked on 'Add app verification' in the phone/email 2FA setup modals.
 *
 * @param {app2FaSetupEnableClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - account settings page/phone modal/email modal/second best
 * @property {string} platform - platform
 * @return {LogObject<app2FaSetupEnableClickParams>} LogObject<app2FaSetupEnableClickParams>
 */
export function app2FaSetupEnableClick(params) {
    return { evid: 1738, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'app2FaSetupClickOnNextAfterScanningQrCode' event (evid: 1739)
 *
 * Event description: The user scanned the QR code, or entered the code manually in the authentication app, and clicked on next.
 *
 * @param {app2FaSetupClickOnNextAfterScanningQrCodeParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - account settings page/phone modal/email modal
 * @property {string} mode - change app/enable
 * @property {string} platform - platform
 * @return {LogObject<app2FaSetupClickOnNextAfterScanningQrCodeParams>} LogObject<app2FaSetupClickOnNextAfterScanningQrCodeParams>
 */
export function app2FaSetupClickOnNextAfterScanningQrCode(params) {
    return { evid: 1739, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'app2FaSetupClickOnCopyCode' event (evid: 1740)
 *
 * Event description: The user clicked on 'copy code' in the QR scan step of the app 2FA enable modal.
 *
 * @param {app2FaSetupClickOnCopyCodeParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} mode - change app/enable
 * @property {string} platform - platform
 * @property {string} origin - The screen origin (Account settings \ 2fa enforcement)
 * @return {LogObject<app2FaSetupClickOnCopyCodeParams>} LogObject<app2FaSetupClickOnCopyCodeParams>
 */
export function app2FaSetupClickOnCopyCode(params) {
    return { evid: 1740, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'app2FaSetupSubmitCode' event (evid: 1741)
 *
 * Event description: The user clicks on 'submit' in the app 2fa setup modal after entering the 6-digit code from the authenticator app
 *
 * @param {app2FaSetupSubmitCodeParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} mode - change app/enable
 * @property {string} platform - platform
 * @property {string} origin - The screen origin (Account settings \ 2fa enforcement)
 * @return {LogObject<app2FaSetupSubmitCodeParams>} LogObject<app2FaSetupSubmitCodeParams>
 */
export function app2FaSetupSubmitCode(params) {
    return { evid: 1741, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'app2FaSetupDisableClick' event (evid: 1742)
 *
 * Event description: App 2FA Setup - Disable Click.
 *
 * @param {app2FaSetupDisableClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<app2FaSetupDisableClickParams>} LogObject<app2FaSetupDisableClickParams>
 */
export function app2FaSetupDisableClick(params) {
    return { evid: 1742, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'app2FaSetupDisableConfirm' event (evid: 1743)
 *
 * Event description: The user clicks on disable in the disable modal, to confirm the action
 *
 * @param {app2FaSetupDisableConfirmParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<app2FaSetupDisableConfirmParams>} LogObject<app2FaSetupDisableConfirmParams>
 */
export function app2FaSetupDisableConfirm(params) {
    return { evid: 1743, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'app2FaSetupClickOnChangeApp' event (evid: 1744)
 *
 * Event description: The user clicks on 'Change App' to change the authenticator app
 *
 * @param {app2FaSetupClickOnChangeAppParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<app2FaSetupClickOnChangeAppParams>} LogObject<app2FaSetupClickOnChangeAppParams>
 */
export function app2FaSetupClickOnChangeApp(params) {
    return { evid: 1744, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'app2FaSetupConfirmChangeApp' event (evid: 1745)
 *
 * Event description: The user clicks on 'Change' in the change app modal, to confirm the action
 *
 * @param {app2FaSetupConfirmChangeAppParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<app2FaSetupConfirmChangeAppParams>} LogObject<app2FaSetupConfirmChangeAppParams>
 */
export function app2FaSetupConfirmChangeApp(params) {
    return { evid: 1745, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'app2FaSetupCodeErrorMessage' event (evid: 1746)
 *
 * Event description: An error message shown to a user who entered an invalid 6-digit code in the 2FA app setup
 *
 * @param {app2FaSetupCodeErrorMessageParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} error_reason - reason for error
 * @property {string} mode - change app/enable
 * @property {string} platform - platform
 * @property {number} error_code - error_code
 * @property {string} origin - The origin page of the click
 * @return {LogObject<app2FaSetupCodeErrorMessageParams>} LogObject<app2FaSetupCodeErrorMessageParams>
 */
export function app2FaSetupCodeErrorMessage(params) {
    return { evid: 1746, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'app2FaSetupClickOnBack' event (evid: 1747)
 *
 * Event description: The user clicked on 'back' in the enter code step, when enabling app 2fa
 *
 * @param {app2FaSetupClickOnBackParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} mode - change app/enable
 * @property {string} platform - platform
 * @property {string} origin - The page origin (Account settings\ 2fa enforcement)
 * @return {LogObject<app2FaSetupClickOnBackParams>} LogObject<app2FaSetupClickOnBackParams>
 */
export function app2FaSetupClickOnBack(params) {
    return { evid: 1747, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersAreaSettingsSelectDigestFrequency' event (evid: 1750)
 *
 * Event description: When a member is changing the frequency of digest emails in the settings page in members area (to be able to change the frequency
 * settings group toggle has to be ON)
 *
 * @param {membersAreaSettingsSelectDigestFrequencyParams} params - The parameters for this event
 * @property {GUID} instance_id - instance id of members area
 * @property {string} channel - notifications channel: email
 * @property {string} toggleName - the name of the toggle. f.e. likes,comment etc. (the name of the setting group actually)
 * @property {GUID} biToken - site guid
 * @property {string} description - toggle description. f.e. get a summary of all the action in the forum. if there is no description then null
 * @property {GUID} visitor_id - visitor id
 * @property {GUID} vsi - vsi
 * @property {GUID} site_member_id - UUID of the member
 * @property {string} title - title name. f.e. Forum (the name of the section actually)
 * @property {string} digestLevel - the frequency the member selects to get digest emails: daily/weekly
 * @property {string} platform - deprecated
 * @return {LogObject<membersAreaSettingsSelectDigestFrequencyParams>} LogObject<membersAreaSettingsSelectDigestFrequencyParams>
 */
export function membersAreaSettingsSelectDigestFrequency(params) {
    return { evid: 1750, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersFilterContactsClear' event (evid: 1762)
 *
 * Event description: User cleared the filtered from the displayed members
 *
 * @param {siteMembersFilterContactsClearParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {number} membersDisplayed - number of original member list to display
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @return {LogObject<siteMembersFilterContactsClearParams>} LogObject<siteMembersFilterContactsClearParams>
 */
export function siteMembersFilterContactsClear(params) {
    return { evid: 1762, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersInfoWidgetWidgetLoaded' event (evid: 1772)
 *
 * Event description: Site member info widget loaded (on member panel in the members list, or in the member's contact page)
 *
 * @param {siteMembersInfoWidgetWidgetLoadedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} loaction - member panel/contact page
 * @property {GUID} vsi - vsi
 * @property {GUID} contact_id - contact_id
 * @property {string} platform - platform
 * @return {LogObject<siteMembersInfoWidgetWidgetLoadedParams>} LogObject<siteMembersInfoWidgetWidgetLoadedParams>
 */
export function siteMembersInfoWidgetWidgetLoaded(params) {
    return { evid: 1772, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersInfoWidgetShowMoreOrLessMemberInfo' event (evid: 1773)
 *
 * Event description: The user clicked on 'show more info' (expand) or 'show less info' (collapse) in the member info widget
 *
 * @param {siteMembersInfoWidgetShowMoreOrLessMemberInfoParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} location - member panel/contact page
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} contact_id - contact_id
 * @property {string} platform - platform
 * @property {string} action - expand/collapse
 * @return {LogObject<siteMembersInfoWidgetShowMoreOrLessMemberInfoParams>} LogObject<siteMembersInfoWidgetShowMoreOrLessMemberInfoParams>
 */
export function siteMembersInfoWidgetShowMoreOrLessMemberInfo(params) {
    return { evid: 1773, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersInfoWidgetManageMemberClick' event (evid: 1774)
 *
 * Event description: The user clicked "manage member" in the member info widget
 *
 * @param {siteMembersInfoWidgetManageMemberClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} location - member panel/contact page
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} contact_id - contact_id
 * @property {string} platform - platform
 * @return {LogObject<siteMembersInfoWidgetManageMemberClickParams>} LogObject<siteMembersInfoWidgetManageMemberClickParams>
 */
export function siteMembersInfoWidgetManageMemberClick(params) {
    return { evid: 1774, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersInfoWidgetManageMemberMenuSelection' event (evid: 1775)
 *
 * Event description: The user chose an action from the manage member menu
 *
 * @param {siteMembersInfoWidgetManageMemberMenuSelectionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} location - member panel/contact page
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} contact_id - contact_id
 * @property {string} platform - platform
 * @property {string} action - reset password/block member/unblock member/approve member/delete member/change login email
 * @return {LogObject<siteMembersInfoWidgetManageMemberMenuSelectionParams>} LogObject<siteMembersInfoWidgetManageMemberMenuSelectionParams>
 */
export function siteMembersInfoWidgetManageMemberMenuSelection(params) {
    return { evid: 1775, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersInfoWidgetSetContactAsMemberClick' event (evid: 1776)
 *
 * Event description: The user clicked on "set contact as member" for an existing contact (not yet a member)
 *
 * @param {siteMembersInfoWidgetSetContactAsMemberClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} location - member panel/contact page
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} contact_id - contact_id
 * @property {string} platform - platform
 * @return {LogObject<siteMembersInfoWidgetSetContactAsMemberClickParams>} LogObject<siteMembersInfoWidgetSetContactAsMemberClickParams>
 */
export function siteMembersInfoWidgetSetContactAsMemberClick(params) {
    return { evid: 1776, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersInfoWidgetBlockPendingMember' event (evid: 1777)
 *
 * Event description: The user blocked a pending member from the notification in the member info widget
 *
 * @param {siteMembersInfoWidgetBlockPendingMemberParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} location - member panel/contact page
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} contact_id - contact_id
 * @property {string} platform - platform
 * @return {LogObject<siteMembersInfoWidgetBlockPendingMemberParams>} LogObject<siteMembersInfoWidgetBlockPendingMemberParams>
 */
export function siteMembersInfoWidgetBlockPendingMember(params) {
    return { evid: 1777, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersInfoWidgetApprovePendingMember' event (evid: 1778)
 *
 * Event description: The user approved a pending member from the notification in the member info widget
 *
 * @param {siteMembersInfoWidgetApprovePendingMemberParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} location - member panel/contact page
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} contact_id - contact_id
 * @property {string} platform - platform
 * @return {LogObject<siteMembersInfoWidgetApprovePendingMemberParams>} LogObject<siteMembersInfoWidgetApprovePendingMemberParams>
 */
export function siteMembersInfoWidgetApprovePendingMember(params) {
    return { evid: 1778, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersInfoWidgetEditLoginEmailClick' event (evid: 1779)
 *
 * Event description: The user clicked on edit login email (the pencil icon) in the member info widget (not from the manage member menu in the widget)
 *
 * @param {siteMembersInfoWidgetEditLoginEmailClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} location - member panel/contact page
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} contact_id - contact_id
 * @property {string} platform - platform
 * @return {LogObject<siteMembersInfoWidgetEditLoginEmailClickParams>} LogObject<siteMembersInfoWidgetEditLoginEmailClickParams>
 */
export function siteMembersInfoWidgetEditLoginEmailClick(params) {
    return { evid: 1779, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersInfoWidgetEditMemberRolesClick' event (evid: 1780)
 *
 * Event description: The user clicked on 'edit roles' (pencil icon, when the member already has roles) or 'add roles' (when the member still doesn't have any roles) in the member info widget or members table
 *
 * @param {siteMembersInfoWidgetEditMemberRolesClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} location - member panel: via the widget embedded in the side panel (regardless of which page opened the panel); contact page; members table
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} contact_id - contact_id
 * @property {string} platform - platform
 * @property {string} action - edit/add
 * @return {LogObject<siteMembersInfoWidgetEditMemberRolesClickParams>} LogObject<siteMembersInfoWidgetEditMemberRolesClickParams>
 */
export function siteMembersInfoWidgetEditMemberRolesClick(params) {
    return { evid: 1780, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersInfoWidgetEditMemberRolesModalLoad' event (evid: 1781)
 *
 * Event description: edit member roles modal load
 *
 * @param {siteMembersInfoWidgetEditMemberRolesModalLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} location - member panel: via the widget embedded in the side panel (regardless of which page opened the panel); contact page; members table
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} contact_id - contact_id
 * @property {string} platform - platform
 * @return {LogObject<siteMembersInfoWidgetEditMemberRolesModalLoadParams>} LogObject<siteMembersInfoWidgetEditMemberRolesModalLoadParams>
 */
export function siteMembersInfoWidgetEditMemberRolesModalLoad(params) {
    return { evid: 1781, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersInfoWidgetSaveMemberRolesClick' event (evid: 1782)
 *
 * Event description: The user saved the updated member roles (after editing)
 *
 * @param {siteMembersInfoWidgetSaveMemberRolesClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} location - member panel: via the widget embedded in the side panel (regardless of which page opened the panel); contact page; members table
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} contact_id - contact_id
 * @property {string} platform - platform
 * @return {LogObject<siteMembersInfoWidgetSaveMemberRolesClickParams>} LogObject<siteMembersInfoWidgetSaveMemberRolesClickParams>
 */
export function siteMembersInfoWidgetSaveMemberRolesClick(params) {
    return { evid: 1782, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersInfoWidgetLearnAboutMemberRolesClick' event (evid: 1783)
 *
 * Event description: The user clicked on 'learn about member roles' in the member info widget, when there are no member roles defined at all.
 *
 * @param {siteMembersInfoWidgetLearnAboutMemberRolesClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} location - member panel/contact page
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} contact_id - contact_id
 * @property {string} platform - platform
 * @return {LogObject<siteMembersInfoWidgetLearnAboutMemberRolesClickParams>} LogObject<siteMembersInfoWidgetLearnAboutMemberRolesClickParams>
 */
export function siteMembersInfoWidgetLearnAboutMemberRolesClick(params) {
    return { evid: 1783, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountSettingsChangeEmailAddressModalClickOnNext' event (evid: 1784)
 *
 * Event description: The user clicks on next in the modal that opens when he wants to change email address
 *
 * @param {accountSettingsChangeEmailAddressModalClickOnNextParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<accountSettingsChangeEmailAddressModalClickOnNextParams>} LogObject<accountSettingsChangeEmailAddressModalClickOnNextParams>
 */
export function accountSettingsChangeEmailAddressModalClickOnNext(params) {
    return { evid: 1784, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountSettingsChangeEmailAddressModalSubmit' event (evid: 1785)
 *
 * Event description: The user clicks on submit after entering the code in the change email address modal
 *
 * @param {accountSettingsChangeEmailAddressModalSubmitParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<accountSettingsChangeEmailAddressModalSubmitParams>} LogObject<accountSettingsChangeEmailAddressModalSubmitParams>
 */
export function accountSettingsChangeEmailAddressModalSubmit(params) {
    return { evid: 1785, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountSettingsChangeEmailAddressModalResendCode' event (evid: 1786)
 *
 * Event description: The user clicks on resend code in the change email address modal
 *
 * @param {accountSettingsChangeEmailAddressModalResendCodeParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<accountSettingsChangeEmailAddressModalResendCodeParams>} LogObject<accountSettingsChangeEmailAddressModalResendCodeParams>
 */
export function accountSettingsChangeEmailAddressModalResendCode(params) {
    return { evid: 1786, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountSettingsChangeEmailAddressModalCancelChanges' event (evid: 1787)
 *
 * Event description: The user clicked on 'cancel' to confirm that the change email address action was canceled
 *
 * @param {accountSettingsChangeEmailAddressModalCancelChangesParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<accountSettingsChangeEmailAddressModalCancelChangesParams>} LogObject<accountSettingsChangeEmailAddressModalCancelChangesParams>
 */
export function accountSettingsChangeEmailAddressModalCancelChanges(params) {
    return { evid: 1787, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersAuthenticationPagesOpenPageSrc5Evid1788' event (evid: 1788)
 *
 * Event description: When the user chooses to open an authentication page in the editor
 *
 * @param {siteMembersAuthenticationPagesOpenPageSrc5Evid1788Params} params - The parameters for this event
 * @property {string} meta_site_id - msid
 * @property {string} page_name - The page the user choose to open
 * @property {string} editorType - {Editor/Wix Studio}
 * @return {LogObject<siteMembersAuthenticationPagesOpenPageSrc5Evid1788Params>} LogObject<siteMembersAuthenticationPagesOpenPageSrc5Evid1788Params>
 */
export function siteMembersAuthenticationPagesOpenPageSrc5Evid1788(params) {
    return { evid: 1788, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersAuthenticationPagesChooseWidgetModeSrc5Evid1789' event (evid: 1789)
 *
 * Event description: When the user choses different mode in the site members authentication page widgets.
 *
 * @param {siteMembersAuthenticationPagesChooseWidgetModeSrc5Evid1789Params} params - The parameters for this event
 * @property {string} modes - All the widget mode types (for example - create password, success, error)
 * @property {string} chosen_mode - The chosen mode
 * @property {string} meta_site_id - msid
 * @return {LogObject<siteMembersAuthenticationPagesChooseWidgetModeSrc5Evid1789Params>} LogObject<siteMembersAuthenticationPagesChooseWidgetModeSrc5Evid1789Params>
 */
export function siteMembersAuthenticationPagesChooseWidgetModeSrc5Evid1789(params) {
    return { evid: 1789, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersBulkDeletionModalOpen' event (evid: 1793)
 *
 * Event description: User clicked on "delete members" button  (after marking members to be deleted), and opened the deletion modal
 *
 * @param {siteMembersBulkDeletionModalOpenParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {number} counter - Counter of how many members have been chosen for deletion
 * @property {string} platform - platform
 * @return {LogObject<siteMembersBulkDeletionModalOpenParams>} LogObject<siteMembersBulkDeletionModalOpenParams>
 */
export function siteMembersBulkDeletionModalOpen(params) {
    return { evid: 1793, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersBulkDeletionButtonClick' event (evid: 1808)
 *
 * Event description: In the "bulk members deletion" modal, user clicked on "delete" button
 *
 * @param {siteMembersBulkDeletionButtonClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {boolean} flag - TRUE = remove deleted members from contacts
 * @property {number} counter - Counter of how many members have been chosen for deletion
 * @property {string} platform - platform
 * @return {LogObject<siteMembersBulkDeletionButtonClickParams>} LogObject<siteMembersBulkDeletionButtonClickParams>
 */
export function siteMembersBulkDeletionButtonClick(params) {
    return { evid: 1808, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersEmailConfirmationForNewMembersModalLoad' event (evid: 1809)
 *
 * Event description: Member email confirmation modal load following a member sign up
 *
 * @param {siteMembersEmailConfirmationForNewMembersModalLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} origin - origin
 * @property {string} platform - platform
 * @return {LogObject<siteMembersEmailConfirmationForNewMembersModalLoadParams>} LogObject<siteMembersEmailConfirmationForNewMembersModalLoadParams>
 */
export function siteMembersEmailConfirmationForNewMembersModalLoad(params) {
    return { evid: 1809, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersEmailConfirmationForNewMembersModalClickSend' event (evid: 1810)
 *
 * Event description: In the member email confirmation modal, user clicked "send"
 *
 * @param {siteMembersEmailConfirmationForNewMembersModalClickSendParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} platform - platform
 * @return {LogObject<siteMembersEmailConfirmationForNewMembersModalClickSendParams>} LogObject<siteMembersEmailConfirmationForNewMembersModalClickSendParams>
 */
export function siteMembersEmailConfirmationForNewMembersModalClickSend(params) {
    return { evid: 1810, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersEmailConfirmationForNewMembersModalClickResendCode' event (evid: 1811)
 *
 * Event description: In the member email confirmation modal, user clicked "resend code"
 *
 * @param {siteMembersEmailConfirmationForNewMembersModalClickResendCodeParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} platform - platform
 * @return {LogObject<siteMembersEmailConfirmationForNewMembersModalClickResendCodeParams>} LogObject<siteMembersEmailConfirmationForNewMembersModalClickResendCodeParams>
 */
export function siteMembersEmailConfirmationForNewMembersModalClickResendCode(params) {
    return { evid: 1811, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersBulkDeletionSummary' event (evid: 1816)
 *
 * Event description: Bulk deletion action completed, this event summarizes the results of the bulk action (how many attempted; deleted; not deleted because they are contributors; not deleted because of server error; not deleted because they have subscription; is deleted from contacts as well)
 *
 * @param {siteMembersBulkDeletionSummaryParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {number} deleted_failed_contributors - Counter of how many members have failed to be deleted due to being contributors
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {number} delete_failed_subscription - Counter of how many members have failed to be deleted due to having subscription to the site
 * @property {GUID} vsi - vsi
 * @property {number} deleted_failed_server_error - Counter of how many members have failed to be deleted due to a server error
 * @property {number} attemptCount - Counter of how many members have been chosen for deletion
 * @property {string} platform - platform
 * @property {boolean} is_deleted_from_contacts - Were members successfully deleted from members but not from contacts?
 * @property {number} deleted_success - Counter of how many members were successfully deleted
 * @return {LogObject<siteMembersBulkDeletionSummaryParams>} LogObject<siteMembersBulkDeletionSummaryParams>
 */
export function siteMembersBulkDeletionSummary(params) {
    return { evid: 1816, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersFedopsAppLoadedSentMoreThanOnce' event (evid: 1821)
 *
 * Event description: Site Members success rate stands on 140%~, we want to track down the problematic cases.
 *
 * @param {siteMembersFedopsAppLoadedSentMoreThanOnceParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} userId - user id
 * @property {string} platform - platform
 * @return {LogObject<siteMembersFedopsAppLoadedSentMoreThanOnceParams>} LogObject<siteMembersFedopsAppLoadedSentMoreThanOnceParams>
 */
export function siteMembersFedopsAppLoadedSentMoreThanOnce(params) {
    return { evid: 1821, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersManagementCustomColumnButtonClick' event (evid: 1822)
 *
 * Event description: Under the Site Members Management page in BM, after the user clicked on the "custom columns" button to edit the  table, the event list the action (check/uncheck) on of the columns names in the sidebar
 *
 * @param {siteMembersManagementCustomColumnButtonClickParams} params - The parameters for this event
 * @property {GUID} instance_id - (deprecated) Instance ID
 * @property {GUID} biToken - (deprecated) MSID
 * @property {string} column_name - Name of the column to show / hide from view
 * @property {GUID} visitor_id - (deprecated) Visitor ID
 * @property {boolean} checkbox - Action done on the column: true = check = show column in view; false = uncheck = remove column from view
 * @property {GUID} vsi - vsi
 * @property {string} platform - (deprecated) Platform
 * @return {LogObject<siteMembersManagementCustomColumnButtonClickParams>} LogObject<siteMembersManagementCustomColumnButtonClickParams>
 */
export function siteMembersManagementCustomColumnButtonClick(params) {
    return { evid: 1822, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSsoSettingsSave' event (evid: 1837)
 *
 * Event description: Account / Site owner clicked "save" in "SSO Settings" page for the account/site
 *
 * @param {siteMembersSsoSettingsSaveParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} sso_context - For accounts: 'DIFM'/'DIY'; For sites: 'Site Members'
 * @property {GUID} sso_id - ID of the IDP of sso (will be empty for first time)
 * @property {GUID} biToken - msid
 * @property {string} sso_status - "enabled" / "disabled"
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_sso_required - true = login/signup to site will redirect to SSO and some site login settings are disabled; false: SSO is optional, login with SSO will be added as an option to the login/signup dialog
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @return {LogObject<siteMembersSsoSettingsSaveParams>} LogObject<siteMembersSsoSettingsSaveParams>
 */
export function siteMembersSsoSettingsSave(params) {
    return { evid: 1837, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersManagementUserClickedOnChangeEmailForMember' event (evid: 1840)
 *
 * Event description: When the user clicks on "Change Email" for the site member in the BM.
 *
 * @param {siteMembersManagementUserClickedOnChangeEmailForMemberParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} location - From which screen the user clicked - "Site members management"/"Members info widget"/"Contact page"
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} contact_id - which member the user want to change their login email
 * @property {string} platform - platform
 * @return {LogObject<siteMembersManagementUserClickedOnChangeEmailForMemberParams>} LogObject<siteMembersManagementUserClickedOnChangeEmailForMemberParams>
 */
export function siteMembersManagementUserClickedOnChangeEmailForMember(params) {
    return { evid: 1840, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersManagementChangeMemberEmailModalLoad' event (evid: 1841)
 *
 * Event description: When the  "Change Email" modal loads for the user in the business manager.
 *
 * @param {siteMembersManagementChangeMemberEmailModalLoadParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} site_member_id - which member the user want to change their login email
 * @property {GUID} contact_id - which member the user want to change their login email
 * @property {string} platform - platform
 * @property {string} origin_view - Origin page (Site members \ contacts)
 * @return {LogObject<siteMembersManagementChangeMemberEmailModalLoadParams>} LogObject<siteMembersManagementChangeMemberEmailModalLoadParams>
 */
export function siteMembersManagementChangeMemberEmailModalLoad(params) {
    return { evid: 1841, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersManagementUserSuccessfullyChangedMembersLoginEmail' event (evid: 1842)
 *
 * Event description: The user successfully changed the members login email
 *
 * @param {siteMembersManagementUserSuccessfullyChangedMembersLoginEmailParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} site_member_id - which member the user want to change their login email
 * @property {GUID} contact_id - which which member the user want to change their login emailthe user want to change their login email
 * @property {string} platform - platform
 * @property {string} origin_view - Origin page (Site members \ contacts)
 * @return {LogObject<siteMembersManagementUserSuccessfullyChangedMembersLoginEmailParams>} LogObject<siteMembersManagementUserSuccessfullyChangedMembersLoginEmailParams>
 */
export function siteMembersManagementUserSuccessfullyChangedMembersLoginEmail(params) {
    return { evid: 1842, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersManagementUserFailedToChangeMembersLoginEmail' event (evid: 1843)
 *
 * Event description: The user failed to change the members login email, with all relevant errors.
 *
 * @param {siteMembersManagementUserFailedToChangeMembersLoginEmailParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} reason - reason for failure (for example "email is already taken"\"technical issues")
 * @property {GUID} vsi - vsi
 * @property {GUID} contact_id - which member the user want to change their login email
 * @property {string} platform - platform
 * @property {string} origin_view - From which page (Contacts\site members)
 * @return {LogObject<siteMembersManagementUserFailedToChangeMembersLoginEmailParams>} LogObject<siteMembersManagementUserFailedToChangeMembersLoginEmailParams>
 */
export function siteMembersManagementUserFailedToChangeMembersLoginEmail(params) {
    return { evid: 1843, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersUserClickedViewAndManageMembers' event (evid: 1844)
 *
 * Event description: User clicked "View and Manage Members" and was redirected to the Site Members Management Page
 *
 * @param {siteMembersUserClickedViewAndManageMembersParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} state - when origin is "contact_page" this field indicates whether the CTA came with "view_only" (when there are no pending requests) / "view_with_pending" (when there are pending requests)
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} origin - contacts_page / site_members_settings
 * @property {string} platform - platform
 * @property {string} button_clicked - The button the user clicked on in the site members bar ("Manage Member access”\”site members”\”pending approval”)
 * @property {string} hoverButton - Indication when the user hovers over the “i” icon near the number of site members
 * @return {LogObject<siteMembersUserClickedViewAndManageMembersParams>} LogObject<siteMembersUserClickedViewAndManageMembersParams>
 */
export function siteMembersUserClickedViewAndManageMembers(params) {
    return { evid: 1844, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersUserClickedAwaitingApproval' event (evid: 1845)
 *
 * Event description: The user clicked "awaiting approval" and was redirected to the Site Members Management Page, to the Pending Members tab
 *
 * @param {siteMembersUserClickedAwaitingApprovalParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} origin - contacts_page / site_members_settings
 * @property {string} platform - platform
 * @return {LogObject<siteMembersUserClickedAwaitingApprovalParams>} LogObject<siteMembersUserClickedAwaitingApprovalParams>
 */
export function siteMembersUserClickedAwaitingApproval(params) {
    return { evid: 1845, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersAuthenticationPagesNotificationShownSrc5Evid1846' event (evid: 1846)
 *
 * Event description: When the user get a notification (error) in the editor for the site members authentication pages.
 *
 * @param {siteMembersAuthenticationPagesNotificationShownSrc5Evid1846Params} params - The parameters for this event
 * @property {string} page_name - The page name
 * @property {GUID} meta_site_id - msid
 * @property {string} text - the notification text
 * @property {string} editorType - editor type (studio\editor)
 * @return {LogObject<siteMembersAuthenticationPagesNotificationShownSrc5Evid1846Params>} LogObject<siteMembersAuthenticationPagesNotificationShownSrc5Evid1846Params>
 */
export function siteMembersAuthenticationPagesNotificationShownSrc5Evid1846(params) {
    return { evid: 1846, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'memberResetPasswordViewSrc5Evid1848' event (evid: 1848)
 *
 * Event description: Test for Reset Password view in member authentication dailog.
 *
 * @param {memberResetPasswordViewSrc5Evid1848Params} params - The parameters for this event
 * @return {LogObject<memberResetPasswordViewSrc5Evid1848Params>} LogObject<memberResetPasswordViewSrc5Evid1848Params>
 */
export function memberResetPasswordViewSrc5Evid1848(params) {
    return { evid: 1848, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersAccessRestrictedSwitchAccountClickSrc5Evid1849' event (evid: 1849)
 *
 * Event description: Member clicked on "Switch Account" button in the reset password page.
 *
 * @param {siteMembersAccessRestrictedSwitchAccountClickSrc5Evid1849Params} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} platform - platform
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<siteMembersAccessRestrictedSwitchAccountClickSrc5Evid1849Params>} LogObject<siteMembersAccessRestrictedSwitchAccountClickSrc5Evid1849Params>
 */
export function siteMembersAccessRestrictedSwitchAccountClickSrc5Evid1849(params) {
    return { evid: 1849, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersPendingApprovalPageViewSrc5Evid1851' event (evid: 1851)
 *
 * Event description: Member signup approvel page for. For example, The page will mention: "Success! Your member signup request has been sent and is awaiting approval. The site administrator will notify you via email (abc@gmail.com) once your request has been approved."
 *
 * @param {siteMembersPendingApprovalPageViewSrc5Evid1851Params} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} platform - platform
 * @property {string} origin - origin
 * @return {LogObject<siteMembersPendingApprovalPageViewSrc5Evid1851Params>} LogObject<siteMembersPendingApprovalPageViewSrc5Evid1851Params>
 */
export function siteMembersPendingApprovalPageViewSrc5Evid1851(params) {
    return { evid: 1851, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersForgotPasswordPageViewSrc5Evid1852' event (evid: 1852)
 *
 * Event description: Member Forgot is password page view - The page will indicate that:
 * "Reset password
 * Enter your login email and we’ll send you a link to reset your password."
 *
 * @param {siteMembersForgotPasswordPageViewSrc5Evid1852Params} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} platform - platform
 * @property {string} origin - origin
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<siteMembersForgotPasswordPageViewSrc5Evid1852Params>} LogObject<siteMembersForgotPasswordPageViewSrc5Evid1852Params>
 */
export function siteMembersForgotPasswordPageViewSrc5Evid1852(params) {
    return { evid: 1852, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersForgotPasswordResetPasswordClickSrc5Evid1853' event (evid: 1853)
 *
 * Event description: Member clicked on "Reset Password" button in the reset password page.
 *
 * @param {siteMembersForgotPasswordResetPasswordClickSrc5Evid1853Params} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} platform - platform
 * @property {GUID} instance_id - instance_id
 * @property {string} email - email
 * @return {LogObject<siteMembersForgotPasswordResetPasswordClickSrc5Evid1853Params>} LogObject<siteMembersForgotPasswordResetPasswordClickSrc5Evid1853Params>
 */
export function siteMembersForgotPasswordResetPasswordClickSrc5Evid1853(params) {
    return { evid: 1853, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersNewPasswordPageViewSrc5Evid1854' event (evid: 1854)
 *
 * Event description: Page view for Member Reset password (/New password), The page will indicate that
 * "Reset password
 * Enter your new password below"
 *
 * @param {siteMembersNewPasswordPageViewSrc5Evid1854Params} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} platform - platform
 * @property {string} origin - origin
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<siteMembersNewPasswordPageViewSrc5Evid1854Params>} LogObject<siteMembersNewPasswordPageViewSrc5Evid1854Params>
 */
export function siteMembersNewPasswordPageViewSrc5Evid1854(params) {
    return { evid: 1854, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersNewPasswordCreatePasswordClickSrc5Evid1855' event (evid: 1855)
 *
 * Event description: Member clicked on "Reset Password" button in the reset password page - That is, he will then permanently reset his password.
 *
 * @param {siteMembersNewPasswordCreatePasswordClickSrc5Evid1855Params} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} platform - platform
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<siteMembersNewPasswordCreatePasswordClickSrc5Evid1855Params>} LogObject<siteMembersNewPasswordCreatePasswordClickSrc5Evid1855Params>
 */
export function siteMembersNewPasswordCreatePasswordClickSrc5Evid1855(params) {
    return { evid: 1855, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersAccessRestrictedPageViewSrc5Evid1856' event (evid: 1856)
 *
 * Event description: Member enters a page that is restricted. For example, The page will indicate that: "Access to this page is restricted"
 *
 * @param {siteMembersAccessRestrictedPageViewSrc5Evid1856Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} origin - origin
 * @property {string} platform - platform
 * @return {LogObject<siteMembersAccessRestrictedPageViewSrc5Evid1856Params>} LogObject<siteMembersAccessRestrictedPageViewSrc5Evid1856Params>
 */
export function siteMembersAccessRestrictedPageViewSrc5Evid1856(params) {
    return { evid: 1856, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersForgotPasswordResetPasswordClickCopySrc5Evid1857' event (evid: 1857)
 *
 * Event description: Member clicked on "Back" button in the reset password page. For example: "Back to Site" button.
 *
 * @param {siteMembersForgotPasswordResetPasswordClickCopySrc5Evid1857Params} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} platform - platform
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<siteMembersForgotPasswordResetPasswordClickCopySrc5Evid1857Params>} LogObject<siteMembersForgotPasswordResetPasswordClickCopySrc5Evid1857Params>
 */
export function siteMembersForgotPasswordResetPasswordClickCopySrc5Evid1857(params) {
    return { evid: 1857, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersExpiredLinkPageViewSrc5Evid1859' event (evid: 1859)
 *
 * Event description: Link Expired page view for reset / new password of a Member - For example, the page will indicate that:
 * "This link has expired. To get a new reset link..."
 *
 * @param {siteMembersExpiredLinkPageViewSrc5Evid1859Params} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} platform - platform
 * @property {string} origin - origin
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<siteMembersExpiredLinkPageViewSrc5Evid1859Params>} LogObject<siteMembersExpiredLinkPageViewSrc5Evid1859Params>
 */
export function siteMembersExpiredLinkPageViewSrc5Evid1859(params) {
    return { evid: 1859, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersExpiredLinkHomeClickSrc5Evid1860' event (evid: 1860)
 *
 * Event description: In Expired Link page, for user reset it's password -  user clicked "Go to Site Home" button.
 *
 * @param {siteMembersExpiredLinkHomeClickSrc5Evid1860Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} platform - platform
 * @return {LogObject<siteMembersExpiredLinkHomeClickSrc5Evid1860Params>} LogObject<siteMembersExpiredLinkHomeClickSrc5Evid1860Params>
 */
export function siteMembersExpiredLinkHomeClickSrc5Evid1860(params) {
    return { evid: 1860, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersExpiredLinkResetPasswordClickSrc5Evid1861' event (evid: 1861)
 *
 * Event description: In Expired Link page, for user reset it's password -  user clicked "Reset Password" button
 *
 * @param {siteMembersExpiredLinkResetPasswordClickSrc5Evid1861Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} platform - platform
 * @return {LogObject<siteMembersExpiredLinkResetPasswordClickSrc5Evid1861Params>} LogObject<siteMembersExpiredLinkResetPasswordClickSrc5Evid1861Params>
 */
export function siteMembersExpiredLinkResetPasswordClickSrc5Evid1861(params) {
    return { evid: 1861, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersEmailConfirmationSuccessSrc5Evid1862' event (evid: 1862)
 *
 * Event description: Member email confirmation modal load following a member sign up - Sucess
 *
 * @param {siteMembersEmailConfirmationSuccessSrc5Evid1862Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} platform - platform
 * @return {LogObject<siteMembersEmailConfirmationSuccessSrc5Evid1862Params>} LogObject<siteMembersEmailConfirmationSuccessSrc5Evid1862Params>
 */
export function siteMembersEmailConfirmationSuccessSrc5Evid1862(params) {
    return { evid: 1862, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersEmailConfirmationFailureSrc5Evid1863' event (evid: 1863)
 *
 * Event description: Member email confirmation modal load following a member sign up - Failure
 *
 * @param {siteMembersEmailConfirmationFailureSrc5Evid1863Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} platform - platform
 * @property {string} failure_reason - The reason of failure
 * @return {LogObject<siteMembersEmailConfirmationFailureSrc5Evid1863Params>} LogObject<siteMembersEmailConfirmationFailureSrc5Evid1863Params>
 */
export function siteMembersEmailConfirmationFailureSrc5Evid1863(params) {
    return { evid: 1863, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersForgotPasswordSuccessSrc5Evid1864' event (evid: 1864)
 *
 * Event description: If Member Forgot is password and after entering an email - the email was sent successfuly
 *
 * @param {siteMembersForgotPasswordSuccessSrc5Evid1864Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} platform - platform
 * @return {LogObject<siteMembersForgotPasswordSuccessSrc5Evid1864Params>} LogObject<siteMembersForgotPasswordSuccessSrc5Evid1864Params>
 */
export function siteMembersForgotPasswordSuccessSrc5Evid1864(params) {
    return { evid: 1864, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersForgotPasswordFailureSrc5Evid1865' event (evid: 1865)
 *
 * Event description: If Member Forgot is password and after entering an email - the email was not sent successfully
 *
 * @param {siteMembersForgotPasswordFailureSrc5Evid1865Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} platform - platform
 * @property {string} failure_reason - The failure reason.
 * @return {LogObject<siteMembersForgotPasswordFailureSrc5Evid1865Params>} LogObject<siteMembersForgotPasswordFailureSrc5Evid1865Params>
 */
export function siteMembersForgotPasswordFailureSrc5Evid1865(params) {
    return { evid: 1865, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersNewPasswordSuccessSrc5Evid1866' event (evid: 1866)
 *
 * Event description: Member Reset password (/New password) successfully
 *
 * @param {siteMembersNewPasswordSuccessSrc5Evid1866Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} platform - platform
 * @return {LogObject<siteMembersNewPasswordSuccessSrc5Evid1866Params>} LogObject<siteMembersNewPasswordSuccessSrc5Evid1866Params>
 */
export function siteMembersNewPasswordSuccessSrc5Evid1866(params) {
    return { evid: 1866, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersNewPasswordFailureSrc5Evid1867' event (evid: 1867)
 *
 * Event description: Member Reset password (/New password) was not successful
 *
 * @param {siteMembersNewPasswordFailureSrc5Evid1867Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} platform - platform
 * @property {string} failure_reason - The failure reason
 * @return {LogObject<siteMembersNewPasswordFailureSrc5Evid1867Params>} LogObject<siteMembersNewPasswordFailureSrc5Evid1867Params>
 */
export function siteMembersNewPasswordFailureSrc5Evid1867(params) {
    return { evid: 1867, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesAndPermissionsInviteAssignMoreRolesOnDifferentSitesSrc5Evid1868' event (evid: 1868)
 *
 * Event description: Users clicks on the assign more roles on different sites in the roles and permission invite page. this is onl for account level.
 *
 * @param {rolesAndPermissionsInviteAssignMoreRolesOnDifferentSitesSrc5Evid1868Params} params - The parameters for this event
 * @property {string} context - Only on account level.
 * @return {LogObject<rolesAndPermissionsInviteAssignMoreRolesOnDifferentSitesSrc5Evid1868Params>} LogObject<rolesAndPermissionsInviteAssignMoreRolesOnDifferentSitesSrc5Evid1868Params>
 */
export function rolesAndPermissionsInviteAssignMoreRolesOnDifferentSitesSrc5Evid1868(params) {
    return { evid: 1868, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesAndPermissionsInviteSelectSitesTeammatesAccessesSrc5Evid1870' event (evid: 1870)
 *
 * Event description: Users clicks on the 'Manage Accesses' button in order to select sites teammates accesses.
 *
 * @param {rolesAndPermissionsInviteSelectSitesTeammatesAccessesSrc5Evid1870Params} params - The parameters for this event
 * @property {string} context - account / team
 * @return {LogObject<rolesAndPermissionsInviteSelectSitesTeammatesAccessesSrc5Evid1870Params>} LogObject<rolesAndPermissionsInviteSelectSitesTeammatesAccessesSrc5Evid1870Params>
 */
export function rolesAndPermissionsInviteSelectSitesTeammatesAccessesSrc5Evid1870(params) {
    return { evid: 1870, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersForgotPasswordLinkWasSentPageViewSrc5Evid1872' event (evid: 1872)
 *
 * Event description: In the member email confirmation modal, user page viewed the "password link was sent" page.
 *
 * @param {siteMembersForgotPasswordLinkWasSentPageViewSrc5Evid1872Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} platform - platform
 * @property {string} origin - origin
 * @return {LogObject<siteMembersForgotPasswordLinkWasSentPageViewSrc5Evid1872Params>} LogObject<siteMembersForgotPasswordLinkWasSentPageViewSrc5Evid1872Params>
 */
export function siteMembersForgotPasswordLinkWasSentPageViewSrc5Evid1872(params) {
    return { evid: 1872, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersForgotPasswordLinkWasSentApprovedClickSrc5Evid1873' event (evid: 1873)
 *
 * Event description: In the member email confirmation modal, user clicked "Got It" after the password link was sent
 *
 * @param {siteMembersForgotPasswordLinkWasSentApprovedClickSrc5Evid1873Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} platform - platform
 * @return {LogObject<siteMembersForgotPasswordLinkWasSentApprovedClickSrc5Evid1873Params>} LogObject<siteMembersForgotPasswordLinkWasSentApprovedClickSrc5Evid1873Params>
 */
export function siteMembersForgotPasswordLinkWasSentApprovedClickSrc5Evid1873(params) {
    return { evid: 1873, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faEnforcementEnforcementRequiredSrc5Evid1877' event (evid: 1877)
 *
 * Event description: fires when user is required 2fa enforcement, right before he starts the flow
 *
 * @param {faEnforcementEnforcementRequiredSrc5Evid1877Params} params - The parameters for this event
 * @property {boolean} is_email_verified - user verified his email
 * @property {boolean} has_password - user added password is account settings
 * @property {boolean} is_billing_account - billing account
 * @property {boolean} no_2fa_enabled - no 2fa method enabled
 * @property {boolean} not_excluded - user didn't exclude himself from enforcement
 * @return {LogObject<faEnforcementEnforcementRequiredSrc5Evid1877Params>} LogObject<faEnforcementEnforcementRequiredSrc5Evid1877Params>
 */
export function faEnforcementEnforcementRequiredSrc5Evid1877(params) {
    return { evid: 1877, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faEnforcementMainScreenDisplaySrc5Evid1879' event (evid: 1879)
 *
 * Event description: fires when user sees the main screen
 *
 * @param {faEnforcementMainScreenDisplaySrc5Evid1879Params} params - The parameters for this event
 * @property {boolean} is_owa_registered - is owner app registered and ping notifications are on
 * @property {boolean} is_multiple_devices - if user has multiple devices
 * @property {string} origin - where from
 * @return {LogObject<faEnforcementMainScreenDisplaySrc5Evid1879Params>} LogObject<faEnforcementMainScreenDisplaySrc5Evid1879Params>
 */
export function faEnforcementMainScreenDisplaySrc5Evid1879(params) {
    return { evid: 1879, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesAndPermissionsDailyInvitesExceededSrc5Evid221' event (evid: 221)
 *
 * Event description: When the user exceeded the allowed number of daily invites - this error will be shown in top of the page
 *
 * @param {rolesAndPermissionsDailyInvitesExceededSrc5Evid221Params} params - The parameters for this event
 * @property {GUID} meta_site_id - MSID of the site
 * @return {LogObject<rolesAndPermissionsDailyInvitesExceededSrc5Evid221Params>} LogObject<rolesAndPermissionsDailyInvitesExceededSrc5Evid221Params>
 */
export function rolesAndPermissionsDailyInvitesExceededSrc5Evid221(params) {
    return { evid: 221, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSettingsCtaClicksSrc5Evid223' event (evid: 223)
 *
 * Event description: When the user clicks on anything on the Site members settings page.
 *
 * @param {siteMembersSettingsCtaClicksSrc5Evid223Params} params - The parameters for this event
 * @property {string} button_click - The button the user clicked on
 * @property {string} referral_info - To which page we are referring the user (site members page \ contacts page) - relevant for the site members and contacts pages merge
 * @return {LogObject<siteMembersSettingsCtaClicksSrc5Evid223Params>} LogObject<siteMembersSettingsCtaClicksSrc5Evid223Params>
 */
export function siteMembersSettingsCtaClicksSrc5Evid223(params) {
    return { evid: 223, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersAccessCtaClicksSrc5Evid225' event (evid: 225)
 *
 * Event description: The buttons the users clicked on on the Site Members Access page
 *
 * @param {siteMembersAccessCtaClicksSrc5Evid225Params} params - The parameters for this event
 * @property {string} button_clicked - The button the users clicked on in the Site Member Access page
 * @property {string} context - In which component the user clicked on the button ("Members page"\"Members roles"\"Badges"\"Signup and login settings"\"Pricing plans")
 * @return {LogObject<siteMembersAccessCtaClicksSrc5Evid225Params>} LogObject<siteMembersAccessCtaClicksSrc5Evid225Params>
 */
export function siteMembersAccessCtaClicksSrc5Evid225(params) {
    return { evid: 225, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersAccessMoreSettingsUserChooseAnOptionSrc5Evid231' event (evid: 231)
 *
 * Event description: When the user chooses an option in the "More settings and tools" upper menu.
 *
 * @param {siteMembersAccessMoreSettingsUserChooseAnOptionSrc5Evid231Params} params - The parameters for this event
 * @property {string} selection - Which option the user clicked on (‘Signup and login_security’\ ‘Member privacy’ \’Signup and login customization’ \’Member info’ \’Members badges’)
 * @return {LogObject<siteMembersAccessMoreSettingsUserChooseAnOptionSrc5Evid231Params>} LogObject<siteMembersAccessMoreSettingsUserChooseAnOptionSrc5Evid231Params>
 */
export function siteMembersAccessMoreSettingsUserChooseAnOptionSrc5Evid231(params) {
    return { evid: 231, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersPagePermissionsCtaClickSrc5Evid234' event (evid: 234)
 *
 * Event description: In the Members Page Permission page, the user clicks on starting in the editor or adding a new role (Depends if the user has already members-only page)
 *
 * @param {siteMembersPagePermissionsCtaClickSrc5Evid234Params} params - The parameters for this event
 * @property {string} button_clicked - Which button the user clicked on
 * @property {boolean} Has_members_page - Does the user has already a members page
 * @return {LogObject<siteMembersPagePermissionsCtaClickSrc5Evid234Params>} LogObject<siteMembersPagePermissionsCtaClickSrc5Evid234Params>
 */
export function siteMembersPagePermissionsCtaClickSrc5Evid234(params) {
    return { evid: 234, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersRolesViewRoleInContactsSrc5Evid235' event (evid: 235)
 *
 * Event description: When the user clicks on this button to view and manage members with this role in contacts, it refers to the contacts page
 *
 * @param {siteMembersRolesViewRoleInContactsSrc5Evid235Params} params - The parameters for this event
 * @property {string} group_name - The group (role) name
 * @property {string} group_id - The group (role) id
 * @return {LogObject<siteMembersRolesViewRoleInContactsSrc5Evid235Params>} LogObject<siteMembersRolesViewRoleInContactsSrc5Evid235Params>
 */
export function siteMembersRolesViewRoleInContactsSrc5Evid235(params) {
    return { evid: 235, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faEnforcementAllFlowsSrc5Evid237' event (evid: 237)
 *
 * Event description: An event that includes all available flow options for 2FA enforcement.
 *
 * @param {faEnforcementAllFlowsSrc5Evid237Params} params - The parameters for this event
 * @property {string} screenName - The name of the screen
 * @property {string} button_name - The button that triggered the event (e.g., 'next', 'back', etc.)
 * @property {boolean} isHover - Did the user hover over the given option
 * @property {boolean} hasOwnerApp - True if the user has OwnerApp. False if he does not have OwnerApp
 * @property {string} value - If there were a few options, what was the selected value
 * @property {string} '2faMethod' - What is the selected main method
 * @property {boolean} isCopy - Did the user copy the code provided
 * @property {string} subScreen - If a specific screen offers various options, such as the number of phone numbers available
 * @return {LogObject<faEnforcementAllFlowsSrc5Evid237Params>} LogObject<faEnforcementAllFlowsSrc5Evid237Params>
 */
export function faEnforcementAllFlowsSrc5Evid237(params) {
    return { evid: 237, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blockedAccountPagePageViewSrc5Evid259' event (evid: 259)
 *
 * Event description: When the user tries to log in to a blocked account, the user will get this page.
 *
 * @param {blockedAccountPagePageViewSrc5Evid259Params} params - The parameters for this event
 * @property {string} refferal_info - From which flow the user got to this page
 * @return {LogObject<blockedAccountPagePageViewSrc5Evid259Params>} LogObject<blockedAccountPagePageViewSrc5Evid259Params>
 */
export function blockedAccountPagePageViewSrc5Evid259(params) {
    return { evid: 259, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blockedAccountPageCtaClicksSrc5Evid290' event (evid: 290)
 *
 * Event description: Which buttons the user clicked when he got the "Your account is blocked" page
 *
 * @param {blockedAccountPageCtaClicksSrc5Evid290Params} params - The parameters for this event
 * @property {string} button_clicked - Which button the user clicked on
 * @return {LogObject<blockedAccountPageCtaClicksSrc5Evid290Params>} LogObject<blockedAccountPageCtaClicksSrc5Evid290Params>
 */
export function blockedAccountPageCtaClicksSrc5Evid290(params) {
    return { evid: 290, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blockedAccountPageCtaClicksSrc5Evid378' event (evid: 378)
 *
 * Event description: Which buttons the user clicked when he got the "Your account is blocked" page
 *
 * @param {blockedAccountPageCtaClicksSrc5Evid378Params} params - The parameters for this event
 * @property {string} button_clicked - Which button the user clicked on
 * @return {LogObject<blockedAccountPageCtaClicksSrc5Evid378Params>} LogObject<blockedAccountPageCtaClicksSrc5Evid378Params>
 */
export function blockedAccountPageCtaClicksSrc5Evid378(params) {
    return { evid: 378, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersMemberClickedOnChangeEmail' event (evid: 5001)
 *
 * Event description: When the site member clicked on "Change Email" in the Profile info
 *
 *
 * @param {siteMembersMemberClickedOnChangeEmailParams} params - The parameters for this event
 * @return {LogObject<siteMembersMemberClickedOnChangeEmailParams>} LogObject<siteMembersMemberClickedOnChangeEmailParams>
 */
export function siteMembersMemberClickedOnChangeEmail(params) {
    return { evid: 5001, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersMemberClickedOnChangePassword' event (evid: 5002)
 *
 * Event description: When the site member clicked on "Change Password" in the Profile info
 *
 *
 * @param {siteMembersMemberClickedOnChangePasswordParams} params - The parameters for this event
 * @return {LogObject<siteMembersMemberClickedOnChangePasswordParams>} LogObject<siteMembersMemberClickedOnChangePasswordParams>
 */
export function siteMembersMemberClickedOnChangePassword(params) {
    return { evid: 5002, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersChangeEmailModalLoad' event (evid: 5003)
 *
 * Event description: After the member clicked on "edit email", the change login email pop-up opens
 *
 * @param {siteMembersChangeEmailModalLoadParams} params - The parameters for this event
 * @return {LogObject<siteMembersChangeEmailModalLoadParams>} LogObject<siteMembersChangeEmailModalLoadParams>
 */
export function siteMembersChangeEmailModalLoad(params) {
    return { evid: 5003, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersChangeEmailCtaClicks' event (evid: 5004)
 *
 * Event description: In the Change email modal, the buttons the site member clicks
 *
 * @param {siteMembersChangeEmailCtaClicksParams} params - The parameters for this event
 * @property {string} button_click - The button the site member clicked (“Reset or create password”\”Cancel”\”Exit”)
 * @return {LogObject<siteMembersChangeEmailCtaClicksParams>} LogObject<siteMembersChangeEmailCtaClicksParams>
 */
export function siteMembersChangeEmailCtaClicks(params) {
    return { evid: 5004, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersChangeEmailClickOnChange' event (evid: 5005)
 *
 * Event description: After the site member changes his email, he clicks "Change" in the modal
 *
 * @param {siteMembersChangeEmailClickOnChangeParams} params - The parameters for this event
 * @property {boolean} is_success - was the change successful?
 * @property {string} failure_reason - The failure reason
 * @return {LogObject<siteMembersChangeEmailClickOnChangeParams>} LogObject<siteMembersChangeEmailClickOnChangeParams>
 */
export function siteMembersChangeEmailClickOnChange(params) {
    return { evid: 5005, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersChangePasswordModalLoad' event (evid: 5006)
 *
 * Event description: After the member clicked on "edit Password", the change password pop-up opens
 *
 * @param {siteMembersChangePasswordModalLoadParams} params - The parameters for this event
 * @return {LogObject<siteMembersChangePasswordModalLoadParams>} LogObject<siteMembersChangePasswordModalLoadParams>
 */
export function siteMembersChangePasswordModalLoad(params) {
    return { evid: 5006, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersChangePasswordCtaClicks' event (evid: 5007)
 *
 * Event description: In the Change password modal, the Button the site member clicks on
 *
 * @param {siteMembersChangePasswordCtaClicksParams} params - The parameters for this event
 * @property {string} button_click - The button the site member clicked in the change password modal (Button_click - “Reset or create password”\”Cancel”\”Exit”)
 * @return {LogObject<siteMembersChangePasswordCtaClicksParams>} LogObject<siteMembersChangePasswordCtaClicksParams>
 */
export function siteMembersChangePasswordCtaClicks(params) {
    return { evid: 5007, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersChangePasswordClickOnChange' event (evid: 5008)
 *
 * Event description: When the member clicks on "change" in the change password modal
 *
 * @param {siteMembersChangePasswordClickOnChangeParams} params - The parameters for this event
 * @property {boolean} is_success - Was the change password successful
 * @property {string} failure_reason - Failure reason
 * @return {LogObject<siteMembersChangePasswordClickOnChangeParams>} LogObject<siteMembersChangePasswordClickOnChangeParams>
 */
export function siteMembersChangePasswordClickOnChange(params) {
    return { evid: 5008, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersEmailSentToResetPassword' event (evid: 5009)
 *
 * Event description: When reset password email is sent to the site members after he clicks on "reset password"
 *
 * @param {siteMembersEmailSentToResetPasswordParams} params - The parameters for this event
 * @property {string} context - from which flow the member reset the password
 * @return {LogObject<siteMembersEmailSentToResetPasswordParams>} LogObject<siteMembersEmailSentToResetPasswordParams>
 */
export function siteMembersEmailSentToResetPassword(params) {
    return { evid: 5009, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersResetPasswordCtaClicks' event (evid: 5010)
 *
 * Event description: Which button the site member clicked on in the reset password modal
 *
 * @param {siteMembersResetPasswordCtaClicksParams} params - The parameters for this event
 * @property {string} button_click - Which button the site member click (“Can't access email”/”back”/”cancel”)
 * @return {LogObject<siteMembersResetPasswordCtaClicksParams>} LogObject<siteMembersResetPasswordCtaClicksParams>
 */
export function siteMembersResetPasswordCtaClicks(params) {
    return { evid: 5010, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersContactSiteOwnerPageLoad' event (evid: 5011)
 *
 * Event description: When the "Contact site owner" popup loads
 *
 * @param {siteMembersContactSiteOwnerPageLoadParams} params - The parameters for this event
 * @property {string} context - "Cant access email"
 * @return {LogObject<siteMembersContactSiteOwnerPageLoadParams>} LogObject<siteMembersContactSiteOwnerPageLoadParams>
 */
export function siteMembersContactSiteOwnerPageLoad(params) {
    return { evid: 5011, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersContactSiteOwnerCtaClicks' event (evid: 5012)
 *
 * Event description: When the member clicks on send a message after he clicks on "can't access email"/ Exit page
 *
 * @param {siteMembersContactSiteOwnerCtaClicksParams} params - The parameters for this event
 * @property {string} message - Members message (In case he clicked "send message")
 * @property {string} button_click - Which button the member clicked on
 * @return {LogObject<siteMembersContactSiteOwnerCtaClicksParams>} LogObject<siteMembersContactSiteOwnerCtaClicksParams>
 */
export function siteMembersContactSiteOwnerCtaClicks(params) {
    return { evid: 5012, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersClickOnLoginSignButtonUpForSiteMembers' event (evid: 601)
 *
 * Event description: Click on login/sign up button  by the UoU
 *
 * @param {siteMembersClickOnLoginSignButtonUpForSiteMembersParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {GUID} ldSessionID - login session_id
 * @property {string} platform - platform
 * @property {string} action - login,signup,logout
 * @return {LogObject<siteMembersClickOnLoginSignButtonUpForSiteMembersParams>} LogObject<siteMembersClickOnLoginSignButtonUpForSiteMembersParams>
 */
export function siteMembersClickOnLoginSignButtonUpForSiteMembers(params) {
    return { evid: 601, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersExitFromSiteMembers' event (evid: 602)
 *
 * Event description: Press exit (X ) after component open
 *
 * @param {siteMembersExitFromSiteMembersParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} context - What was the context when the X was pressed {login,sign up,forget [password,notification}
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {string} form_type - default/custom/corvid
 * @property {GUID} ldSessionID - login session_id
 * @property {string} layout - full screen/pop up
 * @property {string} platform - platform
 * @return {LogObject<siteMembersExitFromSiteMembersParams>} LogObject<siteMembersExitFromSiteMembersParams>
 */
export function siteMembersExitFromSiteMembers(params) {
    return { evid: 602, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersClickOnGoFromSignUpLoginPassWord' event (evid: 603)
 *
 * Event description: Users click on Go in the component - submit.
 *
 * @param {siteMembersClickOnGoFromSignUpLoginPassWordParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} context - what was the context while submit the form {Login, Sign up, Reset Password - Enter Mail, Reset Password - Enter new Password, Password changed successfully}
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {string} form_type - default/custom/corvid
 * @property {GUID} ldSessionID - --
 * @property {string} layout - full screen/pop up
 * @property {string} platform - platform
 * @return {LogObject<siteMembersClickOnGoFromSignUpLoginPassWordParams>} LogObject<siteMembersClickOnGoFromSignUpLoginPassWordParams>
 */
export function siteMembersClickOnGoFromSignUpLoginPassWord(params) {
    return { evid: 603, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnForgotPasswordFromTheLoginWindow' event (evid: 604)
 *
 * Event description: Click on forgot password from the login window
 *
 * @param {clickOnForgotPasswordFromTheLoginWindowParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} ldSessionID - --
 * @property {string} layout - full screen/pop up
 * @property {string} platform - platform
 * @return {LogObject<clickOnForgotPasswordFromTheLoginWindowParams>} LogObject<clickOnForgotPasswordFromTheLoginWindowParams>
 */
export function clickOnForgotPasswordFromTheLoginWindow(params) {
    return { evid: 604, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersClickOnSocialLoginButton' event (evid: 605)
 *
 * Event description: Click on Social login button (FB, Google)
 *
 * @param {siteMembersClickOnSocialLoginButtonParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} socialNetwork - social network type {facebook,google}
 * @property {string} context - {login,signup}
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} form_type - default/custom/corvid
 * @property {GUID} ldSessionID - --
 * @property {string} layout - full screen/pop up
 * @property {string} platform - platform
 * @property {string} view - desktop, mobile
 * @return {LogObject<siteMembersClickOnSocialLoginButtonParams>} LogObject<siteMembersClickOnSocialLoginButtonParams>
 */
export function siteMembersClickOnSocialLoginButton(params) {
    return { evid: 605, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersLoginSignUpForSiteMembersComponentOpen' event (evid: 607)
 *
 * Event description: component of site members login/signup successfully open
 *
 * @param {siteMembersLoginSignUpForSiteMembersComponentOpenParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} has_social - does the form include social login? <true / false>
 * @property {string} context - what was the context while submit the form.
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {string} initator - who open the component {UoU,automatically defined by user, app}
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {GUID} app_id - if user drag it from editor enter '42'
 * @property {string} layout - full screen/pop up
 * @property {string} platform - platform
 * @return {LogObject<siteMembersLoginSignUpForSiteMembersComponentOpenParams>} LogObject<siteMembersLoginSignUpForSiteMembersComponentOpenParams>
 */
export function siteMembersLoginSignUpForSiteMembersComponentOpen(params) {
    return { evid: 607, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersNotificationWindowOpens' event (evid: 608)
 *
 * Event description: notification window has opened
 *
 * @param {siteMembersNotificationWindowOpensParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {string} notifcation_name - deprecated, typo
 * @property {string} notification_name - notification
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @return {LogObject<siteMembersNotificationWindowOpensParams>} LogObject<siteMembersNotificationWindowOpensParams>
 */
export function siteMembersNotificationWindowOpens(params) {
    return { evid: 608, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersLoginSignUpClickOnButtonLink' event (evid: 609)
 *
 * Event description: uou clicks on button/link in different contexts in signup/login flow
 *
 * @param {siteMembersLoginSignUpClickOnButtonLinkParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} context - SignUpDialog / MemberLoginDialog
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {string} option - email / sso / google / facebook
 * @property {GUID} visitor_id - --
 * @property {GUID} vsi - vsi
 * @property {string} layout - full screen/pop up
 * @property {string} platform - platform
 * @return {LogObject<siteMembersLoginSignUpClickOnButtonLinkParams>} LogObject<siteMembersLoginSignUpClickOnButtonLinkParams>
 */
export function siteMembersLoginSignUpClickOnButtonLink(params) {
    return { evid: 609, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersAccountInfoUpdateSuccess' event (evid: 610)
 *
 * Event description: uou updates their info in account info page
 *
 * @param {siteMembersAccountInfoUpdateSuccessParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {string} added - fields that were added with values  (separated by comma)
 * @property {string} updated - fields that were updated (separated by comma)
 * @property {GUID} vsi - vsi
 * @property {string} fields - fields that have value (separated by comma)
 * @property {GUID} contactId - visitor_id
 * @property {string} platform - platform
 * @property {string} deleted - fields that were deleted / emptied (separated by comma)
 * @return {LogObject<siteMembersAccountInfoUpdateSuccessParams>} LogObject<siteMembersAccountInfoUpdateSuccessParams>
 */
export function siteMembersAccountInfoUpdateSuccess(params) {
    return { evid: 610, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersTooltipShow' event (evid: 611)
 *
 * Event description: tooltip is shown to uou
 *
 * @param {siteMembersTooltipShowParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} name - tooltip name
 * @property {GUID} biToken - msid
 * @property {string} context - view/page name
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {GUID} contactId - deprecated
 * @property {string} platform - platform
 * @return {LogObject<siteMembersTooltipShowParams>} LogObject<siteMembersTooltipShowParams>
 */
export function siteMembersTooltipShow(params) {
    return { evid: 611, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersAccountInfoTabLoaded' event (evid: 612)
 *
 * Event description: account info tab is loaded in member area
 *
 * @param {siteMembersAccountInfoTabLoadedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor id
 * @property {boolean} is_owner - true if visitor is site owner
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @return {LogObject<siteMembersAccountInfoTabLoadedParams>} LogObject<siteMembersAccountInfoTabLoadedParams>
 */
export function siteMembersAccountInfoTabLoaded(params) {
    return { evid: 612, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersAccountDetailsSettingsOpened' event (evid: 613)
 *
 * Event description: user opens site members account details settings
 *
 * @param {siteMembersAccountDetailsSettingsOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @return {LogObject<siteMembersAccountDetailsSettingsOpenedParams>} LogObject<siteMembersAccountDetailsSettingsOpenedParams>
 */
export function siteMembersAccountDetailsSettingsOpened(params) {
    return { evid: 613, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersAreaAccountDetailsSettingsChangeValue' event (evid: 614)
 *
 * Event description: user changes a setting value in site members account details settings
 *
 * @param {membersAreaAccountDetailsSettingsChangeValueParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} tab_name - name of tab the change was made in
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @property {string} field_name - name of setting/field the change was made on
 * @property {string} value - new value that was selected
 * @return {LogObject<membersAreaAccountDetailsSettingsChangeValueParams>} LogObject<membersAreaAccountDetailsSettingsChangeValueParams>
 */
export function membersAreaAccountDetailsSettingsChangeValue(params) {
    return { evid: 614, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSignupSettingsChangeValue' event (evid: 615)
 *
 * Event description: user changes what option will be shown first to visitors or
 * changes "join the community is checked by default" or
 * selecting any of the policies
 *
 * @param {siteMembersSignupSettingsChangeValueParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} name - name of setting/field the change was made on
 * @property {GUID} biToken - msid
 * @property {number} ts - editor default field
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - editor default field
 * @property {GUID} vsi - vsi
 * @property {string} editor_working_mode - editor default field
 * @property {GUID} esi - editor default field
 * @property {string} platform - platform
 * @property {string} value - new value
 * @return {LogObject<siteMembersSignupSettingsChangeValueParams>} LogObject<siteMembersSignupSettingsChangeValueParams>
 */
export function siteMembersSignupSettingsChangeValue(params) {
    return { evid: 615, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersMemberCheckUncheckJoinTheCommunity' event (evid: 616)
 *
 * Event description: Site Members - user click on option (in the more options menu)
 *
 * @param {siteMembersMemberCheckUncheckJoinTheCommunityParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - user id
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @property {string} value - name of the button clicked
 * @return {LogObject<siteMembersMemberCheckUncheckJoinTheCommunityParams>} LogObject<siteMembersMemberCheckUncheckJoinTheCommunityParams>
 */
export function siteMembersMemberCheckUncheckJoinTheCommunity(params) {
    return { evid: 616, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSignupSettingsPolicyLink' event (evid: 617)
 *
 * Event description: user clicks on connect link or connects a link to one of the policies
 *
 * @param {siteMembersSignupSettingsPolicyLinkParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} name - name of policy e.g privacy policy
 * @property {GUID} biToken - msid
 * @property {number} ts - editor default field
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - editor default field
 * @property {GUID} vsi - vsi
 * @property {string} editor_working_mode - editor default field
 * @property {string} type - link type: page/anchor
 * @property {GUID} esi - editor default field
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @property {string} action - the action: click/set-link
 * @return {LogObject<siteMembersSignupSettingsPolicyLinkParams>} LogObject<siteMembersSignupSettingsPolicyLinkParams>
 */
export function siteMembersSignupSettingsPolicyLink(params) {
    return { evid: 617, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersUserClickOnAddMemberArea' event (evid: 618)
 *
 * Event description: click on add members area from MA/Editor
 *
 * @param {siteMembersUserClickOnAddMemberAreaParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - deprecated
 * @property {GUID} vsi - vsi
 * @property {string} origin - MA - site member page
 * @property {string} platform - platform
 * @property {string} hosting - MA/Editor
 * @return {LogObject<siteMembersUserClickOnAddMemberAreaParams>} LogObject<siteMembersUserClickOnAddMemberAreaParams>
 */
export function siteMembersUserClickOnAddMemberArea(params) {
    return { evid: 618, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersFilterContactsByLabel' event (evid: 619)
 *
 * Event description: user filtered the displayed members by choosing a label
 *
 * @param {siteMembersFilterContactsByLabelParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} name - the label's name
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {number} membersDisplayed - number of members displayed
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @return {LogObject<siteMembersFilterContactsByLabelParams>} LogObject<siteMembersFilterContactsByLabelParams>
 */
export function siteMembersFilterContactsByLabel(params) {
    return { evid: 619, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSearchField' event (evid: 620)
 *
 * Event description: user uses the search field in member list
 *
 * @param {siteMembersSearchFieldParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {number} membersDisplayed - number of members displayed
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @return {LogObject<siteMembersSearchFieldParams>} LogObject<siteMembersSearchFieldParams>
 */
export function siteMembersSearchField(params) {
    return { evid: 620, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSearchCompleted' event (evid: 621)
 *
 * Event description: user complete searching
 *
 * @param {siteMembersSearchCompletedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {number} membersDisplayed - number of members displayed
 * @property {number} results - number of results
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @return {LogObject<siteMembersSearchCompletedParams>} LogObject<siteMembersSearchCompletedParams>
 */
export function siteMembersSearchCompleted(params) {
    return { evid: 621, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersManageMembersClick' event (evid: 622)
 *
 * Event description: user click on manage members and select from dropdown
 *
 * @param {siteMembersManageMembersClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {number} membersDisplayed - number of members displayed
 * @property {GUID} vsi - vsi
 * @property {string} selection - Pending/Blocked/Signup
 * @property {string} platform - platform
 * @return {LogObject<siteMembersManageMembersClickParams>} LogObject<siteMembersManageMembersClickParams>
 */
export function siteMembersManageMembersClick(params) {
    return { evid: 622, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersMemberOptionsClick' event (evid: 624)
 *
 * Event description: user click on member options and select from the list
 *
 * @param {membersMemberOptionsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor id
 * @property {GUID} vsi - vsi
 * @property {string} selection - View/Block/Delete/Restore/Reset password
 * @property {string} platform - platform
 * @property {string} view - Site/Block/Pending Members
 * @return {LogObject<membersMemberOptionsClickParams>} LogObject<membersMemberOptionsClickParams>
 */
export function membersMemberOptionsClick(params) {
    return { evid: 624, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersGroupClick' event (evid: 625)
 *
 * Event description: user click on member group
 *
 * @param {membersGroupClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} group_id - group_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} group_name - group name
 * @property {string} platform - platform
 * @return {LogObject<membersGroupClickParams>} LogObject<membersGroupClickParams>
 */
export function membersGroupClick(params) {
    return { evid: 625, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersMemberDialogBoxClick' event (evid: 626)
 *
 * Event description: user click in dialog box
 *
 * @param {membersMemberDialogBoxClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor id
 * @property {string} dialogType - Remove/Approve/Delete/Block/Restore etc.
 * @property {GUID} vsi - vsi
 * @property {string} selection - Cancel/Action
 * @property {string} origin - origin
 * @property {string} platform - platform
 * @property {string} origin_view - Origin page ('Contact'\'Site members')
 * @return {LogObject<membersMemberDialogBoxClickParams>} LogObject<membersMemberDialogBoxClickParams>
 */
export function membersMemberDialogBoxClick(params) {
    return { evid: 626, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersMemberAddNewGroup' event (evid: 627)
 *
 * Event description: user click on add new group
 *
 * @param {membersMemberAddNewGroupParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @return {LogObject<membersMemberAddNewGroupParams>} LogObject<membersMemberAddNewGroupParams>
 */
export function membersMemberAddNewGroup(params) {
    return { evid: 627, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersCreateNewGroupClick' event (evid: 628)
 *
 * Event description: user save new group
 *
 * @param {membersCreateNewGroupClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} group_id - group id
 * @property {string} group_color - group color
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} group_name - group name
 * @property {string} platform - platform
 * @return {LogObject<membersCreateNewGroupClickParams>} LogObject<membersCreateNewGroupClickParams>
 */
export function membersCreateNewGroupClick(params) {
    return { evid: 628, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersAddMemberToGroup' event (evid: 629)
 *
 * Event description: user add member to group
 *
 * @param {membersAddMemberToGroupParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} group_id - group_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} group_name - group name
 * @property {string} platform - platform
 * @return {LogObject<membersAddMemberToGroupParams>} LogObject<membersAddMemberToGroupParams>
 */
export function membersAddMemberToGroup(params) {
    return { evid: 629, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersAddMemberClick' event (evid: 630)
 *
 * Event description: user click on add member
 *
 * @param {membersAddMemberClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} group_id - group_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} group_name - group name
 * @property {string} platform - platform
 * @return {LogObject<membersAddMemberClickParams>} LogObject<membersAddMemberClickParams>
 */
export function membersAddMemberClick(params) {
    return { evid: 630, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersGroupOptionsClick' event (evid: 631)
 *
 * Event description: user click on group options and select from the list
 *
 * @param {membersGroupOptionsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} group_id - group_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} group_name - group name
 * @property {string} selection - edit/delete role/ manage members / role permissions/ assigned members
 * @property {string} platform - platform
 * @return {LogObject<membersGroupOptionsClickParams>} LogObject<membersGroupOptionsClickParams>
 */
export function membersGroupOptionsClick(params) {
    return { evid: 631, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersGroupDialogBoxClick' event (evid: 632)
 *
 * Event description: user click in dialog box
 *
 * @param {membersGroupDialogBoxClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} group_id - group_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} dialogType - Delete etc.
 * @property {GUID} vsi - vsi
 * @property {string} group_name - group name
 * @property {string} selection - Cancel/Action
 * @property {string} platform - platform
 * @return {LogObject<membersGroupDialogBoxClickParams>} LogObject<membersGroupDialogBoxClickParams>
 */
export function membersGroupDialogBoxClick(params) {
    return { evid: 632, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersMemberInOptionsClick' event (evid: 633)
 *
 * Event description: user click on member options in group and select from the list
 *
 * @param {membersMemberInOptionsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} group_id - group id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor id
 * @property {GUID} vsi - vsi
 * @property {string} group_name - group name
 * @property {string} selection - view/remove
 * @property {string} platform - platform
 * @return {LogObject<membersMemberInOptionsClickParams>} LogObject<membersMemberInOptionsClickParams>
 */
export function membersMemberInOptionsClick(params) {
    return { evid: 633, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersSetPermissionsClick' event (evid: 634)
 *
 * Event description: user click on set permissions
 *
 * @param {membersSetPermissionsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} referral_info - referral page
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @property {string} view - view page
 * @return {LogObject<membersSetPermissionsClickParams>} LogObject<membersSetPermissionsClickParams>
 */
export function membersSetPermissionsClick(params) {
    return { evid: 634, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersGroupPermissionsClick' event (evid: 635)
 *
 * Event description: user change group permissions
 *
 * @param {membersGroupPermissionsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} group_id - group id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} member_page_name - member page name
 * @property {GUID} vsi - vsi
 * @property {string} group_name - group_name
 * @property {boolean} status - true/false
 * @property {string} platform - platform
 * @return {LogObject<membersGroupPermissionsClickParams>} LogObject<membersGroupPermissionsClickParams>
 */
export function membersGroupPermissionsClick(params) {
    return { evid: 635, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersSaveCancelPermissionsChange' event (evid: 636)
 *
 * Event description: user save/cancel permissions change
 *
 * @param {membersSaveCancelPermissionsChangeParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} tab_name - tab_name
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} selection - Save/Cancel
 * @property {string} platform - platform
 * @return {LogObject<membersSaveCancelPermissionsChangeParams>} LogObject<membersSaveCancelPermissionsChangeParams>
 */
export function membersSaveCancelPermissionsChange(params) {
    return { evid: 636, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersSaveAfterAddMemberClick' event (evid: 637)
 *
 * Event description: user click on save after adding a member
 *
 * @param {membersSaveAfterAddMemberClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} group_id - group_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} group_name - group name
 * @property {string} platform - platform
 * @return {LogObject<membersSaveAfterAddMemberClickParams>} LogObject<membersSaveAfterAddMemberClickParams>
 */
export function membersSaveAfterAddMemberClick(params) {
    return { evid: 637, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersCancelAfterAddMemberClick' event (evid: 638)
 *
 * Event description: user click on cancel after adding a member
 *
 * @param {membersCancelAfterAddMemberClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} group_id - group_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} group_name - group name
 * @property {string} platform - platform
 * @return {LogObject<membersCancelAfterAddMemberClickParams>} LogObject<membersCancelAfterAddMemberClickParams>
 */
export function membersCancelAfterAddMemberClick(params) {
    return { evid: 638, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSignupSettingsClickOnEnableCustomSignup' event (evid: 639)
 *
 * Event description: user clicks on enable custom signup
 *
 * @param {siteMembersSignupSettingsClickOnEnableCustomSignupParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - editor default field
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - editor default field
 * @property {GUID} vsi - vsi
 * @property {string} editor_working_mode - editor default field
 * @property {GUID} esi - editor default field
 * @property {string} platform - platform
 * @return {LogObject<siteMembersSignupSettingsClickOnEnableCustomSignupParams>} LogObject<siteMembersSignupSettingsClickOnEnableCustomSignupParams>
 */
export function siteMembersSignupSettingsClickOnEnableCustomSignup(params) {
    return { evid: 639, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSignupSettingsUserChangeToggle' event (evid: 640)
 *
 * Event description: user changes custom signup settings toggle
 *
 * @param {siteMembersSignupSettingsUserChangeToggleParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} toggle_state - true/false
 * @property {GUID} biToken - msid
 * @property {number} ts - editor default field
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - editor default field
 * @property {GUID} vsi - vsi
 * @property {string} editor_working_mode - editor default field
 * @property {GUID} esi - editor default field
 * @property {string} platform - platform
 * @return {LogObject<siteMembersSignupSettingsUserChangeToggleParams>} LogObject<siteMembersSignupSettingsUserChangeToggleParams>
 */
export function siteMembersSignupSettingsUserChangeToggle(params) {
    return { evid: 640, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSignupSettingsUserClickSave' event (evid: 641)
 *
 * Event description: user clicks on save in custom signup settings dialog box
 *
 * @param {siteMembersSignupSettingsUserClickSaveParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - editor default field
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - editor default field
 * @property {GUID} vsi - vsi
 * @property {string} editor_working_mode - editor default field
 * @property {GUID} esi - editor default field
 * @property {string} platform - platform
 * @return {LogObject<siteMembersSignupSettingsUserClickSaveParams>} LogObject<siteMembersSignupSettingsUserClickSaveParams>
 */
export function siteMembersSignupSettingsUserClickSave(params) {
    return { evid: 641, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSignupSettingsUserLinkClick' event (evid: 642)
 *
 * Event description: user clicks on link button in custom signup settings dialog box
 *
 * @param {siteMembersSignupSettingsUserLinkClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - editor default field
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - editor default field
 * @property {GUID} vsi - vsi
 * @property {string} editor_working_mode - editor default field
 * @property {GUID} esi - editor default field
 * @property {string} platform - platform
 * @return {LogObject<siteMembersSignupSettingsUserLinkClickParams>} LogObject<siteMembersSignupSettingsUserLinkClickParams>
 */
export function siteMembersSignupSettingsUserLinkClick(params) {
    return { evid: 642, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSignupSettingsUserSelectLinkType' event (evid: 643)
 *
 * Event description: user select link type (page/lightbox) in dialog box
 *
 * @param {siteMembersSignupSettingsUserSelectLinkTypeParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - editor default field
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - editor default field
 * @property {GUID} vsi - vsi
 * @property {string} editor_working_mode - editor default field
 * @property {string} link_type - page/lightbox
 * @property {GUID} esi - editor default field
 * @property {string} platform - platform
 * @return {LogObject<siteMembersSignupSettingsUserSelectLinkTypeParams>} LogObject<siteMembersSignupSettingsUserSelectLinkTypeParams>
 */
export function siteMembersSignupSettingsUserSelectLinkType(params) {
    return { evid: 643, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersLinkTypeDialogBoxUserClickSave' event (evid: 644)
 *
 * Event description: user clicks on save in link type dialog box
 *
 * @param {siteMembersLinkTypeDialogBoxUserClickSaveParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - editor default field
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - editor default field
 * @property {GUID} vsi - vsi
 * @property {string} editor_working_mode - editor default field
 * @property {GUID} esi - editor default field
 * @property {string} platform - platform
 * @return {LogObject<siteMembersLinkTypeDialogBoxUserClickSaveParams>} LogObject<siteMembersLinkTypeDialogBoxUserClickSaveParams>
 */
export function siteMembersLinkTypeDialogBoxUserClickSave(params) {
    return { evid: 644, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersLinkTypeDialogBoxUserClickCancel' event (evid: 645)
 *
 * Event description: user clicks on cancel in link type dialog box
 *
 * @param {siteMembersLinkTypeDialogBoxUserClickCancelParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - editor default field
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - editor default field
 * @property {GUID} vsi - vsi
 * @property {string} editor_working_mode - editor default field
 * @property {GUID} esi - editor default field
 * @property {string} platform - platform
 * @return {LogObject<siteMembersLinkTypeDialogBoxUserClickCancelParams>} LogObject<siteMembersLinkTypeDialogBoxUserClickCancelParams>
 */
export function siteMembersLinkTypeDialogBoxUserClickCancel(params) {
    return { evid: 645, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersLinkTypeDialogBoxUserSelectPage' event (evid: 646)
 *
 * Event description: user selecting a page in link type dialog box
 *
 * @param {siteMembersLinkTypeDialogBoxUserSelectPageParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - editor default field
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - editor default field
 * @property {GUID} vsi - vsi
 * @property {string} editor_working_mode - editor default field
 * @property {GUID} esi - editor default field
 * @property {string} platform - platform
 * @return {LogObject<siteMembersLinkTypeDialogBoxUserSelectPageParams>} LogObject<siteMembersLinkTypeDialogBoxUserSelectPageParams>
 */
export function siteMembersLinkTypeDialogBoxUserSelectPage(params) {
    return { evid: 646, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersLoginBarSettingLoginBarShow' event (evid: 647)
 *
 * Event description: User select an option from login bar show
 *
 * @param {siteMembersLoginBarSettingLoginBarShowParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {string} selection - profile pic and member name/profile pic/member name
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @return {LogObject<siteMembersLoginBarSettingLoginBarShowParams>} LogObject<siteMembersLoginBarSettingLoginBarShowParams>
 */
export function siteMembersLoginBarSettingLoginBarShow(params) {
    return { evid: 647, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersLoginBarSettingLoginLogoutTextChange' event (evid: 648)
 *
 * Event description: User change text of login/logout bar
 *
 * @param {siteMembersLoginBarSettingLoginLogoutTextChangeParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {string} type - login/logout
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @return {LogObject<siteMembersLoginBarSettingLoginLogoutTextChangeParams>} LogObject<siteMembersLoginBarSettingLoginLogoutTextChangeParams>
 */
export function siteMembersLoginBarSettingLoginLogoutTextChange(params) {
    return { evid: 648, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersLoginBarSettingGreetingToggle' event (evid: 649)
 *
 * Event description: User change greeting toggle on/off
 *
 * @param {siteMembersLoginBarSettingGreetingToggleParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} toggle_state - true/false
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @return {LogObject<siteMembersLoginBarSettingGreetingToggleParams>} LogObject<siteMembersLoginBarSettingGreetingToggleParams>
 */
export function siteMembersLoginBarSettingGreetingToggle(params) {
    return { evid: 649, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersLoginBarSettingChangeLanguage' event (evid: 650)
 *
 * Event description: User change language of login bar
 *
 * @param {siteMembersLoginBarSettingChangeLanguageParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {string} language - language name
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @return {LogObject<siteMembersLoginBarSettingChangeLanguageParams>} LogObject<siteMembersLoginBarSettingChangeLanguageParams>
 */
export function siteMembersLoginBarSettingChangeLanguage(params) {
    return { evid: 650, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersLoginBarSettingMemberSignupSettingsClick' event (evid: 651)
 *
 * Event description: User clicks on member signup settings
 *
 * @param {siteMembersLoginBarSettingMemberSignupSettingsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @return {LogObject<siteMembersLoginBarSettingMemberSignupSettingsClickParams>} LogObject<siteMembersLoginBarSettingMemberSignupSettingsClickParams>
 */
export function siteMembersLoginBarSettingMemberSignupSettingsClick(params) {
    return { evid: 651, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersMemberSignupSettingWhoCanBeAMemberClick' event (evid: 652)
 *
 * Event description: User select from "who can be a member"
 *
 * @param {siteMembersMemberSignupSettingWhoCanBeAMemberClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} source - BM / settings on editor
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {string} selection - everyone/people i approve
 * @property {string} editor_working_mode - editor_working_mode
 * @property {GUID} esi - esi
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @return {LogObject<siteMembersMemberSignupSettingWhoCanBeAMemberClickParams>} LogObject<siteMembersMemberSignupSettingWhoCanBeAMemberClickParams>
 */
export function siteMembersMemberSignupSettingWhoCanBeAMemberClick(params) {
    return { evid: 652, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersMemberSignupSettingWhoCanBeAMemberClickSrc5Evid653' event (evid: 653)
 *
 * Event description: User select from "which option shows first"
 *
 * @param {siteMembersMemberSignupSettingWhoCanBeAMemberClickSrc5Evid653Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {string} selection - new member signup/existing member login
 * @property {string} editor_working_mode - {desktop/..}
 * @property {GUID} esi - esi
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @return {LogObject<siteMembersMemberSignupSettingWhoCanBeAMemberClickSrc5Evid653Params>} LogObject<siteMembersMemberSignupSettingWhoCanBeAMemberClickSrc5Evid653Params>
 */
export function siteMembersMemberSignupSettingWhoCanBeAMemberClickSrc5Evid653(params) {
    return { evid: 653, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersMemberSignupSettingSocialAndCommunityToggle' event (evid: 654)
 *
 * Event description: User change toggle state under social and community tab
 *
 * @param {siteMembersMemberSignupSettingSocialAndCommunityToggleParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} toggle_state - true/false
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {string} editor_working_mode - editor_working_mode
 * @property {GUID} esi - esi
 * @property {string} platform - google/facebook/community
 * @property {string} hosting - editor/onboarding
 * @return {LogObject<siteMembersMemberSignupSettingSocialAndCommunityToggleParams>} LogObject<siteMembersMemberSignupSettingSocialAndCommunityToggleParams>
 */
export function siteMembersMemberSignupSettingSocialAndCommunityToggle(params) {
    return { evid: 654, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersMemberSignupSettingPoliciesToggle' event (evid: 655)
 *
 * Event description: User change toggle state under policies tab
 *
 * @param {siteMembersMemberSignupSettingPoliciesToggleParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} toggle_state - true/false
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {string} type - terms of use/privacy/code of conduct
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @return {LogObject<siteMembersMemberSignupSettingPoliciesToggleParams>} LogObject<siteMembersMemberSignupSettingPoliciesToggleParams>
 */
export function siteMembersMemberSignupSettingPoliciesToggle(params) {
    return { evid: 655, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersLoginSignupDialogLoaded' event (evid: 658)
 *
 * Event description: Event is generated when the login/signup dialog is loaded and shown to the visitor
 *
 * @param {siteMembersLoginSignupDialogLoadedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - biToken
 * @property {string} context - What was the context when the X was pressed {login,sign up,forget [password,notification}
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {GUID} ldSessionID - login session_id
 * @property {string} layout - full screen/pop up
 * @property {string} platform - platform
 * @return {LogObject<siteMembersLoginSignupDialogLoadedParams>} LogObject<siteMembersLoginSignupDialogLoadedParams>
 */
export function siteMembersLoginSignupDialogLoaded(params) {
    return { evid: 658, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'twoFactorAuthenticationSetupSendCode' event (evid: 683)
 *
 * Event description: The user clicks on 'send code' or 'resend verification code' in the verify phone dialog box, after entering a phone number
 *
 * @param {twoFactorAuthenticationSetupSendCodeParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} phone_type - new phone/account phone
 * @property {string} mode - enable/edit
 * @property {string} platform - platform
 * @property {string} action - send/resend
 * @property {string} origin - The origin of the page (Account settings \ 2fa enforcement)
 * @return {LogObject<twoFactorAuthenticationSetupSendCodeParams>} LogObject<twoFactorAuthenticationSetupSendCodeParams>
 */
export function twoFactorAuthenticationSetupSendCode(params) {
    return { evid: 683, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'twoFactorAuthenticationSetupConfirmCodeClick' event (evid: 684)
 *
 * Event description: The user clicks on 'confirm' after entering the 6-digit code he received in an sms
 *
 * @param {twoFactorAuthenticationSetupConfirmCodeClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} mode - enable/edit
 * @property {boolean} is_valid - did the user enter the correct code sent to his mobile device
 * @property {string} platform - platform
 * @property {string} origin - The origin of the page (Account settings \ 2fa enforcement)
 * @return {LogObject<twoFactorAuthenticationSetupConfirmCodeClickParams>} LogObject<twoFactorAuthenticationSetupConfirmCodeClickParams>
 */
export function twoFactorAuthenticationSetupConfirmCodeClick(params) {
    return { evid: 684, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSiteWithSiteMembersFeatureRendered' event (evid: 698)
 *
 * Event description: The event is generated when a site which has the site members feature installed, is rendered
 *
 * @param {siteMembersSiteWithSiteMembersFeatureRenderedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} site_settings_lng - the site settings language
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {string} browser_lng - the browser language
 * @property {boolean} lng_mismatch - does the browser language match the site setting language
 * @property {GUID} vsi - vsi
 * @property {GUID} site_member_id - if the site member is logged in, this field will contain the site member id, else, it will be null.
 * @property {string} platform - platform
 * @return {LogObject<siteMembersSiteWithSiteMembersFeatureRenderedParams>} LogObject<siteMembersSiteWithSiteMembersFeatureRenderedParams>
 */
export function siteMembersSiteWithSiteMembersFeatureRendered(params) {
    return { evid: 698, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSiteWithWixCodeSiteMembersFeatureRendered' event (evid: 699)
 *
 * Event description: The event is generated when a site which has the wix code site members feature installed, is rendered
 *
 * @param {siteMembersSiteWithWixCodeSiteMembersFeatureRenderedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {GUID} site_member_id - if the site member is logged in, this field will contain the site member id, else, it will be null.
 * @property {string} platform - platform
 * @return {LogObject<siteMembersSiteWithWixCodeSiteMembersFeatureRenderedParams>} LogObject<siteMembersSiteWithWixCodeSiteMembersFeatureRenderedParams>
 */
export function siteMembersSiteWithWixCodeSiteMembersFeatureRendered(params) {
    return { evid: 699, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersCreateCustomSignupStartNowClick' event (evid: 856)
 *
 * Event description: User click start now
 *
 * @param {siteMembersCreateCustomSignupStartNowClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} esi - esi
 * @property {string} platform - platform
 * @return {LogObject<siteMembersCreateCustomSignupStartNowClickParams>} LogObject<siteMembersCreateCustomSignupStartNowClickParams>
 */
export function siteMembersCreateCustomSignupStartNowClick(params) {
    return { evid: 856, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersCreateCustomSignupAddRemoveField' event (evid: 857)
 *
 * Event description: User click on add/remove field from custom signup
 *
 * @param {siteMembersCreateCustomSignupAddRemoveFieldParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} fieldType - field type
 * @property {string} platform - platform
 * @property {string} action - add/remove
 * @return {LogObject<siteMembersCreateCustomSignupAddRemoveFieldParams>} LogObject<siteMembersCreateCustomSignupAddRemoveFieldParams>
 */
export function siteMembersCreateCustomSignupAddRemoveField(params) {
    return { evid: 857, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersCreateCustomSignupViewFormSubmissionsClick' event (evid: 858)
 *
 * Event description: user clicks on view form submissions inside custom signup
 *
 * @param {siteMembersCreateCustomSignupViewFormSubmissionsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} platform - platform
 * @return {LogObject<siteMembersCreateCustomSignupViewFormSubmissionsClickParams>} LogObject<siteMembersCreateCustomSignupViewFormSubmissionsClickParams>
 */
export function siteMembersCreateCustomSignupViewFormSubmissionsClick(params) {
    return { evid: 858, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersMemberSignupSettingSignupFormTypeSelection' event (evid: 859)
 *
 * Event description: User select Signup Form type - default / custom / wix code
 *
 * @param {siteMembersMemberSignupSettingSignupFormTypeSelectionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} ts - --needed for completion scheme from editor.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - --needed for completion scheme from editor.
 * @property {GUID} vsi - vsi
 * @property {string} selection - default / custom / wix code
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @return {LogObject<siteMembersMemberSignupSettingSignupFormTypeSelectionParams>} LogObject<siteMembersMemberSignupSettingSignupFormTypeSelectionParams>
 */
export function siteMembersMemberSignupSettingSignupFormTypeSelection(params) {
    return { evid: 859, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSignupSettingsWixCodeConnectLink' event (evid: 861)
 *
 * Event description: user clicks on connect link or connects a link to a Page/Lightbox from a Wix Code Signup Form
 *
 * @param {siteMembersSignupSettingsWixCodeConnectLinkParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} name - wixCodeFormLink
 * @property {GUID} biToken - msid
 * @property {number} ts - editor default field
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - editor default field
 * @property {GUID} vsi - vsi
 * @property {string} editor_working_mode - editor default field
 * @property {string} type - link type: page/lightbox
 * @property {GUID} esi - editor default field
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @property {string} action - the action: click/set-link
 * @return {LogObject<siteMembersSignupSettingsWixCodeConnectLinkParams>} LogObject<siteMembersSignupSettingsWixCodeConnectLinkParams>
 */
export function siteMembersSignupSettingsWixCodeConnectLink(params) {
    return { evid: 861, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'siteMembersSignupSettingsEditTextFieldConnectLink' event (evid: 866)
 *
 * Event description: user clicks on connect link or connects a link to a text field in wix form
 *
 * @param {siteMembersSignupSettingsEditTextFieldConnectLinkParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} name - field name
 * @property {GUID} biToken - msid
 * @property {number} ts - editor default field
 * @property {GUID} visitor_id - visitor_id
 * @property {string} viewmode - editor default field
 * @property {GUID} vsi - vsi
 * @property {string} editor_working_mode - editor default field
 * @property {string} type - link type: page/lightbox/....
 * @property {GUID} esi - editor default field
 * @property {string} platform - platform
 * @property {string} hosting - editor/onboarding
 * @property {string} action - the action: click/set-link
 * @return {LogObject<siteMembersSignupSettingsEditTextFieldConnectLinkParams>} LogObject<siteMembersSignupSettingsEditTextFieldConnectLinkParams>
 */
export function siteMembersSignupSettingsEditTextFieldConnectLink(params) {
    return { evid: 866, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersClickOnInTheChangeSiteMemberLoginEmailModal' event (evid: 881)
 *
 * Event description: The user clicks on the question mark ("?") in the change site member login email modal
 *
 * @param {membersClickOnInTheChangeSiteMemberLoginEmailModalParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} contact_id - contact_id of the site member whose email was changed
 * @property {string} platform - platform
 * @return {LogObject<membersClickOnInTheChangeSiteMemberLoginEmailModalParams>} LogObject<membersClickOnInTheChangeSiteMemberLoginEmailModalParams>
 */
export function membersClickOnInTheChangeSiteMemberLoginEmailModal(params) {
    return { evid: 881, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersErrorMessageShownWhenUserTriesToChangeSiteMemberLoginEmail' event (evid: 897)
 *
 * Event description: Form settings - click
 *
 * @param {membersErrorMessageShownWhenUserTriesToChangeSiteMemberLoginEmailParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {string} error_reason - error reason
 * @property {GUID} contact_id - contact_id of the site member whose email was changed
 * @property {string} platform - platform
 * @property {number} error_code - error code
 * @return {LogObject<membersErrorMessageShownWhenUserTriesToChangeSiteMemberLoginEmailParams>} LogObject<membersErrorMessageShownWhenUserTriesToChangeSiteMemberLoginEmailParams>
 */
export function membersErrorMessageShownWhenUserTriesToChangeSiteMemberLoginEmail(params) {
    return { evid: 897, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faSetupClickFromAccountSecurityBox' event (evid: 8998)
 *
 * Event description: The user clicked on '2fa enable/edit' from account security box in account settings
 *
 * @param {faSetupClickFromAccountSecurityBoxParams} params - The parameters for this event
 * @property {string} context - "enable"/"edit"/"disable"
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<faSetupClickFromAccountSecurityBoxParams>} LogObject<faSetupClickFromAccountSecurityBoxParams>
 */
export function faSetupClickFromAccountSecurityBox(params) {
    return { evid: 8998, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'activityLoginSeeRecentLoginsClick' event (evid: 8999)
 *
 * Event description: The user clicked on 'See recent logins' from the account security box in account settings
 *
 * @param {activityLoginSeeRecentLoginsClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<activityLoginSeeRecentLoginsClickParams>} LogObject<activityLoginSeeRecentLoginsClickParams>
 */
export function activityLoginSeeRecentLoginsClick(params) {
    return { evid: 8999, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'activityLogLogOutFromAllDevicesClick' event (evid: 9003)
 *
 * Event description: The user clicked on 'Log out from all devices' from Login activity in account settings
 *
 * @param {activityLogLogOutFromAllDevicesClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<activityLogLogOutFromAllDevicesClickParams>} LogObject<activityLogLogOutFromAllDevicesClickParams>
 */
export function activityLogLogOutFromAllDevicesClick(params) {
    return { evid: 9003, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'activityLogViewLoginHistoryClick' event (evid: 9004)
 *
 * Event description: The user clicked on 'View login history' from Login activity in account settings
 *
 * @param {activityLogViewLoginHistoryClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<activityLogViewLoginHistoryClickParams>} LogObject<activityLogViewLoginHistoryClickParams>
 */
export function activityLogViewLoginHistoryClick(params) {
    return { evid: 9004, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'activityLogNotYouClick' event (evid: 9005)
 *
 * Event description: The user clicked on 'Not you?' on a specific device from Login activity box in account settings
 *
 * @param {activityLogNotYouClickParams} params - The parameters for this event
 * @property {string} deviceName - OS Device name (Android / Mac OS ....)
 * @property {string} browser - Browser name (Chrome / Firefox ... )
 * @property {string} view_type - view_type
 * @property {string} loaction - Location of the device (city + Country)
 * @property {DateTime} lastLoginDate - Last login date and time of the device
 * @property {string} origin - "acccount_settings" / "login_history_modal"
 * @property {string} platform - platform
 * @return {LogObject<activityLogNotYouClickParams>} LogObject<activityLogNotYouClickParams>
 */
export function activityLogNotYouClick(params) {
    return { evid: 9005, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'activityLogLogOutFromDevicesModalCta' event (evid: 9010)
 *
 * Event description: Modal choice and CTA in the "log out from all devices" in the activity log in the account settings
 *
 * @param {activityLogLogOutFromDevicesModalCtaParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} cta - "next" / "confirm"
 * @property {string} choice - ""change_password " / "log_out_all_devices"
 * @property {string} platform - platform
 * @return {LogObject<activityLogLogOutFromDevicesModalCtaParams>} LogObject<activityLogLogOutFromDevicesModalCtaParams>
 */
export function activityLogLogOutFromDevicesModalCta(params) {
    return { evid: 9010, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'activityLogDonTRecognizeThisDeviceModalCta' event (evid: 9011)
 *
 * Event description: CTA in the "Don't recognize this device" in the activity log in the account settings
 *
 * @param {activityLogDonTRecognizeThisDeviceModalCtaParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - "login_history_table" / "login_history_modal"
 * @property {string} cta - "change_password" / "cancel"
 * @property {string} platform - platform
 * @return {LogObject<activityLogDonTRecognizeThisDeviceModalCtaParams>} LogObject<activityLogDonTRecognizeThisDeviceModalCtaParams>
 */
export function activityLogDonTRecognizeThisDeviceModalCta(params) {
    return { evid: 9011, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postLoginConfirmAccountDetails' event (evid: 9501)
 *
 * Event description: The buttons the user clicked on the "confirm account details" pop-up
 *
 * @param {postLoginConfirmAccountDetailsParams} params - The parameters for this event
 * @property {string} flowType - Post-login flow type ("Confirm account details"/"Confirm email")
 * @property {GUID} user_id - the users uuid
 * @property {string} button - Which button the user clicked on ("Edit email"\"Edit phone"\"Not now"\"Confirm")
 * @return {LogObject<postLoginConfirmAccountDetailsParams>} LogObject<postLoginConfirmAccountDetailsParams>
 */
export function postLoginConfirmAccountDetails(params) {
    return { evid: 9501, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postLoginChangeDetailsClickedContinue' event (evid: 9502)
 *
 * Event description: The user clicked "Continue" on the "Change your account email" pop up, this event includes the errors the user gets
 *
 * @param {postLoginChangeDetailsClickedContinueParams} params - The parameters for this event
 * @property {GUID} uuid - Users UUID
 * @property {string} methodType - Method type the user confirms ("Email"\"Phone")
 * @property {string} error_info - The error the user got when he clicked "Continue" (If all good - then Null)
 * @return {LogObject<postLoginChangeDetailsClickedContinueParams>} LogObject<postLoginChangeDetailsClickedContinueParams>
 */
export function postLoginChangeDetailsClickedContinue(params) {
    return { evid: 9502, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postLoginResendCode' event (evid: 9503)
 *
 * Event description: The user clicked on "resend code"
 *
 * @param {postLoginResendCodeParams} params - The parameters for this event
 * @property {GUID} uuid - Users UUID
 * @property {string} methodType - Where to resend the code? ("Email"\"Phone")
 * @property {string} flow_type - Post login flow type ("Confirm details"\"Confirm Email"\"Recovery Phone"\"MFA")
 * @return {LogObject<postLoginResendCodeParams>} LogObject<postLoginResendCodeParams>
 */
export function postLoginResendCode(params) {
    return { evid: 9503, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postLoginVerifyDetails' event (evid: 9504)
 *
 * Event description: The user clicked on "Verify"
 *
 * @param {postLoginVerifyDetailsParams} params - The parameters for this event
 * @property {GUID} uuid - Users UUID
 * @property {string} methodType - Where to resend the code? ("Email"\"Phone")
 * @property {string} error_info - The error the user got when he clicked "Verify" (If all good - then Null)
 * @property {string} flow_type - Post login flow type ("Confirm details"\"Confirm Email"\"Recovery Phone"\"MFA")
 * @return {LogObject<postLoginVerifyDetailsParams>} LogObject<postLoginVerifyDetailsParams>
 */
export function postLoginVerifyDetails(params) {
    return { evid: 9504, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postLoginConfirmDetailsDone' event (evid: 9505)
 *
 * Event description: The user clicked on the "Done" button in the "Confirm details" flow
 *
 * @param {postLoginConfirmDetailsDoneParams} params - The parameters for this event
 * @property {string} changes - What changes the user made (nothing - null\"Phone number"\"Email"\"Email and phone number")
 * @property {GUID} user_id - the users uuid
 * @return {LogObject<postLoginConfirmDetailsDoneParams>} LogObject<postLoginConfirmDetailsDoneParams>
 */
export function postLoginConfirmDetailsDone(params) {
    return { evid: 9505, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postLoginRecoveryPhoneDetails' event (evid: 9506)
 *
 * Event description: The buttons the user clicked on the "Confirm recovery phone number" pop-up
 *
 * @param {postLoginRecoveryPhoneDetailsParams} params - The parameters for this event
 * @property {GUID} user_id - the users uuid
 * @property {string} phone_type - The phone number type the user chosen before clicking "next" ("Billing Phone number"\"Recover Phone number"\"New number"\Null when clicking "Not now")
 * @property {string} button - Which button the user clicked on ("Not now"\"Next")
 * @property {string} error_info - The error the user got when he clicked "Next" (If all good - then Null)
 * @return {LogObject<postLoginRecoveryPhoneDetailsParams>} LogObject<postLoginRecoveryPhoneDetailsParams>
 */
export function postLoginRecoveryPhoneDetails(params) {
    return { evid: 9506, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postLoginMfaDetails' event (evid: 9507)
 *
 * Event description: The buttons the user clicked on the "2-step verification" pop-up
 *
 * @param {postLoginMfaDetailsParams} params - The parameters for this event
 * @property {GUID} user_id - the users uuid
 * @property {string} phone_type - Deprecated
 * @property {string} button - Which button the user clicked on ("Next"\"Not now")
 * @property {string} mfa_type - The 2fa type ("Phone")
 * @property {string} error_info - The error the user got when he clicked "Next" (If all good - then Null)
 * @property {string} type - The type for each 2FA, for example - The phone number type the user chosen before clicking "next" ("Billing Phone number"\"Recover Phone number"\"New number"\Null when clicking "Not now")
 * @return {LogObject<postLoginMfaDetailsParams>} LogObject<postLoginMfaDetailsParams>
 */
export function postLoginMfaDetails(params) {
    return { evid: 9507, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postLoginChangeYourPasswordDetails' event (evid: 9508)
 *
 * Event description: The buttons the user clicked on the "Change your password" pop-up
 *
 * @param {postLoginChangeYourPasswordDetailsParams} params - The parameters for this event
 * @property {GUID} user_id - the users uuid
 * @property {string} button - Which button the user clicked on ("Not now"\"Save"\"Forgot Password")
 * @property {string} error_info - The error the user got when he clicked "Save" (If all good - then Null)
 * @property {string} flow_type - Users flow type ("Create password"\"Update password")
 * @return {LogObject<postLoginChangeYourPasswordDetailsParams>} LogObject<postLoginChangeYourPasswordDetailsParams>
 */
export function postLoginChangeYourPasswordDetails(params) {
    return { evid: 9508, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postLoginOwnerApp2FaOfferUserHasBackupMethodSrc5Evid9510' event (evid: 9510)
 *
 * Event description: post login - OwnerApp 2FA offer when the user already has at least one other 2FA method
 *
 * @param {postLoginOwnerApp2FaOfferUserHasBackupMethodSrc5Evid9510Params} params - The parameters for this event
 * @property {string} screen_name - which part of the flow
 * @property {string} button_name - on what the user clicked
 * @property {string} value - value chosen
 * @return {LogObject<postLoginOwnerApp2FaOfferUserHasBackupMethodSrc5Evid9510Params>} LogObject<postLoginOwnerApp2FaOfferUserHasBackupMethodSrc5Evid9510Params>
 */
export function postLoginOwnerApp2FaOfferUserHasBackupMethodSrc5Evid9510(params) {
    return { evid: 9510, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postLoginOwnerApp2FaOfferUserDontHaveBackupMethodSrc5Evid9511' event (evid: 9511)
 *
 * Event description: post login - OwnerApp 2FA offer when the user already has OwnerApp but don't have one other 2FA method
 *
 * @param {postLoginOwnerApp2FaOfferUserDontHaveBackupMethodSrc5Evid9511Params} params - The parameters for this event
 * @property {string} screenName - which part of the flow
 * @property {string} subScreen - which sub screen is displayed (in some screens, there are multiple options of different UI for several options)
 * @property {string} button_name - on what the user clicked
 * @property {string} value - users chosen value
 * @property {boolean} isHover - does the user hovered the info icon
 * @return {LogObject<postLoginOwnerApp2FaOfferUserDontHaveBackupMethodSrc5Evid9511Params>} LogObject<postLoginOwnerApp2FaOfferUserDontHaveBackupMethodSrc5Evid9511Params>
 */
export function postLoginOwnerApp2FaOfferUserDontHaveBackupMethodSrc5Evid9511(params) {
    return { evid: 9511, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bookingsClickToViewSessionAppointment' event (evid: 102)
 *
 * Event description: When user clicks on 'Resend' button or switches to different method from 'Enter Verification Code' screen
 *
 * @param {bookingsClickToViewSessionAppointmentParams} params - The parameters for this event
 * @property {string} method - (app/email/sms/push)
 * @property {boolean} isPreviewMode - is_preview_mode
 * @property {number} ts - ts
 * @property {string} moduleName - module_name
 * @property {boolean} isSplitInstance - is_split_instance
 * @property {string} moduleVersion - module_version
 * @property {string} user_agent - user_agent
 * @property {string} origin - (subtitle/actionsheet)
 * @property {GUID} contactId - contact_id
 * @property {string} appNameInstance - app_name_instance
 * @property {GUID} ldsessionid - Available for join with src 6 login events
 * @property {string} originalMethod - the method from which we click switch/resend
 * @return {LogObject<bookingsClickToViewSessionAppointmentParams>} LogObject<bookingsClickToViewSessionAppointmentParams>
 */
export function bookingsClickToViewSessionAppointment(params) {
    return { evid: 102, src: 67, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ownerApp2FaSetupClickOnApproveFromTheOwnerAppSrc67Evid4862' event (evid: 4862)
 *
 * Event description: When the user gets a popup in his owner app to verify his identity (for the Owner app 2fa flow), he clicks on "Approve".
 *
 * @param {ownerApp2FaSetupClickOnApproveFromTheOwnerAppSrc67Evid4862Params} params - The parameters for this event
 * @property {boolean} isPreviewMode - is_preview_mode
 * @property {string} context - enable 2fa \ login
 * @property {number} ts - ts
 * @property {string} moduleName - module_name
 * @property {boolean} isSplitInstance - is_split_instance
 * @property {string} moduleVersion - module_version
 * @property {string} user_agent - user_agent
 * @property {GUID} contactId - contact_id
 * @property {string} appNameInstance - app_name_instance
 * @property {string} verificationId - verification id
 * @return {LogObject<ownerApp2FaSetupClickOnApproveFromTheOwnerAppSrc67Evid4862Params>} LogObject<ownerApp2FaSetupClickOnApproveFromTheOwnerAppSrc67Evid4862Params>
 */
export function ownerApp2FaSetupClickOnApproveFromTheOwnerAppSrc67Evid4862(params) {
    return { evid: 4862, src: 67, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ownerApp2FaSetupClickOnResendRequestSrc67Evid4864' event (evid: 4864)
 *
 * Event description: When the user gets a popup in his owner app to verify his identity (for the Owner app 2fa flow), he clicks on "Deny".
 *
 * @param {ownerApp2FaSetupClickOnResendRequestSrc67Evid4864Params} params - The parameters for this event
 * @property {boolean} isPreviewMode - is_preview_mode
 * @property {number} ts - ts
 * @property {string} moduleName - module_name
 * @property {boolean} isSplitInstance - is_split_instance
 * @property {string} moduleVersion - module_version
 * @property {string} user_agent - user_agent
 * @property {string} origin - phone modal
 * @property {GUID} contactId - contact_id
 * @property {string} appNameInstance - app_name_instance
 * @return {LogObject<ownerApp2FaSetupClickOnResendRequestSrc67Evid4864Params>} LogObject<ownerApp2FaSetupClickOnResendRequestSrc67Evid4864Params>
 */
export function ownerApp2FaSetupClickOnResendRequestSrc67Evid4864(params) {
    return { evid: 4864, src: 67, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ownerApp2FaSetupOwaModalDisplaySrc67Evid748' event (evid: 748)
 *
 * Event description: When the user gets a popup in his owner app to verify his identity
 *
 * @param {ownerApp2FaSetupOwaModalDisplaySrc67Evid748Params} params - The parameters for this event
 * @property {string} context - enable 2fa \ login
 * @property {string} moduleName - module_name
 * @property {string} moduleVersion - module_version
 * @property {string} user_agent - user_agent
 * @property {GUID} correlationId - correlation_id
 * @property {string} notificationId - notification_id
 * @property {string} verificationId - verification_id
 * @return {LogObject<ownerApp2FaSetupOwaModalDisplaySrc67Evid748Params>} LogObject<ownerApp2FaSetupOwaModalDisplaySrc67Evid748Params>
 */
export function ownerApp2FaSetupOwaModalDisplaySrc67Evid748(params) {
    return { evid: 748, src: 67, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ownerApp2FaSetupClickOnResendSrc67Evid749' event (evid: 749)
 *
 * Event description: When the user clicks on resend code button
 *
 * @param {ownerApp2FaSetupClickOnResendSrc67Evid749Params} params - The parameters for this event
 * @property {string} context - enable 2fa \ login
 * @property {string} moduleName - module_name
 * @property {string} moduleVersion - module_version
 * @property {string} user_agent - user_agent
 * @return {LogObject<ownerApp2FaSetupClickOnResendSrc67Evid749Params>} LogObject<ownerApp2FaSetupClickOnResendSrc67Evid749Params>
 */
export function ownerApp2FaSetupClickOnResendSrc67Evid749(params) {
    return { evid: 749, src: 67, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ownerApp2FaSetupClickOnSwitchMethodSrc67Evid787' event (evid: 787)
 *
 * Event description: When the user clicks on different method (backup method)
 *
 * @param {ownerApp2FaSetupClickOnSwitchMethodSrc67Evid787Params} params - The parameters for this event
 * @property {string} context - enable 2fa \ login
 * @property {string} moduleName - module_name
 * @property {string} moduleVersion - module_version
 * @property {string} user_agent - user_agent
 * @property {string} chosen_method - method clicked
 * @property {string} original_method - method the user switched from
 * @return {LogObject<ownerApp2FaSetupClickOnSwitchMethodSrc67Evid787Params>} LogObject<ownerApp2FaSetupClickOnSwitchMethodSrc67Evid787Params>
 */
export function ownerApp2FaSetupClickOnSwitchMethodSrc67Evid787(params) {
    return { evid: 787, src: 67, endpoint: '', params };
}
/**
 * A function to create a log object for the 'owa2FaFunnelNotificationSentToDisconnectedSessionSrc67Evid813' event (evid: 813)
 *
 * Event description: Notification sent to user that disconnected from OWA
 *
 * @param {owa2FaFunnelNotificationSentToDisconnectedSessionSrc67Evid813Params} params - The parameters for this event
 * @property {string} moduleName - module_name
 * @property {string} moduleVersion - module_version
 * @property {string} user_agent - user_agent
 * @property {string} flow - flow
 * @property {string} correlationId - correlation id
 * @property {string} notificationId - notification id
 * @return {LogObject<owa2FaFunnelNotificationSentToDisconnectedSessionSrc67Evid813Params>} LogObject<owa2FaFunnelNotificationSentToDisconnectedSessionSrc67Evid813Params>
 */
export function owa2FaFunnelNotificationSentToDisconnectedSessionSrc67Evid813(params) {
    return { evid: 813, src: 67, endpoint: '', params };
}
/**
 * A function to create a log object for the 'errorEvent' event (evid: 10)
 *
 * Event description: error event.
 *
 * @param {errorEventParams} params - The parameters for this event
 * @property {string} dsc - dsc
 * @property {number} response_time - Time in ms from load to error
 * @property {boolean} is_rollout - is_rollout
 * @property {string} initiator_name - initiator_name
 * @property {string} builderType - builder_type
 * @property {string} errscp - error scope
 * @property {GUID} site_id - changed from did -> site_id on Oct 03, 2013
 * @property {string} errn - error name
 * @property {string} p4 - 4st extra parameter
 * @property {string} majorver - the major version of html editor
 * @property {string} trgt - target name, api call or class
 * @property {boolean} isLiveEditor - is_live_editor
 * @property {number} ts - Time in ms from load to error
 * @property {string} playerVersion - player_version
 * @property {string} artifactVersion - artifact_version
 * @property {number} usersOnPageCount - users_on_page_count
 * @property {string} viewmode - viewmode
 * @property {string} error_description_short - error_description_short
 * @property {string} data_center - data_center
 * @property {string} screenResolution - screen_resolution
 * @property {string} p3 - 3rd extra parameter
 * @property {GUID} did - changed from did -> site_id on Oct 03, 2013
 * @property {boolean} isSg - is_sg
 * @property {string} dsOrigin - ds_origin
 * @property {string} p2 - 2nd extra parameter
 * @property {string} token - token
 * @property {string} sessionId - session_id
 * @property {number} errc - error code
 * @property {string} stack - stacktrace
 * @property {string} viewerName - viewer_name
 * @property {string} app_id - app_id
 * @property {string} ldSessionID - ld_session_id
 * @property {number} sev - severity of the error
 * @property {GUID} esi - esi
 * @property {number} cat - category id
 * @property {string} errormsg - dsc
 * @property {number} usersOnSiteCount - users_on_site_count
 * @property {string} p1 - 1st extra parameter
 * @property {GUID} msid - msid
 * @property {number} base_version - base_version
 * @property {number} iss - issue (sub-category)
 * @property {string} view - origin_view
 * @return {LogObject<errorEventParams>} LogObject<errorEventParams>
 */
export function errorEvent(params) {
    return { evid: 10, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callToLoginSignupForm' event (evid: 100)
 *
 * Event description: call to login/signup form.
 *
 * @param {callToLoginSignupFormParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {string} origin - the origin of the request (for example, on home-page there are 3 possible origins, my-account link, start now button and login/signnup link
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<callToLoginSignupFormParams>} LogObject<callToLoginSignupFormParams>
 */
export function callToLoginSignupForm(params) {
    return { evid: 100, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'onSwitchContext' event (evid: 101)
 *
 * Event description: event is generated each time the user moves between screens
 *
 * @param {onSwitchContextParams} params - The parameters for this event
 * @property {string} socialNetwork - social network type
 * @property {string} context - the context of the login/sign-up/forgot-password form
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {string} displayVersion - login version: access link / captcha / other ...
 * @property {string} recoveryMode - for account recovery screen only, which recovery mode the user chose: account recovery/cant access email
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @property {string} referrer - Flow referrer (LFND for example)
 * @return {LogObject<onSwitchContextParams>} LogObject<onSwitchContextParams>
 */
export function onSwitchContext(params) {
    return { evid: 101, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'emptyPassword' event (evid: 102)
 *
 * Event description: empty password.
 *
 * @param {emptyPasswordParams} params - The parameters for this event
 * @property {string} socialNetwork - social network type
 * @property {string} context - the context of the login/sign-up/forgot-password form
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<emptyPasswordParams>} LogObject<emptyPasswordParams>
 */
export function emptyPassword(params) {
    return { evid: 102, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'emptyEmail' event (evid: 104)
 *
 * Event description: empty email.
 *
 * @param {emptyEmailParams} params - The parameters for this event
 * @property {string} socialNetwork - social network type
 * @property {string} context - the context of the login/sign-up/forgot-password form
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<emptyEmailParams>} LogObject<emptyEmailParams>
 */
export function emptyEmail(params) {
    return { evid: 104, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'malformedEmail' event (evid: 105)
 *
 * Event description: malformed email.
 *
 * @param {malformedEmailParams} params - The parameters for this event
 * @property {string} context - the context of the login/sign-up/forgot-password form
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<malformedEmailParams>} LogObject<malformedEmailParams>
 */
export function malformedEmail(params) {
    return { evid: 105, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'malformedPassword' event (evid: 106)
 *
 * Event description: malformed password.
 *
 * @param {malformedPasswordParams} params - The parameters for this event
 * @property {string} socialNetwork - social network type
 * @property {string} context - the context of the login/sign-up/forgot-password form
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<malformedPasswordParams>} LogObject<malformedPasswordParams>
 */
export function malformedPassword(params) {
    return { evid: 106, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginEmailsDonTMatch' event (evid: 107)
 *
 * Event description: login -> emails don't match.
 *
 * @param {loginEmailsDonTMatchParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<loginEmailsDonTMatchParams>} LogObject<loginEmailsDonTMatchParams>
 */
export function loginEmailsDonTMatch(params) {
    return { evid: 107, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginPasswordsDonTMatch' event (evid: 108)
 *
 * Event description: login -> passwords don't match.
 *
 * @param {loginPasswordsDonTMatchParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<loginPasswordsDonTMatchParams>} LogObject<loginPasswordsDonTMatchParams>
 */
export function loginPasswordsDonTMatch(params) {
    return { evid: 108, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSubmit' event (evid: 110)
 *
 * Event description: event is generated when login form is submitted to server
 *
 * @param {loginSubmitParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {boolean} remember_me - did the user have remember me checked or not. true/false
 * @property {GUID} client_id - client_id
 * @property {string} version - old/new login
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} recaptchaChallengeType - none/checkbox/imageselect
 * @property {boolean} formValid - yes for invalid form
 * @property {string} view - desktop,mobile...
 * @return {LogObject<loginSubmitParams>} LogObject<loginSubmitParams>
 */
export function loginSubmit(params) {
    return { evid: 110, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginTryLoginRequestSentToServer' event (evid: 111)
 *
 * Event description: login try : login request sent to server.
 *
 * @param {loginTryLoginRequestSentToServerParams} params - The parameters for this event
 * @property {boolean} force - if we use the confusion mechanism-true
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<loginTryLoginRequestSentToServerParams>} LogObject<loginTryLoginRequestSentToServerParams>
 */
export function loginTryLoginRequestSentToServer(params) {
    return { evid: 111, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginTrySuccess' event (evid: 114)
 *
 * Event description: login try : success.
 *
 * @param {loginTrySuccessParams} params - The parameters for this event
 * @property {string} socialNetwork - social network type
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<loginTrySuccessParams>} LogObject<loginTrySuccessParams>
 */
export function loginTrySuccess(params) {
    return { evid: 114, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pinterestPixel' event (evid: 115)
 *
 * Event description: Pinterest Pixel was sent
 *
 * @param {pinterestPixelParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<pinterestPixelParams>} LogObject<pinterestPixelParams>
 */
export function pinterestPixel(params) {
    return { evid: 115, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'facebookOrderIdPixelSent' event (evid: 116)
 *
 * Event description: This event is sent when marketing related conversion pixels are sent - upon signup
 *
 * @param {facebookOrderIdPixelSentParams} params - The parameters for this event
 * @property {string} pixel_name - marketing pixel sent
 * @property {string} user_creation_date - user_creation_date from window.__APP_PARAMS__.userCreationDate
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {string} conversion_reporting_event_id - unique id for facebook event
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {number} days_back - days since registration
 * @property {string} view - desktop,mobile
 * @return {LogObject<facebookOrderIdPixelSentParams>} LogObject<facebookOrderIdPixelSentParams>
 */
export function facebookOrderIdPixelSent(params) {
    return { evid: 116, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'socialLoginAuthErrorMarketingLp' event (evid: 117)
 *
 * Event description: event is generated when social authentication failed and the component is within a marketing LP. The error is sent when a user who previously signed up regularly tried to login via social
 *
 * @param {socialLoginAuthErrorMarketingLpParams} params - The parameters for this event
 * @property {string} socialNetwork - social network type
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} reason - a reason of error from social login provider/internal
 * @property {number} errorCode - error code
 * @property {string} ver - marketing needs
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<socialLoginAuthErrorMarketingLpParams>} LogObject<socialLoginAuthErrorMarketingLpParams>
 */
export function socialLoginAuthErrorMarketingLp(params) {
    return { evid: 117, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountRecoveryAlert' event (evid: 119)
 *
 * Event description: Alert shown to the user when recovery process is not successful
 *
 * @param {accountRecoveryAlertParams} params - The parameters for this event
 * @property {string} name - name of modal
 * @property {string} context - page on which the alert is shown
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop, mobile
 * @return {LogObject<accountRecoveryAlertParams>} LogObject<accountRecoveryAlertParams>
 */
export function accountRecoveryAlert(params) {
    return { evid: 119, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'signupSubmit' event (evid: 120)
 *
 * Event description: event is generated when signup form is submitted to server
 *
 * @param {signupSubmitParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} version - old/new login
 * @property {string} ver - marketing needs
 * @property {GUID} ldSessionID - ld_session_id
 * @property {boolean} formValid - from_valid
 * @property {string} view - origin_view
 * @return {LogObject<signupSubmitParams>} LogObject<signupSubmitParams>
 */
export function signupSubmit(params) {
    return { evid: 120, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'signUpTryRequestSentToServer' event (evid: 121)
 *
 * Event description: sign-up try : request sent to server.
 *
 * @param {signUpTryRequestSentToServerParams} params - The parameters for this event
 * @property {boolean} force - if we use the confusion mechanism-true
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<signUpTryRequestSentToServerParams>} LogObject<signUpTryRequestSentToServerParams>
 */
export function signUpTryRequestSentToServer(params) {
    return { evid: 121, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountRecoveryRedirect' event (evid: 124)
 *
 * Event description: user is redirected when enters to a middle page in the recovery process (e.g.: using a bookmark)
 *
 * @param {accountRecoveryRedirectParams} params - The parameters for this event
 * @property {string} contextTo - redirect to
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} contextFrom - redirect from
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop, mobile
 * @return {LogObject<accountRecoveryRedirectParams>} LogObject<accountRecoveryRedirectParams>
 */
export function accountRecoveryRedirect(params) {
    return { evid: 124, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountRecoveryClickNextOnMainPage' event (evid: 125)
 *
 * Event description: event is generated when a user clicks next on "How Can We Help?" page.
 *
 * @param {accountRecoveryClickNextOnMainPageParams} params - The parameters for this event
 * @property {string} name - flow chosen: {reset my password, find my login email, reset my account details, other login questions}
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} displayVersion - old/new
 * @property {GUID} ldSessionID - session id
 * @property {string} view - desktop, mobile
 * @return {LogObject<accountRecoveryClickNextOnMainPageParams>} LogObject<accountRecoveryClickNextOnMainPageParams>
 */
export function accountRecoveryClickNextOnMainPage(params) {
    return { evid: 125, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountRecoveryErrorOnMandatoryField' event (evid: 126)
 *
 * Event description: event is generated each time the user inserts details with wrong format (e.g. email, website)
 *
 * @param {accountRecoveryErrorOnMandatoryFieldParams} params - The parameters for this event
 * @property {string} name - field name
 * @property {string} description - error text
 * @property {string} context - the context of the login/sign-up/forgot-password form
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<accountRecoveryErrorOnMandatoryFieldParams>} LogObject<accountRecoveryErrorOnMandatoryFieldParams>
 */
export function accountRecoveryErrorOnMandatoryField(params) {
    return { evid: 126, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'emailDoesnTExistMessageDisplayed' event (evid: 127)
 *
 * Event description: user tried to login or reset password with email that doesn't exist
 *
 * @param {emailDoesnTExistMessageDisplayedParams} params - The parameters for this event
 * @property {string} context - login/forgot-password
 * @property {string} __cookies_prefix___ga - deprecated
 * @property {GUID} client_id - client_id
 * @property {string} version - old/new login
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - deprecated
 * @return {LogObject<emailDoesnTExistMessageDisplayedParams>} LogObject<emailDoesnTExistMessageDisplayedParams>
 */
export function emailDoesnTExistMessageDisplayed(params) {
    return { evid: 127, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'findLoginEmailSmsIsSent' event (evid: 128)
 *
 * Event description: event is generated each time a sms is sent (server)
 *
 * @param {findLoginEmailSmsIsSentParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - origin_view
 * @return {LogObject<findLoginEmailSmsIsSentParams>} LogObject<findLoginEmailSmsIsSentParams>
 */
export function findLoginEmailSmsIsSent(params) {
    return { evid: 128, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'proceedingToPasswordClickContinue' event (evid: 129)
 *
 * Event description: login redesign - click to move from "enter your email" to "enter your password"
 *
 * @param {proceedingToPasswordClickContinueParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {string} source_type - signup / login
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<proceedingToPasswordClickContinueParams>} LogObject<proceedingToPasswordClickContinueParams>
 */
export function proceedingToPasswordClickContinue(params) {
    return { evid: 129, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'forgotPasswordSubmit' event (evid: 131)
 *
 * Event description: event is generated when forgot password form is submitted to server
 *
 * @param {forgotPasswordSubmitParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {string} version - old/new login
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {boolean} formValid - yes for invalid form
 * @property {string} view - desktop,mobile..
 * @return {LogObject<forgotPasswordSubmitParams>} LogObject<forgotPasswordSubmitParams>
 */
export function forgotPasswordSubmit(params) {
    return { evid: 131, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountRecoveryRequestSubmit' event (evid: 134)
 *
 * Event description: event is generated when a user submits one of the requests in account recovery flow.
 * name of request: {contact-us, reset-free (reset account for free site) ,reset-premium...}
 *
 * @param {accountRecoveryRequestSubmitParams} params - The parameters for this event
 * @property {string} name - what was submitted: {contact-us,reset-free,reset-premium...}
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryRequestSubmitParams>} LogObject<accountRecoveryRequestSubmitParams>
 */
export function accountRecoveryRequestSubmit(params) {
    return { evid: 134, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'proceedingToPasswordError' event (evid: 135)
 *
 * Event description: could not move from mail to password (login redesign)
 *
 * @param {proceedingToPasswordErrorParams} params - The parameters for this event
 * @property {string} errorMessage - error message
 * @property {string} __cookies_prefix___ga - ga
 * @property {string} source_type - signup / login
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<proceedingToPasswordErrorParams>} LogObject<proceedingToPasswordErrorParams>
 */
export function proceedingToPasswordError(params) {
    return { evid: 135, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnForgotButton' event (evid: 136)
 *
 * Event description: click on "forgot" button in the login funnel
 *
 * @param {clickOnForgotButtonParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} origin - differentiate by button source: email / login / old version / etc...
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<clickOnForgotButtonParams>} LogObject<clickOnForgotButtonParams>
 */
export function clickOnForgotButton(params) {
    return { evid: 136, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewPreIntroScreen' event (evid: 137)
 *
 * Event description: User visits the screen between signup and start intro. The purpose of this screen is to help acquisition to segment users who cannot track due to new cookies policies.
 *
 * @param {viewPreIntroScreenParams} params - The parameters for this event
 * @property {string} screenName - screen name
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<viewPreIntroScreenParams>} LogObject<viewPreIntroScreenParams>
 */
export function viewPreIntroScreen(params) {
    return { evid: 137, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'socialDebug' event (evid: 138)
 *
 * Event description: social debug
 *
 * @param {socialDebugParams} params - The parameters for this event
 * @property {string} step - debug step name
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<socialDebugParams>} LogObject<socialDebugParams>
 */
export function socialDebug(params) {
    return { evid: 138, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'socialLoginEarlyClick' event (evid: 139)
 *
 * Event description: event is generated when social login button is clicked before social sdk finished downloading
 *
 * @param {socialLoginEarlyClickParams} params - The parameters for this event
 * @property {string} socialNetwork - social_network
 * @property {string} context - context
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} version - old/new login
 * @property {string} ver - marketing needs
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<socialLoginEarlyClickParams>} LogObject<socialLoginEarlyClickParams>
 */
export function socialLoginEarlyClick(params) {
    return { evid: 139, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'socialLoginClicked' event (evid: 140)
 *
 * Event description: event is generated when social login button is clicked
 *
 * @param {socialLoginClickedParams} params - The parameters for this event
 * @property {string} socialNetwork - 'google', 'facebook'
 * @property {string} context - context
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} version - old/new login
 * @property {string} ver - marketing needs
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} type - 'social'
 * @property {string} view - origin_view
 * @return {LogObject<socialLoginClickedParams>} LogObject<socialLoginClickedParams>
 */
export function socialLoginClicked(params) {
    return { evid: 140, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'socialAuthError' event (evid: 141)
 *
 * Event description: event is generated when social authentication failed
 *
 * @param {socialAuthErrorParams} params - The parameters for this event
 * @property {string} state - state
 * @property {string} socialNetwork - social_network
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} reason - reason
 * @property {string} version - old/new login
 * @property {string} ver - marketing needs
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<socialAuthErrorParams>} LogObject<socialAuthErrorParams>
 */
export function socialAuthError(params) {
    return { evid: 141, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'socialAuthSuccess' event (evid: 142)
 *
 * Event description: event is generated when social authentication succeeded
 *
 * @param {socialAuthSuccessParams} params - The parameters for this event
 * @property {string} state - only for google via redirect from gdomain / googleOT / googleButton
 * @property {string} socialNetwork - google, facebook
 * @property {string} context - login, signup, gdomain
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {boolean} interactive - is_consent_page
 * @property {string} version - old/new login
 * @property {string} ver - marketing needs
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<socialAuthSuccessParams>} LogObject<socialAuthSuccessParams>
 */
export function socialAuthSuccess(params) {
    return { evid: 142, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'verifyAccountSubmit' event (evid: 143)
 *
 * Event description: event is generated when verify account form is submitted to server
 *
 * @param {verifyAccountSubmitParams} params - The parameters for this event
 * @property {string} socialNetwork - social network type
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {boolean} formValid - yes for invalid form
 * @property {string} view - desktop,mobile..
 * @return {LogObject<verifyAccountSubmitParams>} LogObject<verifyAccountSubmitParams>
 */
export function verifyAccountSubmit(params) {
    return { evid: 143, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getEmailSubmit' event (evid: 149)
 *
 * Event description: event is generated when get email form is submitted to server
 *
 * @param {getEmailSubmitParams} params - The parameters for this event
 * @property {string} socialNetwork - social_network
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} ver - marketing needs
 * @property {GUID} ldSessionID - ld_session_id
 * @property {boolean} formValid - form_valid
 * @property {string} view - origin_view
 * @return {LogObject<getEmailSubmitParams>} LogObject<getEmailSubmitParams>
 */
export function getEmailSubmit(params) {
    return { evid: 149, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationVerifyClick' event (evid: 150)
 *
 * Event description: a user that enabled 2-factor authentication clicks on 'verify' after entering the code sent to his mobile, during the login/step-up process.
 *
 * @param {loginTwoFactorAuthenticationVerifyClickParams} params - The parameters for this event
 * @property {string} tfa_type - "login" / "step-up"
 * @property {boolean} remember_this_device - true/false - did the user check the box 'remember this device for 30 days'
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} flow_type - email/phone
 * @property {string} view - origin_view
 * @return {LogObject<loginTwoFactorAuthenticationVerifyClickParams>} LogObject<loginTwoFactorAuthenticationVerifyClickParams>
 */
export function loginTwoFactorAuthenticationVerifyClick(params) {
    return { evid: 150, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationResendCodeClick' event (evid: 151)
 *
 * Event description: a user that enabled 2-factor authentication clicks on 'resend code' in the 'check your phone' dialog box, during the login/step-up process.
 *
 * @param {loginTwoFactorAuthenticationResendCodeClickParams} params - The parameters for this event
 * @property {string} tfa_type - "login" / "step-up"
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} flow_type - email/sms
 * @property {string} view - origin_view
 * @property {string} reason - Reason this page was loaded (Login\ LFND model)
 * @return {LogObject<loginTwoFactorAuthenticationResendCodeClickParams>} LogObject<loginTwoFactorAuthenticationResendCodeClickParams>
 */
export function loginTwoFactorAuthenticationResendCodeClick(params) {
    return { evid: 151, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationLostPhoneAccessClick' event (evid: 152)
 *
 * Event description: a user that enabled 2-factor authentication clicks on 'lost access to your phone' in the 'check your phone' dialog box, during the login process.
 *
 * @param {loginTwoFactorAuthenticationLostPhoneAccessClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} flow_type - phone/email/totp
 * @property {string} view - origin_view
 * @return {LogObject<loginTwoFactorAuthenticationLostPhoneAccessClickParams>} LogObject<loginTwoFactorAuthenticationLostPhoneAccessClickParams>
 */
export function loginTwoFactorAuthenticationLostPhoneAccessClick(params) {
    return { evid: 152, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationVerifySuccess' event (evid: 153)
 *
 * Event description: a user successfully verified a correct code during 2-factor authentication login/step-up
 *
 * @param {loginTwoFactorAuthenticationVerifySuccessParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} flow_type - email/phone
 * @property {string} view - origin_view
 * @property {string} reason - Reason this page was loaded (Login\ LFND model)
 * @return {LogObject<loginTwoFactorAuthenticationVerifySuccessParams>} LogObject<loginTwoFactorAuthenticationVerifySuccessParams>
 */
export function loginTwoFactorAuthenticationVerifySuccess(params) {
    return { evid: 153, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationVerifyFail' event (evid: 154)
 *
 * Event description: the verification failed due to incorrect code entered by the user, during 2-factor authentication login
 *
 * @param {loginTwoFactorAuthenticationVerifyFailParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} flow_type - email/sms
 * @property {string} view - origin_view
 * @property {string} reason - Reason this page was loaded (Login\ LFND model)
 * @return {LogObject<loginTwoFactorAuthenticationVerifyFailParams>} LogObject<loginTwoFactorAuthenticationVerifyFailParams>
 */
export function loginTwoFactorAuthenticationVerifyFail(params) {
    return { evid: 154, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginClickOnBack' event (evid: 155)
 *
 * Event description: The user clicks on 'back' during the login process
 *
 * @param {loginClickOnBackParams} params - The parameters for this event
 * @property {string} step_name - in which step the user clicked 'back' (enter password/verify code)
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} flow_type - phone/email/totp
 * @property {string} view - origin_view
 * @return {LogObject<loginClickOnBackParams>} LogObject<loginClickOnBackParams>
 */
export function loginClickOnBack(params) {
    return { evid: 155, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationPageLoad' event (evid: 156)
 *
 * Event description: Page load of 2fa screen (where the user is asked to enter the verification code)
 *
 * @param {loginTwoFactorAuthenticationPageLoadParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} origin - where the user was directed to 2FA from: regular login- 'login', or 'deviant art'
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} flow_type - email/sms
 * @property {string} view - origin_view
 * @property {string} reason - Reason this page was loaded (Login\ LFND model)
 * @return {LogObject<loginTwoFactorAuthenticationPageLoadParams>} LogObject<loginTwoFactorAuthenticationPageLoadParams>
 */
export function loginTwoFactorAuthenticationPageLoad(params) {
    return { evid: 156, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneEnterEmailModalLoad' event (evid: 157)
 *
 * Event description: The modal of "enter your email address you lost access to"  loaded after the user chose "can't access my login email" from the account recovery options
 *
 * @param {accountRecoveryByPhoneEnterEmailModalLoadParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneEnterEmailModalLoadParams>} LogObject<accountRecoveryByPhoneEnterEmailModalLoadParams>
 */
export function accountRecoveryByPhoneEnterEmailModalLoad(params) {
    return { evid: 157, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneClickNextAfterEnteringEmail' event (evid: 158)
 *
 * Event description: The user clicked on next after entering email address in the phone recovery flow
 *
 * @param {accountRecoveryByPhoneClickNextAfterEnteringEmailParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneClickNextAfterEnteringEmailParams>} LogObject<accountRecoveryByPhoneClickNextAfterEnteringEmailParams>
 */
export function accountRecoveryByPhoneClickNextAfterEnteringEmail(params) {
    return { evid: 158, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneResetPasswordOptionsModalLoad' event (evid: 159)
 *
 * Event description: The modal with optional ways to reset password was loaded
 *
 * @param {accountRecoveryByPhoneResetPasswordOptionsModalLoadParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneResetPasswordOptionsModalLoadParams>} LogObject<accountRecoveryByPhoneResetPasswordOptionsModalLoadParams>
 */
export function accountRecoveryByPhoneResetPasswordOptionsModalLoad(params) {
    return { evid: 159, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneResetPasswordOptionChosen' event (evid: 160)
 *
 * Event description: The event is sent when the user clicks on "next" after choosing an option to reset password: link to recovery email (if exists), code to the recovery phone number (if exists), or neither
 *
 * @param {accountRecoveryByPhoneResetPasswordOptionChosenParams} params - The parameters for this event
 * @property {string} chosen_option - recovery email/recovery phone/no access
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneResetPasswordOptionChosenParams>} LogObject<accountRecoveryByPhoneResetPasswordOptionChosenParams>
 */
export function accountRecoveryByPhoneResetPasswordOptionChosen(params) {
    return { evid: 160, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneVerifyCodePageLoad' event (evid: 161)
 *
 * Event description: Load of 'check your phone' modal during account recovery by phone flow
 *
 * @param {accountRecoveryByPhoneVerifyCodePageLoadParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneVerifyCodePageLoadParams>} LogObject<accountRecoveryByPhoneVerifyCodePageLoadParams>
 */
export function accountRecoveryByPhoneVerifyCodePageLoad(params) {
    return { evid: 161, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneVerifyCodeClick' event (evid: 162)
 *
 * Event description: The user clicked on 'verify' after entering the code sent to his phone, during  account recovery
 *
 * @param {accountRecoveryByPhoneVerifyCodeClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneVerifyCodeClickParams>} LogObject<accountRecoveryByPhoneVerifyCodeClickParams>
 */
export function accountRecoveryByPhoneVerifyCodeClick(params) {
    return { evid: 162, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneResendCodeClick' event (evid: 163)
 *
 * Event description: The user clicked on 'resend code' during  account recovery by phone
 *
 * @param {accountRecoveryByPhoneResendCodeClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneResendCodeClickParams>} LogObject<accountRecoveryByPhoneResendCodeClickParams>
 */
export function accountRecoveryByPhoneResendCodeClick(params) {
    return { evid: 163, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneLostPhoneAccessClick' event (evid: 164)
 *
 * Event description: The user clicked on 'lost access to your phone?' during  account recovery by phone
 *
 * @param {accountRecoveryByPhoneLostPhoneAccessClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneLostPhoneAccessClickParams>} LogObject<accountRecoveryByPhoneLostPhoneAccessClickParams>
 */
export function accountRecoveryByPhoneLostPhoneAccessClick(params) {
    return { evid: 164, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneCodeVerifiedSuccessfully' event (evid: 165)
 *
 * Event description: The user clicked on 'lost access to your phone?' during  account recovery by phone
 *
 * @param {accountRecoveryByPhoneCodeVerifiedSuccessfullyParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneCodeVerifiedSuccessfullyParams>} LogObject<accountRecoveryByPhoneCodeVerifiedSuccessfullyParams>
 */
export function accountRecoveryByPhoneCodeVerifiedSuccessfully(params) {
    return { evid: 165, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneCodeVerificationFailed' event (evid: 166)
 *
 * Event description: The user clicked on 'lost access to your phone?' during  account recovery by phone
 *
 * @param {accountRecoveryByPhoneCodeVerificationFailedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneCodeVerificationFailedParams>} LogObject<accountRecoveryByPhoneCodeVerificationFailedParams>
 */
export function accountRecoveryByPhoneCodeVerificationFailed(params) {
    return { evid: 166, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneSelectNewPasswordModalLoad' event (evid: 167)
 *
 * Event description: Load of 'select new password' modal
 *
 * @param {accountRecoveryByPhoneSelectNewPasswordModalLoadParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneSelectNewPasswordModalLoadParams>} LogObject<accountRecoveryByPhoneSelectNewPasswordModalLoadParams>
 */
export function accountRecoveryByPhoneSelectNewPasswordModalLoad(params) {
    return { evid: 167, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneSaveNewPasswordClick' event (evid: 168)
 *
 * Event description: The user clicked on "save new password" during account recovery by phone
 *
 * @param {accountRecoveryByPhoneSaveNewPasswordClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneSaveNewPasswordClickParams>} LogObject<accountRecoveryByPhoneSaveNewPasswordClickParams>
 */
export function accountRecoveryByPhoneSaveNewPasswordClick(params) {
    return { evid: 168, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountRecoveryByPhoneSuccessScreenSelection' event (evid: 169)
 *
 * Event description: The user selected one of two options in the success screen after saving a new password -  go to account settings/go to dashboard, or closed the modal
 *
 * @param {accountRecoveryByPhoneSuccessScreenSelectionParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} selection - account settings/dashboard/close
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<accountRecoveryByPhoneSuccessScreenSelectionParams>} LogObject<accountRecoveryByPhoneSuccessScreenSelectionParams>
 */
export function accountRecoveryByPhoneSuccessScreenSelection(params) {
    return { evid: 169, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'answerPreIntroScreen' event (evid: 170)
 *
 * Event description: Users answers the pre intro screen
 *
 * @param {answerPreIntroScreenParams} params - The parameters for this event
 * @property {string} screenName - screen name
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} answer - answer
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<answerPreIntroScreenParams>} LogObject<answerPreIntroScreenParams>
 */
export function answerPreIntroScreen(params) {
    return { evid: 170, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'signUpPasswordStrengthIndicator' event (evid: 171)
 *
 * Event description: this event contains the indicators of each password saved during a sign up
 *
 * @param {signUpPasswordStrengthIndicatorParams} params - The parameters for this event
 * @property {GUID} uuid - user id
 * @property {string} __cookies_prefix___ga - ga
 * @property {string} strength - Numeric score
 * @property {GUID} client_id - client_id
 * @property {string} origin - where the password was choswn: sign up/reset password/account settings
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<signUpPasswordStrengthIndicatorParams>} LogObject<signUpPasswordStrengthIndicatorParams>
 */
export function signUpPasswordStrengthIndicator(params) {
    return { evid: 171, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationSmsErrorDisplayed' event (evid: 172)
 *
 * Event description: Sent when we show users an error message saying we're having trouble sending the 2FA verification code via sms, and suggest them to get it via email
 *
 * @param {loginTwoFactorAuthenticationSmsErrorDisplayedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<loginTwoFactorAuthenticationSmsErrorDisplayedParams>} LogObject<loginTwoFactorAuthenticationSmsErrorDisplayedParams>
 */
export function loginTwoFactorAuthenticationSmsErrorDisplayed(params) {
    return { evid: 172, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationClickToGet2FaCodeViaEmail' event (evid: 173)
 *
 * Event description: Sent when the user clicks on "click here to get it via email" in the error message we show, that says we're having trouble sending the code via sms
 *
 * @param {loginTwoFactorAuthenticationClickToGet2FaCodeViaEmailParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<loginTwoFactorAuthenticationClickToGet2FaCodeViaEmailParams>} LogObject<loginTwoFactorAuthenticationClickToGet2FaCodeViaEmailParams>
 */
export function loginTwoFactorAuthenticationClickToGet2FaCodeViaEmail(params) {
    return { evid: 173, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'emailLoginInteractionData' event (evid: 174)
 *
 * Event description: This event is for collecting data regarding email-login interaction being above 100%
 *
 * @param {emailLoginInteractionDataParams} params - The parameters for this event
 * @property {string} timestamp_date - the time the interaction event sent in date format
 * @property {number} timestamp_ms - the time the interaction event sent in ms
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} error_info - the error, in case occurred
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} type - start/end-success/end-error
 * @property {string} email_hash - the use's email hashed
 * @property {number} error_code - the error status code, in case occurred
 * @property {string} view - origin_view
 * @return {LogObject<emailLoginInteractionDataParams>} LogObject<emailLoginInteractionDataParams>
 */
export function emailLoginInteractionData(params) {
    return { evid: 174, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationSendCodeByEmailClickSrc6Evid175' event (evid: 175)
 *
 * Event description: The user clicked on 'send code by phone' in the 2fa login screen
 *
 * @param {loginTwoFactorAuthenticationSendCodeByEmailClickSrc6Evid175Params} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} origin - app/email (what flow type the user was in when he clicked on send code by phone)
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<loginTwoFactorAuthenticationSendCodeByEmailClickSrc6Evid175Params>} LogObject<loginTwoFactorAuthenticationSendCodeByEmailClickSrc6Evid175Params>
 */
export function loginTwoFactorAuthenticationSendCodeByEmailClickSrc6Evid175(params) {
    return { evid: 175, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationSendCodeByPhoneClick' event (evid: 176)
 *
 * Event description: The user clicked on 'send code by email' in the 2fa login screen
 *
 * @param {loginTwoFactorAuthenticationSendCodeByPhoneClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} origin - app/phone (which flow the user was in when he clicked on send code by email)
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<loginTwoFactorAuthenticationSendCodeByPhoneClickParams>} LogObject<loginTwoFactorAuthenticationSendCodeByPhoneClickParams>
 */
export function loginTwoFactorAuthenticationSendCodeByPhoneClick(params) {
    return { evid: 176, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSocialLoginErrorInIncognito' event (evid: 177)
 *
 * Event description: The user tried to login with Google in chrome incognito mode, and received an error message. Google doesn’t allow 3rd party cookie in Incognito mode in recent Chrome versions (from ~June 2020).
 *
 * @param {loginSocialLoginErrorInIncognitoParams} params - The parameters for this event
 * @property {string} socialNetwork - social_network
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<loginSocialLoginErrorInIncognitoParams>} LogObject<loginSocialLoginErrorInIncognitoParams>
 */
export function loginSocialLoginErrorInIncognito(params) {
    return { evid: 177, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationInternalBug' event (evid: 178)
 *
 * Event description: Login - Two Factor Authentication - Internal Bug
 *
 * @param {loginTwoFactorAuthenticationInternalBugParams} params - The parameters for this event
 * @property {string} timestamp_date - timestamp_date
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ldSessionID
 * @property {string} type - type
 * @property {string} email_hash - email_hash
 * @property {string} view - origin_view
 * @property {number} counter_value - counter_value
 * @return {LogObject<loginTwoFactorAuthenticationInternalBugParams>} LogObject<loginTwoFactorAuthenticationInternalBugParams>
 */
export function loginTwoFactorAuthenticationInternalBug(params) {
    return { evid: 178, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationLoginWithAuthenticatorAppClick' event (evid: 179)
 *
 * Event description: The user clicked on 'login with authenticator app' in the 2fa login screen, while in the email/phone flow
 *
 * @param {loginTwoFactorAuthenticationLoginWithAuthenticatorAppClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} origin - origin
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<loginTwoFactorAuthenticationLoginWithAuthenticatorAppClickParams>} LogObject<loginTwoFactorAuthenticationLoginWithAuthenticatorAppClickParams>
 */
export function loginTwoFactorAuthenticationLoginWithAuthenticatorAppClick(params) {
    return { evid: 179, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginPageClickOnLogInWithSso' event (evid: 180)
 *
 * Event description: Login Page - Click on Log in with SSO.
 *
 * @param {loginPageClickOnLogInWithSsoParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<loginPageClickOnLogInWithSsoParams>} LogObject<loginPageClickOnLogInWithSsoParams>
 */
export function loginPageClickOnLogInWithSso(params) {
    return { evid: 180, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixSsoLoginPageClickOnContinueAfterEnteringEmail' event (evid: 181)
 *
 * Event description: In the Log in with SSO page, after clicking "Log in with SSO" in the regular Wix login page, the user enters their Email address and clicks on "Continue".
 *
 * @param {wixSsoLoginPageClickOnContinueAfterEnteringEmailParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<wixSsoLoginPageClickOnContinueAfterEnteringEmailParams>} LogObject<wixSsoLoginPageClickOnContinueAfterEnteringEmailParams>
 */
export function wixSsoLoginPageClickOnContinueAfterEnteringEmail(params) {
    return { evid: 181, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixSsoLoginPageClickOnBack' event (evid: 182)
 *
 * Event description: In the Log in with SSO page, after clicking "Log in with SSO" in the regular Wix login page, the user clicks on 'Back'
 *
 * @param {wixSsoLoginPageClickOnBackParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<wixSsoLoginPageClickOnBackParams>} LogObject<wixSsoLoginPageClickOnBackParams>
 */
export function wixSsoLoginPageClickOnBack(params) {
    return { evid: 182, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ssoLoginRequestClickToConnectWithSsoYellowButton' event (evid: 183)
 *
 * Event description: SSO Login Request - Click to Connect with SSO (Yellow Button).
 *
 * @param {ssoLoginRequestClickToConnectWithSsoYellowButtonParams} params - The parameters for this event
 * @property {GUID} state - similar to session id for SSO
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - user_id
 * @property {GUID} account_id - account id of the channel account that enabled SSO
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<ssoLoginRequestClickToConnectWithSsoYellowButtonParams>} LogObject<ssoLoginRequestClickToConnectWithSsoYellowButtonParams>
 */
export function ssoLoginRequestClickToConnectWithSsoYellowButton(params) {
    return { evid: 183, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleOneTapModalLoad' event (evid: 186)
 *
 * Event description: Google One Tap Modal Load (in one of Wix's landing pages, while the user is logged in to his Google account in the same browser)
 *
 * @param {googleOneTapModalLoadParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<googleOneTapModalLoadParams>} LogObject<googleOneTapModalLoadParams>
 */
export function googleOneTapModalLoad(params) {
    return { evid: 186, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginAccountSelectorComponentLoad' event (evid: 188)
 *
 * Event description: A user with multiple accounts tried to log in and saw the account selector component, allowing him to select one of his accounts.
 *
 * @param {loginAccountSelectorComponentLoadParams} params - The parameters for this event
 * @property {string} account_ids - an array with all the account ids available for selection. Coupled with parent accounts in the same order.
 * @property {string} context - login/reset password
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} parent_account_ids - an array with all the parent account ids of the accounts in the selection. If no parent account exists - the value will be null
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<loginAccountSelectorComponentLoadParams>} LogObject<loginAccountSelectorComponentLoadParams>
 */
export function loginAccountSelectorComponentLoad(params) {
    return { evid: 188, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginAccountSelectorAccountSelected' event (evid: 189)
 *
 * Event description: The user selected one of the accounts available in account selector
 *
 * @param {loginAccountSelectorAccountSelectedParams} params - The parameters for this event
 * @property {GUID} parent_account_id - parent account of the selected account id
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} selected_account_id - the selected account id
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<loginAccountSelectorAccountSelectedParams>} LogObject<loginAccountSelectorAccountSelectedParams>
 */
export function loginAccountSelectorAccountSelected(params) {
    return { evid: 189, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationLoginWithOwnerAppClick' event (evid: 190)
 *
 * Event description: a user that enabled 2-factor authentication clicks on Login with Owner App' in the 'Enter Code' dialog box, during the login process.
 *
 * @param {loginTwoFactorAuthenticationLoginWithOwnerAppClickParams} params - The parameters for this event
 * @property {string} flow_type - flow_type
 * @property {string} view - origin_view
 * @return {LogObject<loginTwoFactorAuthenticationLoginWithOwnerAppClickParams>} LogObject<loginTwoFactorAuthenticationLoginWithOwnerAppClickParams>
 */
export function loginTwoFactorAuthenticationLoginWithOwnerAppClick(params) {
    return { evid: 190, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'showModuleSrc6Evid200' event (evid: 200)
 *
 * Event description: Identity module and it's pages were shown (2-step verification, password etc)
 *
 * @param {showModuleSrc6Evid200Params} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {GUID} userGuid - user_guid
 * @property {string} placement - The place user see this module (bm/wix-checking, ecom etc)
 * @property {string} context - A bunch of pages that will be shown (password, 2f auth etc)
 * @property {string} step - exact step (phone, auth code etc)
 * @property {GUID} ldSessionID - Session ID
 * @return {LogObject<showModuleSrc6Evid200Params>} LogObject<showModuleSrc6Evid200Params>
 */
export function showModuleSrc6Evid200(params) {
    return { evid: 200, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'buttonClickedInModuleSrc6Evid201' event (evid: 201)
 *
 * Event description: Click the button or link inside Identity module or it's pages
 *
 * @param {buttonClickedInModuleSrc6Evid201Params} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {GUID} userGuid - uuid
 * @property {string} placement - The place user see this module (bm/wix-checking, ecom etc)
 * @property {string} context - A bunch of pages that will be shown (password, 2f auth etc)
 * @property {string} step - exact step (phone, auth code etc)
 * @property {string} ldSessionID - Session ID
 * @property {string} ctaName - Name of button or link was clicked
 * @return {LogObject<buttonClickedInModuleSrc6Evid201Params>} LogObject<buttonClickedInModuleSrc6Evid201Params>
 */
export function buttonClickedInModuleSrc6Evid201(params) {
    return { evid: 201, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginPageOnStart' event (evid: 300)
 *
 * Event description: event is generated when login dialog starts
 *
 * @param {loginPageOnStartParams} params - The parameters for this event
 * @property {string} context - context
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {number} screen_width - Width of client device screen
 * @property {number} avail_width - available window width
 * @property {string} origin - the origin of the request (for example, on home-page there are 3 possible origins, my-account link, start now button and login/signnup link
 * @property {string} context_button - Which button the user clicked before getting this page
 * @property {string} ver - ver
 * @property {string} context_type - Context type, usually will happen when the user has UIDX cookie (for example - 'Multi account'/sso')
 * @property {number} screen_height - Height of client device screen
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {number} avail_height - available window height
 * @property {string} referrer_context - which experience the users was supposed to get? (signup\login)
 * @property {string} view - desktop,mobile..
 * @property {string} referrer - Context referrer (LFND\account recovery)
 * @return {LogObject<loginPageOnStartParams>} LogObject<loginPageOnStartParams>
 */
export function loginPageOnStart(params) {
    return { evid: 300, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginDialogInitComplete' event (evid: 302)
 *
 * Event description: login dialog -> INIT_COMPLETE.
 *
 * @param {loginDialogInitCompleteParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<loginDialogInitCompleteParams>} LogObject<loginDialogInitCompleteParams>
 */
export function loginDialogInitComplete(params) {
    return { evid: 302, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'onClose' event (evid: 303)
 *
 * Event description: event is generated when user clicks big X button
 *
 * @param {onCloseParams} params - The parameters for this event
 * @property {string} context - the context of the login/sign-up/forgot-password form
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {string} version - old/new login
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<onCloseParams>} LogObject<onCloseParams>
 */
export function onClose(params) {
    return { evid: 303, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'errorEventNotClosingInteraction' event (evid: 305)
 *
 * Event description: A detailed error event, sent when the interaction is not closed
 *
 * @param {errorEventNotClosingInteractionParams} params - The parameters for this event
 * @property {string} ga - ga
 * @property {string} context - context
 * @property {string} interaction_name - interaction_name
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {string} error - error received (text)
 * @property {string} origin - the origin of the request (for example, on home-page there are 3 possible origins, my-account link, start now button and login/signnup link
 * @property {string} request_id - request_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} error_code - error_code (number)
 * @property {string} view - origin_view
 * @return {LogObject<errorEventNotClosingInteractionParams>} LogObject<errorEventNotClosingInteractionParams>
 */
export function errorEventNotClosingInteraction(params) {
    return { evid: 305, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginDialogFullStoryReady' event (evid: 400)
 *
 * Event description: event is generated (if and) when fullstory recording start
 *
 * @param {loginDialogFullStoryReadyParams} params - The parameters for this event
 * @property {string} fullStoryUrl - full story url
 * @property {string} __cookies_prefix___ga - _ga cookie
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop,mobile..
 * @return {LogObject<loginDialogFullStoryReadyParams>} LogObject<loginDialogFullStoryReadyParams>
 */
export function loginDialogFullStoryReady(params) {
    return { evid: 400, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginTwoFactorAuthenticationCallMeCodeClick' event (evid: 401)
 *
 * Event description: a user that enabled 2-factor authentication clicks on 'call me' during the login / step-up process.
 *
 * @param {loginTwoFactorAuthenticationCallMeCodeClickParams} params - The parameters for this event
 * @property {string} tfa_type - "login" / "step-up"
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - session ID
 * @property {string} view - desktop / mobile
 * @return {LogObject<loginTwoFactorAuthenticationCallMeCodeClickParams>} LogObject<loginTwoFactorAuthenticationCallMeCodeClickParams>
 */
export function loginTwoFactorAuthenticationCallMeCodeClick(params) {
    return { evid: 401, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userClickedOnContinueWithEmail' event (evid: 402)
 *
 * Event description: When the user clicks on the "continue with email" button on the combined signup and login form
 *
 * @param {userClickedOnContinueWithEmailParams} params - The parameters for this event
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - ld_session_id
 * @property {string} view - origin_view
 * @return {LogObject<userClickedOnContinueWithEmailParams>} LogObject<userClickedOnContinueWithEmailParams>
 */
export function userClickedOnContinueWithEmail(params) {
    return { evid: 402, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSignupPageClickOnSwitchForm' event (evid: 403)
 *
 * Event description: event is generated when the user clicks on switch to signup form (on the login form) and when he clicks on switch to login (on the signup form).
 *
 * @param {loginSignupPageClickOnSwitchFormParams} params - The parameters for this event
 * @property {string} context - context of the page (signup\login)
 * @property {string} __cookies_prefix___ga - ga
 * @property {GUID} client_id - client_id
 * @property {GUID} ldSessionID - a unique guid for login flow
 * @property {string} view - desktop/mobile
 * @property {string} switch_to - What button the user clicked (switch to - login\signup)?
 * @return {LogObject<loginSignupPageClickOnSwitchFormParams>} LogObject<loginSignupPageClickOnSwitchFormParams>
 */
export function loginSignupPageClickOnSwitchForm(params) {
    return { evid: 403, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginOwnerApp2FaClickOnResendNotification' event (evid: 407)
 *
 * Event description: In the owner app two-factor authentication login, the user clicks on "Resend Notification",
 *
 * @param {loginOwnerApp2FaClickOnResendNotificationParams} params - The parameters for this event
 * @return {LogObject<loginOwnerApp2FaClickOnResendNotificationParams>} LogObject<loginOwnerApp2FaClickOnResendNotificationParams>
 */
export function loginOwnerApp2FaClickOnResendNotification(params) {
    return { evid: 407, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginOwnerApp2FaErrorTimeoutPageView' event (evid: 408)
 *
 * Event description: In the owner app two-factor authentication login, the user gets a "Timeout" notification, this should happen when the user didn't verify the user within a minute.
 *
 * @param {loginOwnerApp2FaErrorTimeoutPageViewParams} params - The parameters for this event
 * @return {LogObject<loginOwnerApp2FaErrorTimeoutPageViewParams>} LogObject<loginOwnerApp2FaErrorTimeoutPageViewParams>
 */
export function loginOwnerApp2FaErrorTimeoutPageView(params) {
    return { evid: 408, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginOwnerApp2FaLoginRequestDeniedPageView' event (evid: 409)
 *
 * Event description: In the owner app two-factor authentication login, the user is declined the login and presented with a "decline" screen.
 *
 * @param {loginOwnerApp2FaLoginRequestDeniedPageViewParams} params - The parameters for this event
 * @return {LogObject<loginOwnerApp2FaLoginRequestDeniedPageViewParams>} LogObject<loginOwnerApp2FaLoginRequestDeniedPageViewParams>
 */
export function loginOwnerApp2FaLoginRequestDeniedPageView(params) {
    return { evid: 409, src: 6, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sendingVerificationSms' event (evid: 3)
 *
 * Event description: Successful verification call to ping (after calling ping)
 * For methods that go through ping: PUSH, EMAIL, SMS/VOICE
 *
 * @param {sendingVerificationSmsParams} params - The parameters for this event
 * @property {string} method - email/phone
 * @property {string} errorMessage - null if no error
 * @property {string} hashed_phone - hashed_phone
 * @property {string} code - confirmation code
 * @property {boolean} status - true = sent successfully
 * @property {string} hashed_key - hashed value of verification method
 * @property {string} correlation_id - correlation_id (comes from ping)
 * @property {Url} app_url - app_url
 * @property {string} verification_id - verification_id
 * @return {LogObject<sendingVerificationSmsParams>} LogObject<sendingVerificationSmsParams>
 */
export function sendingVerificationSms(params) {
    return { evid: 3, src: 98, endpoint: '', params };
}
//# sourceMappingURL=index.js.map